import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const dominios = {
	state: {
		dominios: '',
		interesesCV: [],
		programas: [],
		titulacionesEmpresa: '',
		motivosRechazo: '',
		aniosForo: [],
		tiposNivelFormativoSNE: '',
		rangosDeCreditos: [],
		provinciasComplet: {
			"1": {
				"nameProvincia": "Álava / Araba",
				"idProvincia": "1",
				"localidades": {
					"6888": "AMURRIO",
					"6889": "ARAMAIO",
					"6890": "ARTZINIEGA",
					"6891": "ARMIÑON",
					"6892": "ARRAZUA-UBARRUNDIA",
					"6893": "ASPARRENA",
					"6894": "AYALA/AIARA",
					"6895": "BAÑOS DE EBRO/MAÑUETA",
					"6896": "BARRUNDIA",
					"6897": "BERANTEVILLA",
					"6898": "BERNEDO",
					"6899": "CAMPEZO/KANPEZU",
					"6900": "ZIGOITIA",
					"6901": "KRIPAN",
					"6902": "KUARTANGO",
					"6903": "ELBURGO/BURGELU",
					"6904": "ELCIEGO",
					"6905": "ELVILLAR/BILAR",
					"6906": "IRURAIZ-GAUNA",
					"6907": "LABASTIDA",
					"6908": "ALEGRIA-DULANTZI",
					"6909": "LAGRAN",
					"6910": "LAGUARDIA",
					"6911": "LANCIEGO/LANTZIEGO",
					"6912": "LAPUEBLA DE LABARCA",
					"6913": "LEZA",
					"6914": "LLODIO",
					"6915": "ARRAIA-MAEZTU",
					"6916": "MOREDA DE ALAVA",
					"6917": "NAVARIDAS",
					"6918": "OKONDO",
					"6919": "OYON/OION",
					"6920": "PEÑACERRADA-URIZAHARRA",
					"6921": "RIBERA ALTA",
					"6922": "RIBERA BAJA/ERRIBERA BEITIA",
					"6923": "AÑANA",
					"6924": "SALVATIERRA O AGURAIN",
					"6925": "SAMANIEGO",
					"6926": "SAN MILLAN/DONEMILIAGA",
					"6927": "URKABUSTAIZ",
					"6928": "VALDEGOVIA",
					"6929": "HARANA/VALLE DE ARANA",
					"6930": "VILLABUENA DE ALAVA/ESKUERNAGA",
					"6931": "LEGUTIANO",
					"6932": "VITORIA-GASTEIZ",
					"6933": "YECORA",
					"6934": "ZALDUONDO",
					"6935": "ZAMBRANA",
					"6936": "ZUIA",
					"6937": "IRUÑA OKA/IRUÑA DE OCA",
					"6938": "LANTARON"
				}
			},
			"2": {
				"nameProvincia": "Albacete",
				"idProvincia": "2",
				"localidades": {
					"6502": "CENIZATE",
					"6503": "CORRAL-RUBIO",
					"6939": "ABENGIBRE",
					"6940": "ALATOZ",
					"6941": "ALBACETE",
					"6942": "ALBATANA",
					"6943": "ALBOREA",
					"6944": "ALCADOZO",
					"6945": "ALCALA DEL JUCAR",
					"6946": "ALCARAZ",
					"6947": "ALMANSA",
					"6948": "ALPERA",
					"6949": "AYNA",
					"6950": "BALAZOTE",
					"6951": "BALSA DE VES",
					"6952": "BALLESTERO (EL)",
					"6953": "BARRAX",
					"6954": "BIENSERVIDA",
					"6955": "BOGARRA",
					"6956": "BONETE",
					"6957": "BONILLO (EL)",
					"6958": "CARCELEN",
					"6959": "CASAS DE JUAN NUÑEZ",
					"6960": "CASAS DE LAZARO",
					"6961": "CASAS DE VES",
					"6962": "CASAS-IBAÑEZ",
					"6963": "CAUDETE",
					"7627": "COTILLAS",
					"7628": "CHINCHILLA DE MONTE-ARAGON",
					"7629": "ELCHE DE LA SIERRA",
					"7630": "FEREZ",
					"7631": "FUENSANTA",
					"7632": "FUENTEALBILLA",
					"7633": "GINETA (LA)",
					"7634": "HELLIN",
					"7635": "HERRERA (LA)",
					"7636": "HOYA-GONZALO",
					"7637": "JORQUERA",
					"7638": "LEZUZA",
					"7639": "LIETOR",
					"7640": "MAHORA",
					"7641": "MASEGOSO",
					"7642": "MOLINICOS",
					"7643": "MONTALVOS",
					"7644": "MOTILLEJA",
					"7645": "MUNERA",
					"7646": "NAVAS DE JORQUERA",
					"7647": "NERPIO",
					"7648": "OSSA DE MONTIEL",
					"7649": "PEÑASCOSA",
					"7650": "PEÑAS DE SAN PEDRO",
					"7651": "PETROLA",
					"7652": "POVEDILLA",
					"7653": "POZO-LORENTE",
					"7654": "POZUELO",
					"7655": "RIOPAR",
					"7656": "ROBLEDO",
					"7657": "SALOBRE",
					"7658": "SAN PEDRO",
					"7659": "TARAZONA DE LA MANCHA",
					"7660": "TOBARRA",
					"7661": "VIANOS",
					"7662": "VILLA DE VES",
					"7663": "VILLAMALEA",
					"7664": "VILLAPALACIOS",
					"7665": "VILLARROBLEDO",
					"7666": "VILLATOYA",
					"7667": "VILLAVERDE DE GUADALIMAR",
					"7668": "VIVEROS",
					"7669": "YESTE",
					"8017": "FUENTE-ALAMO",
					"8018": "GOLOSALVO",
					"8019": "HIGUERUELA",
					"8020": "LETUR",
					"8021": "MADRIGUERAS",
					"8022": "MINAYA",
					"8023": "MONTEALEGRE DEL CASTILLO",
					"8024": "ONTUR",
					"8025": "PATERNA DEL MADERA",
					"8026": "POZOHONDO",
					"8027": "RECUEJA (LA)",
					"8028": "RODA (LA)",
					"8029": "SOCOVOS",
					"8030": "VALDEGANGA",
					"8031": "VILLALGORDO DEL JUCAR",
					"8032": "VILLAVALIENTE",
					"8033": "POZO CAÑADA"
				}
			},
			"3": {
				"nameProvincia": "Alicante / Alacant",
				"idProvincia": "3",
				"localidades": {
					"7670": "ADSUBIA",
					"7671": "AGOST",
					"7672": "AIGÜES",
					"7673": "ALBATERA",
					"7674": "ALCOCER DE PLANES",
					"7675": "ALCOY/ALCOI",
					"7676": "ALFAFARA",
					"7677": "ALGORFA",
					"7678": "ALGUEÑA",
					"7679": "ALICANTE/ALACANT",
					"7680": "ALMORADI",
					"7681": "ALQUERIA D'ASNAR (L')",
					"7682": "ALTEA",
					"7683": "BALONES",
					"7684": "BENASAU",
					"7685": "BENEIXAMA",
					"7686": "BENEJUZAR",
					"7687": "BENIARBEIG",
					"7688": "BENIARDA",
					"7689": "BENIGEMBLA",
					"7690": "BENIDOLEIG",
					"7691": "BENIFALLIM",
					"7692": "BENIFATO",
					"7693": "BENILLOBA",
					"7694": "BENILLUP",
					"7695": "BENIMARFULL",
					"7696": "BENIMASSOT",
					"7697": "BENISSA",
					"7698": "BENITACHELL/POBLE NOU DE BENIT",
					"7699": "BIGASTRO",
					"7700": "BUSOT",
					"7701": "CALPE/CALP",
					"7702": "CALLOSA DE SEGURA",
					"7703": "CAMPELLO (EL)",
					"7704": "CAMPO DE MIRRA/CAMP DE MIRRA (",
					"7705": "CAÑADA",
					"7706": "CASTELL DE CASTELLS",
					"7707": "CATRAL",
					"7708": "CONFRIDES",
					"7709": "COX",
					"7710": "QUATRETONDETA",
					"7711": "DAYA NUEVA",
					"7712": "DENIA",
					"7713": "DOLORES",
					"7714": "ELDA",
					"7715": "FACHECA",
					"7716": "FINESTRAT",
					"7717": "FORMENTERA DEL SEGURA",
					"7718": "GAIANES",
					"7719": "GORGA",
					"7720": "GRANJA DE ROCAMORA",
					"7721": "GUARDAMAR DEL SEGURA",
					"7722": "HONDON DE LAS NIEVES",
					"7723": "IBI",
					"7724": "JACARILLA",
					"7725": "JALON/XALO",
					"7726": "JAVEA/XABIA",
					"7727": "LORCHA/ORXA (L')",
					"7728": "LLIBER",
					"7729": "MONFORTE DEL CID",
					"7730": "MONOVAR/MONOVER",
					"7731": "MURLA",
					"7732": "MURO DE ALCOY",
					"7733": "NUCIA (LA)",
					"7734": "ONIL",
					"7735": "ORBA",
					"7736": "ORIHUELA",
					"7737": "PEDREGUER",
					"7738": "PEGO",
					"7739": "PETRER",
					"7740": "PINOSO",
					"7741": "PLANES",
					"7742": "POLOP",
					"7743": "RAFAL",
					"7744": "RAFOL D'ALMUNIA (EL)",
					"7745": "REDOVAN",
					"7746": "RELLEU",
					"7747": "ROJALES",
					"7748": "ROMANA (LA)",
					"7749": "SAGRA",
					"7750": "SALINAS",
					"7751": "SANET Y NEGRALS",
					"7752": "SAN FULGENCIO",
					"7753": "SANT JOAN D'ALACANT",
					"7754": "SAN MIGUEL DE SALINAS",
					"7755": "SANTA POLA",
					"7756": "SAN VICENTE DEL RASPEIG/SANT V",
					"7757": "SAX",
					"7758": "SELLA",
					"7759": "SENIJA",
					"7760": "TARBENA",
					"7761": "TEULADA",
					"7762": "TIBI",
					"7763": "TOLLOS",
					"7764": "TORMOS",
					"7765": "TORREMANZANAS/TORRE DE LES MAÇ",
					"7766": "TORREVIEJA",
					"7767": "VALL D'ALCALA (LA)",
					"7768": "VALL DE EBO",
					"7769": "VALL DE GALLINERA",
					"7770": "VALL DE LAGUAR (LA)",
					"7771": "VERGER (EL)",
					"7772": "VILLAJOYOSA/VILA JOIOSA (LA)",
					"7773": "VILLENA",
					"7774": "POBLETS (ELS)",
					"7775": "PILAR DE LA HORADADA",
					"7776": "MONTESINOS (LOS)",
					"7777": "SAN ISIDRO",
					"8034": "AGRES",
					"8035": "ALCALALI",
					"8036": "ALCOLEJA",
					"8037": "ALFAS DEL PI (L')",
					"8038": "ALMUDAINA",
					"8039": "ASPE",
					"8040": "BANYERES DE MARIOLA",
					"8041": "BENFERRI",
					"8042": "BENIARRES",
					"8043": "BENIDORM",
					"8044": "BENIJOFAR",
					"8045": "BENIMANTELL",
					"8046": "BENIMELI",
					"8047": "BIAR",
					"8048": "BOLULLA",
					"8049": "CALLOSA D'EN SARRIA",
					"8050": "CASTALLA",
					"8051": "COCENTAINA",
					"8052": "CREVILLENT",
					"8053": "DAYA VIEJA",
					"8054": "ELCHE/ELX",
					"8055": "FAMORCA",
					"8056": "GATA DE GORGOS",
					"8057": "GUADALEST",
					"8058": "HONDON DE LOS FRAILES",
					"8059": "JIJONA/XIXONA",
					"8060": "MILLENA",
					"8061": "MUTXAMEL",
					"8062": "NOVELDA",
					"8063": "ONDARA",
					"8064": "ORXETA",
					"8065": "PARCENT",
					"8066": "PENAGUILA"
				}
			},
			"4": {
				"nameProvincia": "Almería",
				"idProvincia": "4",
				"localidades": {
					"5399": "ULEILA DEL CAMPO",
					"5400": "URRACAL",
					"5401": "VELEFIQUE",
					"6736": "VELEZ-BLANCO",
					"6737": "VELEZ-RUBIO",
					"6966": "VERA",
					"6967": "VIATOR",
					"6968": "VICAR",
					"6969": "ZURGENA",
					"6970": "TRES VILLAS (LAS)",
					"6971": "MOJONERA (LA)",
					"7778": "ABLA",
					"7779": "ABRUCENA",
					"7780": "ADRA",
					"7781": "ALBANCHEZ",
					"7782": "ALBOLODUY",
					"7783": "ALBOX",
					"7784": "ALCOLEA",
					"7785": "ALCONTAR",
					"7786": "ALCUDIA DE MONTEAGUD",
					"7787": "ALHABIA",
					"7788": "ALHAMA DE ALMERIA",
					"7789": "ALICUN",
					"7790": "ALMERIA",
					"7791": "ALMOCITA",
					"7792": "ALSODUX",
					"7793": "ANTAS",
					"7794": "ARBOLEAS",
					"7795": "ARMUÑA DE ALMANZORA",
					"7796": "BACARES",
					"7797": "BAYARCAL",
					"7798": "BAYARQUE",
					"7799": "BEDAR",
					"7800": "BEIRES",
					"7801": "BENAHADUX",
					"7802": "BENITAGLA",
					"7803": "BENIZALON",
					"7804": "BENTARIQUE",
					"7805": "BERJA",
					"7806": "CANJAYAR",
					"7807": "CANTORIA",
					"7808": "CARBONERAS",
					"7809": "CASTRO DE FILABRES",
					"7810": "COBDAR",
					"7811": "CUEVAS DEL ALMANZORA",
					"7812": "CHERCOS",
					"7813": "CHIRIVEL",
					"7814": "DALIAS",
					"7815": "ENIX",
					"7816": "FELIX",
					"7817": "FINES",
					"7818": "FIÑANA",
					"7819": "FONDON",
					"7820": "GADOR",
					"7821": "GALLARDOS (LOS)",
					"7822": "GARRUCHA",
					"7823": "GERGAL",
					"7824": "HUECIJA",
					"7825": "HUERCAL DE ALMERIA",
					"7826": "HUERCAL-OVERA",
					"7827": "ILLAR",
					"7828": "INSTINCION",
					"7829": "LAROYA",
					"7830": "LAUJAR DE ANDARAX",
					"7831": "LIJAR",
					"7832": "LUBRIN",
					"7833": "LUCAINENA DE LAS TORRES",
					"7834": "LUCAR",
					"7835": "MACAEL",
					"7836": "MARIA",
					"7837": "MOJACAR",
					"7838": "NACIMIENTO",
					"7839": "NIJAR",
					"7840": "OHANES",
					"7841": "OLULA DE CASTRO",
					"7842": "OLULA DEL RIO",
					"7843": "ORIA",
					"7844": "PADULES",
					"7845": "PARTALOA",
					"7846": "PATERNA DEL RIO",
					"7847": "PECHINA",
					"7848": "PULPI",
					"7849": "PURCHENA",
					"7850": "RAGOL",
					"7851": "RIOJA",
					"7852": "ROQUETAS DE MAR",
					"7853": "SANTA CRUZ DE MARCHENA",
					"7854": "SANTA FE DE MONDUJAR",
					"7855": "SENES",
					"7856": "SERON",
					"7857": "SIERRO",
					"7858": "SOMONTIN",
					"7859": "SORBAS",
					"7860": "SUFLI",
					"7861": "TABERNAS",
					"7862": "TABERNO",
					"7863": "TAHAL",
					"7864": "TERQUE",
					"7865": "TIJOLA",
					"7866": "TURRE",
					"7867": "TURRILLAS",
					"8067": "EJIDO (EL)"
				}
			},
			"5": {
				"nameProvincia": "Ávila",
				"idProvincia": "5",
				"localidades": {
					"5941": "VILLAR DE CORNEJA",
					"5942": "VILLAREJO DEL VALLE",
					"5943": "VILLATORO",
					"5944": "VIÑEGRA DE MORAÑA",
					"5945": "VITA",
					"5946": "ZAPARDIEL DE LA CAÑADA",
					"5947": "ZAPARDIEL DE LA RIBERA",
					"5948": "SAN JUAN DE GREDOS",
					"5949": "SANTA MARIA DEL CUBILLO",
					"5950": "DIEGO DEL CARPIO",
					"5951": "SANTIAGO DEL TORMES",
					"5952": "VILLANUEVA DE AVILA",
					"6887": "VILLANUEVA DEL CAMPILLO",
					"6972": "ADANERO",
					"6973": "ALBORNOS",
					"6974": "ALDEANUEVA DE SANTA CRUZ",
					"6975": "ALDEHUELA (LA)",
					"6976": "AMAVIDA",
					"6977": "ARENAS DE SAN PEDRO",
					"6978": "AREVALILLO",
					"6979": "AREVALO",
					"6980": "AVELLANEDA",
					"6981": "BARCO DE AVILA (EL)",
					"6982": "BARRACO (EL)",
					"6983": "BECEDAS",
					"6984": "BECEDILLAS",
					"6985": "BERLANAS (LAS)",
					"6986": "BERNUY-ZAPARDIEL",
					"6987": "BERROCALEJO DE ARAGONA",
					"6988": "BLASCONUÑO DE MATACABRAS",
					"6989": "BLASCOSANCHO",
					"6990": "BOHODON (EL)",
					"6991": "BONILLA DE LA SIERRA",
					"6992": "BULARROS",
					"6993": "BURGOHONDO",
					"6994": "CABEZAS DEL POZO",
					"6995": "CABEZAS DEL VILLAR",
					"6996": "CABIZUELA",
					"6997": "CANDELEDA",
					"6998": "CANTIVEROS",
					"6999": "CARRERA (LA)",
					"7000": "CASAS DEL PUERTO DE VILLATORO",
					"7001": "CASAVIEJA",
					"7002": "CASILLAS",
					"7003": "CEBREROS",
					"7004": "CEPEDA LA MORA",
					"7005": "CILLAN",
					"7006": "CISLA",
					"7007": "COLLADO DE CONTRERAS",
					"7008": "COLLADO DEL MIRON",
					"7009": "CONSTANZANA",
					"7010": "CUEVAS DEL VALLE",
					"7011": "CHAMARTIN",
					"7012": "DONVIDAS",
					"7013": "ESPINOSA DE LOS CABALLEROS",
					"7014": "FONTIVEROS",
					"7015": "FRESNEDILLA",
					"7016": "FRESNO (EL)",
					"7017": "FUENTES DE AÑO",
					"7018": "GALLEGOS DE ALTAMIROS",
					"7019": "GARGANTA DEL VILLAR",
					"7020": "GAVILANES",
					"7021": "GEMUÑO",
					"7022": "GILBUENA",
					"7023": "GIMIALCON",
					"7024": "GOTARRENDURA",
					"7025": "GUISANDO",
					"7026": "GUTIERRE-MUÑOZ",
					"7027": "HERNANSANCHO",
					"7028": "HERRADON DE PINARES",
					"7029": "HIGUERA DE LAS DUEÑAS",
					"7030": "HIJA DE DIOS (LA)",
					"7031": "HORCAJADA (LA)",
					"7032": "HORNILLO (EL)",
					"7033": "HOYOCASERO",
					"7034": "HOYO DE PINARES (EL)",
					"7035": "HOYORREDONDO",
					"7036": "HOYOS DEL ESPINO",
					"7037": "HOYOS DE MIGUEL MUÑOZ",
					"7038": "HURTUMPASCUAL",
					"7039": "JUNCIANA",
					"7040": "LANZAHITA",
					"7041": "LLANOS DE TORMES (LOS)",
					"7042": "MADRIGAL DE LAS ALTAS TORRES",
					"7043": "MAELLO",
					"7044": "MALPARTIDA DE CORNEJA",
					"7045": "MANCERA DE ARRIBA",
					"7046": "MANJABALAGO",
					"7047": "MARTIHERRERO",
					"7048": "MEDIANA DE VOLTOYA",
					"7049": "MEDINILLA",
					"7050": "MESEGAR DE CORNEJA",
					"7051": "MIJARES",
					"7052": "MIRON (EL)",
					"7053": "MIRONCILLO",
					"7054": "MOMBELTRAN",
					"7055": "MONSALUPE",
					"7056": "MORALEJA DE MATACABRAS",
					"7057": "MUÑANA",
					"7058": "MUÑICO",
					"7059": "MUÑOGRANDE",
					"7060": "MUÑOMER DEL PECO",
					"7061": "MUÑOSANCHO",
					"7062": "MUÑOTELLO",
					"7063": "NARRILLOS DEL REBOLLAR",
					"7064": "NARROS DEL CASTILLO",
					"7065": "NARROS DEL PUERTO",
					"7066": "NARROS DE SALDUEÑA",
					"7067": "NAVA DE AREVALO",
					"7068": "NAVA DEL BARCO",
					"7069": "NAVADIJOS",
					"7070": "NAVAESCURIAL",
					"7071": "NAVALACRUZ",
					"7072": "NAVALMORAL",
					"7073": "NAVALONGUILLA",
					"7074": "NAVALPERAL DE PINARES",
					"7075": "NAVALUENGA",
					"7076": "NAVAQUESERA",
					"7077": "NAVARREDONDA DE GREDOS",
					"7078": "NAVARREDONDILLA",
					"7079": "NAVARREVISCA",
					"7080": "NAVAS DEL MARQUES (LAS)",
					"7081": "NAVATALGORDO",
					"7082": "NAVATEJARES",
					"7083": "NEILA DE SAN MIGUEL",
					"7084": "NIHARRA",
					"7085": "OJOS-ALBOS",
					"7086": "ORBITA",
					"7087": "OSO (EL)",
					"7088": "PADIERNOS",
					"7089": "PAJARES DE ADAJA",
					"7090": "PALACIOS DE GODA",
					"7091": "PAPATRIGO",
					"7092": "PARRAL (EL)",
					"7093": "PASCUALCOBO",
					"7094": "PEDRO BERNARDO",
					"7095": "PEDRO-RODRIGUEZ",
					"7096": "PEGUERINOS",
					"7097": "PEÑALBA DE AVILA",
					"7098": "PIEDRAHITA",
					"7099": "PIEDRALAVES",
					"7100": "POVEDA",
					"7101": "POYALES DEL HOYO",
					"7102": "POZANCO",
					"7103": "PRADOSEGAR",
					"7104": "PUERTO CASTILLA",
					"7105": "RASUEROS",
					"7106": "RIOCABADO",
					"7107": "RIOFRIO",
					"7108": "RIVILLA DE BARAJAS",
					"7109": "SALOBRAL",
					"7110": "SALVADIOS",
					"7111": "SAN BARTOLOME DE BEJAR",
					"7112": "SAN BARTOLOME DE CORNEJA",
					"7113": "SAN BARTOLOME DE PINARES",
					"7114": "SANCHIDRIAN",
					"7115": "SANCHORREJA",
					"7116": "SAN ESTEBAN DE LOS PATOS",
					"7117": "SAN ESTEBAN DEL VALLE",
					"7118": "SAN ESTEBAN DE ZAPARDIEL",
					"7119": "SAN GARCIA DE INGELMOS",
					"7120": "SAN JUAN DE LA ENCINILLA",
					"7121": "SAN JUAN DE LA NAVA",
					"7122": "SAN JUAN DEL MOLINILLO",
					"7123": "SAN JUAN DEL OLMO",
					"7124": "SAN LORENZO DE TORMES",
					"7125": "SAN MARTIN DE LA VEGA DEL ALBE",
					"7126": "SAN MARTIN DEL PIMPOLLAR",
					"7127": "SAN MIGUEL DE CORNEJA",
					"7128": "SAN MIGUEL DE SERREZUELA",
					"7129": "SAN PASCUAL",
					"7130": "SAN PEDRO DEL ARROYO",
					"7131": "SANTA CRUZ DEL VALLE",
					"7132": "SANTA CRUZ DE PINARES",
					"7133": "SANTA MARIA DEL ARROYO",
					"7134": "SANTA MARIA DEL BERROCAL",
					"7135": "SANTA MARIA DE LOS CABALLEROS",
					"7136": "SANTA MARIA DEL TIETAR",
					"7137": "SANTIAGO DEL COLLADO",
					"7138": "SANTO DOMINGO DE LAS POSADAS",
					"7139": "SANTO TOME DE ZABARCOS",
					"7140": "SAN VICENTE DE AREVALO",
					"7141": "SERRADA (LA)",
					"7142": "SERRANILLOS",
					"7143": "SIGERES",
					"7144": "SINLABAJOS",
					"7145": "SOLANA DE AVILA",
					"7146": "SOLANA DE RIOALMAR",
					"7147": "SOLOSANCHO",
					"7148": "SOTALBO",
					"7149": "SOTILLO DE LA ADRADA",
					"7150": "TIEMBLO (EL)",
					"7151": "TIÑOSILLOS",
					"7152": "TOLBAÑOS",
					"7153": "TORMELLAS",
					"7154": "TORNADIZOS DE AVILA",
					"7155": "TORTOLES",
					"7156": "TORRE (LA)",
					"7157": "UMBRIAS",
					"7158": "VADILLO DE LA SIERRA",
					"7159": "VALDECASA",
					"7160": "VEGA DE SANTA MARIA",
					"7161": "VELAYOS",
					"7162": "VILLAFLOR",
					"7163": "VILLAFRANCA DE LA SIERRA",
					"7164": "VILLANUEVA DE GOMEZ",
					"7165": "VILLANUEVA DEL ACERAL",
					"8068": "ADRADA (LA)",
					"8069": "ALDEASECA",
					"8070": "ARENAL (EL)",
					"8071": "AVEINTE",
					"8072": "AVILA",
					"8073": "BARROMAN",
					"8074": "BERCIAL DE ZAPARDIEL",
					"8075": "BLASCOMILLAN",
					"8076": "BOHOYO",
					"8077": "BRABOS",
					"8078": "CABEZAS DE ALAMBRE",
					"8079": "CANALES",
					"8080": "CARDEÑOSA",
					"8081": "CASASOLA",
					"8082": "CASTELLANOS DE ZAPARDIEL",
					"8083": "COLILLA (LA)",
					"8084": "CRESPOS",
					"8085": "DONJIMENO",
					"8086": "FLORES DE AVILA",
					"8087": "FUENTE EL SAUZ",
					"8088": "GALLEGOS DE SOBRINOS",
					"8089": "GIL GARCIA",
					"8090": "GRANDES Y SAN MARTIN",
					"8091": "HERREROS DE SUSO",
					"8092": "HORCAJO DE LAS TORRES",
					"8093": "HOYOS DEL COLLADO",
					"8094": "LANGA",
					"8095": "LOSAR DEL BARCO (EL)",
					"8096": "MAMBLAS",
					"8097": "MARLIN",
					"8098": "MARTINEZ",
					"8099": "MENGAMUÑOZ",
					"8100": "MINGORRIA",
					"8101": "MIRUEÑA DE LOS INFANZONES",
					"8102": "MUÑOGALINDO",
					"8103": "MUÑOPEPE",
					"8104": "NARRILLOS DEL ALAMO",
					"8105": "NAVACEPEDILLA DE CORNEJA",
					"8106": "NAVAHONDILLA",
					"8107": "NAVALOSA",
					"8108": "NAVALPERAL DE TORMES"
				}
			},
			"6": {
				"nameProvincia": "Badajoz",
				"idProvincia": "6",
				"localidades": {
					"5953": "ACEDERA",
					"5954": "ACEUCHAL",
					"5955": "AHILLONES",
					"5956": "ALANGE",
					"5957": "ALBUERA (LA)",
					"5958": "ALBURQUERQUE",
					"5959": "ALCONCHEL",
					"5960": "ALCONERA",
					"5961": "ALJUCEN",
					"5962": "ALMENDRAL",
					"5963": "ALMENDRALEJO",
					"5964": "ARROYO DE SAN SERVAN",
					"5965": "ATALAYA",
					"5966": "AZUAGA",
					"5967": "BADAJOZ",
					"5968": "BARCARROTA",
					"5969": "BATERNO",
					"5970": "BENQUERENCIA DE LA SERENA",
					"5971": "BERLANGA",
					"5972": "BIENVENIDA",
					"5973": "BODONAL DE LA SIERRA",
					"5974": "BURGUILLOS DEL CERRO",
					"5975": "CABEZA DEL BUEY",
					"5976": "CABEZA LA VACA",
					"5977": "CALAMONTE",
					"5978": "CALERA DE LEON",
					"5979": "CALZADILLA DE LOS BARROS",
					"5980": "CAMPANARIO",
					"5981": "CAMPILLO DE LLERENA",
					"5982": "CAPILLA",
					"5983": "CARMONITA",
					"5984": "CARRASCALEJO (EL)",
					"5985": "CASAS DE DON PEDRO",
					"5986": "CASAS DE REINA",
					"5987": "CASTILBLANCO",
					"5988": "CASTUERA",
					"5989": "CODOSERA (LA)",
					"5990": "CORDOBILLA DE LACARA",
					"5991": "CORONADA (LA)",
					"5992": "CORTE DE PELEAS",
					"5993": "CRISTINA",
					"5994": "CHELES",
					"5995": "DON ALVARO",
					"5996": "DON BENITO",
					"5997": "ENTRIN BAJO",
					"5998": "ESPARRAGALEJO",
					"5999": "ESPARRAGOSA DE LA SERENA",
					"6000": "ESPARRAGOSA DE LARES",
					"6001": "FERIA",
					"6002": "FREGENAL DE LA SIERRA",
					"6003": "FUENLABRADA DE LOS MONTES",
					"6004": "FUENTE DE CANTOS",
					"6005": "FUENTE DEL ARCO",
					"6006": "FUENTE DEL MAESTRE",
					"6007": "FUENTES DE LEON",
					"6008": "GARBAYUELA",
					"6009": "GARLITOS",
					"6010": "GARROVILLA (LA)",
					"6011": "GRANJA DE TORREHERMOSA",
					"6012": "GUAREÑA",
					"6013": "HABA (LA)",
					"6014": "HELECHOSA DE LOS MONTES",
					"6015": "HERRERA DEL DUQUE",
					"6016": "HIGUERA DE LA SERENA",
					"6017": "HIGUERA DE LLERENA",
					"6018": "HIGUERA DE VARGAS",
					"6019": "HIGUERA LA REAL",
					"6020": "HINOJOSA DEL VALLE",
					"6021": "HORNACHOS",
					"6022": "JEREZ DE LOS CABALLEROS",
					"6023": "LAPA (LA)",
					"6024": "LOBON",
					"6025": "LLERA",
					"6026": "LLERENA",
					"6027": "MAGACELA",
					"6028": "MAGUILLA",
					"6029": "MALCOCINADO",
					"6030": "MALPARTIDA DE LA SERENA",
					"6031": "MANCHITA",
					"6032": "MEDELLIN",
					"6033": "MEDINA DE LAS TORRES",
					"6034": "MENGABRIL",
					"6035": "MERIDA",
					"6036": "MIRANDILLA",
					"6037": "MONESTERIO",
					"6038": "MONTEMOLIN",
					"6039": "MONTERRUBIO DE LA SERENA",
					"6040": "MONTIJO",
					"6041": "MORERA (LA)",
					"6042": "NAVA DE SANTIAGO (LA)",
					"6043": "NAVALVILLAR DE PELA",
					"6044": "NOGALES",
					"6045": "OLIVA DE LA FRONTERA",
					"6739": "PALOMAS",
					"6740": "PARRA (LA)",
					"6741": "PEÑALSORDO",
					"6742": "PUEBLA DE ALCOCER",
					"6743": "PUEBLA DE LA CALZADA",
					"6744": "PUEBLA DE LA REINA",
					"6745": "PUEBLA DEL MAESTRE",
					"6746": "PUEBLA DE OBANDO",
					"6747": "PUEBLA DE SANCHO PEREZ",
					"6748": "QUINTANA DE LA SERENA",
					"6749": "RENA",
					"6750": "RIBERA DEL FRESNO",
					"6751": "RISCO",
					"6752": "ROCA DE LA SIERRA (LA)",
					"6753": "SALVALEON",
					"6754": "SANCTI-SPIRITUS",
					"6755": "SAN PEDRO DE MERIDA",
					"6756": "SANTA AMALIA",
					"6757": "SANTA MARTA",
					"6758": "SAN VICENTE DE ALCANTARA",
					"6759": "SEGURA DE LEON",
					"6760": "SIRUELA",
					"6761": "SOLANA DE LOS BARROS",
					"6762": "TALARRUBIAS",
					"6763": "TALIGA",
					"6764": "TAMUREJO",
					"6765": "TORRE DE MIGUEL SESMERO",
					"6766": "TORREMEJIA",
					"6767": "TRASIERRA",
					"6768": "USAGRE",
					"6769": "VALDECABALLEROS",
					"6770": "VALENCIA DE LAS TORRES",
					"6771": "VALENCIA DEL MOMBUEY",
					"6772": "VALENCIA DEL VENTOSO",
					"6773": "VALVERDE DE LEGANES",
					"6774": "VALVERDE DE LLERENA",
					"6775": "VALVERDE DE MERIDA",
					"6776": "VALLE DE LA SERENA",
					"6777": "VALLE DE SANTA ANA",
					"6778": "VILLAFRANCA DE LOS BARROS",
					"6779": "VILLAGARCIA DE LA TORRE",
					"6780": "VILLALBA DE LOS BARROS",
					"6781": "VILLANUEVA DE LA SERENA",
					"6782": "VILLANUEVA DEL FRESNO",
					"6783": "VILLAR DE RENA",
					"6784": "VILLARTA DE LOS MONTES",
					"6785": "ZAFRA",
					"6786": "ZALAMEA DE LA SERENA",
					"6787": "ZARZA (LA)",
					"6788": "VALDELACALZADA",
					"6789": "PUEBLONUEVO DEL GUADIANA",
					"7178": "ORELLANA LA VIEJA",
					"7398": "OLIVA DE MERIDA",
					"7399": "OLIVENZA",
					"7981": "ORELLANA DE LA SIERRA",
					"7982": "PERALEDA DEL ZAUCEJO",
					"7983": "PUEBLA DEL PRIOR",
					"7984": "REINA",
					"7985": "RETAMAL DE LLERENA",
					"7986": "SALVATIERRA DE LOS BARROS",
					"7987": "SANTOS DE MAIMONA (LOS)",
					"7988": "TALAVERA LA REAL",
					"7989": "TORREMAYOR",
					"7990": "TRUJILLANOS",
					"7991": "VALDETORRES",
					"7992": "VALVERDE DE BURGUILLOS",
					"7993": "VALLE DE MATAMOROS",
					"7994": "VILLAGONZALO",
					"7995": "VILLAR DEL REY",
					"7996": "ZAHINOS",
					"7997": "ZARZA-CAPILLA"
				}
			},
			"7": {
				"nameProvincia": "Islas Baleares",
				"idProvincia": "7",
				"localidades": {
					"6790": "ALAIOR",
					"6791": "ALGAIDA",
					"6792": "ANDRATX",
					"6793": "BANYALBUFAR",
					"6794": "BUGER",
					"6795": "BUNYOLA",
					"6796": "CAMPANET",
					"6797": "CAMPOS",
					"6798": "CIUTADELLA DE MENORCA",
					"6799": "CONSELL",
					"6800": "DEYA",
					"6801": "ESPORLES",
					"6802": "ESTELLENCS",
					"6803": "FERRERIES",
					"6804": "FORMENTERA",
					"6805": "EIVISSA",
					"6806": "INCA",
					"6807": "LLOSETA",
					"6808": "LLUBI",
					"6809": "LLUCMAJOR",
					"6810": "MAHON",
					"6811": "MANCOR DE LA VALL",
					"6812": "MARRATXI",
					"6813": "MERCADAL (ES)",
					"6814": "MONTUïRI",
					"6815": "MURO",
					"6816": "PETRA",
					"6817": "POLLENÇA",
					"6818": "PORRERES",
					"6819": "PUIGPUNYENT",
					"6820": "SANT ANTONI DE PORTMANY",
					"6821": "SANT JOSEP DE SA TALAIA",
					"6822": "SANT JOAN",
					"6823": "SANT LLORENÇ DES CARDASSAR",
					"6824": "SANT LLUIS",
					"6825": "SANTA EUGENIA",
					"6826": "SANTA EULALIA DEL RIO",
					"6827": "SANTA MARIA DEL CAMI",
					"6828": "SANTANYI",
					"6829": "SELVA",
					"6830": "SINEU",
					"6831": "SOLLER",
					"6832": "SON SERVERA",
					"6833": "VALLDEMOSSA",
					"6834": "CASTELL (ES)",
					"6835": "VILAFRANCA DE BONANY",
					"6836": "ARIANY",
					"6837": "MIGJORN GRAN (ES)",
					"7998": "ALARO",
					"7999": "ALCUDIA",
					"8000": "ARTA",
					"8001": "BINISSALEM",
					"8002": "CALVIA",
					"8003": "CAPDEPERA",
					"8004": "COSTITX",
					"8005": "ESCORCA",
					"8006": "FELANITX",
					"8007": "FORNALUTX",
					"8008": "LLORET DE VISTALEGRE",
					"8009": "MANACOR",
					"8010": "MARIA DE LA SALUT",
					"8011": "PALMA DE MALLORCA",
					"8012": "POBLA (SA)",
					"8013": "SENCELLES",
					"8014": "SANT JOAN DE LABRITJA",
					"8015": "SANTA MARGALIDA",
					"8016": "SALINES (SES)"
				}
			},
			"8": {
				"nameProvincia": "Barcelona",
				"idProvincia": "8",
				"localidades": {
					"3341": "SANT BOI DE LLUÇANES",
					"5257": "CASTELLAR DEL VALLES",
					"5258": "CASTELLAR DE N'HUG",
					"5259": "CASTELLBELL I EL VILAR",
					"5260": "CASTELLBISBAL",
					"5261": "CASTELLCIR",
					"5262": "CASTELLDEFELS",
					"5263": "CASTELL DE L'ARENY",
					"5264": "CASTELLET I LA GORNAL",
					"5265": "CASTELLFOLLIT DEL BOIX",
					"5266": "CASTELLFOLLIT DE RIUBREGOS",
					"5267": "CASTELLGALI",
					"5268": "CASTELLNOU DE BAGES",
					"5269": "CASTELLOLI",
					"5270": "CASTELLTERÇOL",
					"5271": "CASTELLVI DE LA MARCA",
					"5272": "CASTELLVI DE ROSANES",
					"5273": "CENTELLES",
					"5274": "CERVELLO",
					"5275": "COLLBATO",
					"5276": "COLLSUSPINA",
					"5277": "COPONS",
					"5278": "CORBERA DE LLOBREGAT",
					"5279": "CORNELLA DE LLOBREGAT",
					"5280": "CUBELLES",
					"5281": "DOSRIUS",
					"5282": "ESPARREGUERA",
					"5283": "ESPLUGUES DE LLOBREGAT",
					"5284": "ESPUNYOLA (L')",
					"5285": "ESTANY (L')",
					"5286": "FIGOLS",
					"5287": "FOGARS DE MONTCLUS",
					"5288": "FOGARS DE LA SELVA",
					"5289": "FOLGUEROLES",
					"5290": "FONOLLOSA",
					"5291": "FONT-RUBI",
					"5292": "FRANQUESES DEL VALLES (LES)",
					"5293": "GALLIFA",
					"5294": "GARRIGA (LA)",
					"5295": "GAVA",
					"5296": "GAIA",
					"5297": "GELIDA",
					"5298": "GIRONELLA",
					"5299": "GISCLARENY",
					"5300": "GRANADA (LA)",
					"5301": "GRANERA",
					"5302": "GRANOLLERS",
					"5303": "GUALBA",
					"5304": "SANT SALVADOR DE GUARDIOLA",
					"5305": "GUARDIOLA DE BERGUEDA",
					"5306": "GURB",
					"5307": "HOSPITALET DE LLOBREGAT (L')",
					"5308": "IGUALADA",
					"5309": "JORBA",
					"5310": "LLACUNA (LA)",
					"5311": "LLAGOSTA (LA)",
					"5312": "LLINARS DEL VALLES",
					"5313": "LLIÇA D'AMUNT",
					"5314": "LLIÇA DE VALL",
					"5315": "LLUÇA",
					"5316": "MALGRAT DE MAR",
					"5317": "MALLA",
					"5318": "MANLLEU",
					"5319": "MANRESA",
					"5320": "MARTORELL",
					"5321": "MARTORELLES",
					"5322": "MASIES DE RODA (LES)",
					"5323": "MASIES DE VOLTREGA (LES)",
					"5324": "MASNOU (EL)",
					"5325": "MASQUEFA",
					"5326": "MATADEPERA",
					"5327": "MATARO",
					"5328": "MEDIONA",
					"5329": "MOLINS DE REI",
					"5330": "MOLLET DEL VALLES",
					"5331": "MONTCADA I REIXAC",
					"5332": "MONTGAT",
					"5333": "MONISTROL DE MONTSERRAT",
					"5334": "MONISTROL DE CALDERS",
					"5335": "MUNTANYOLA",
					"5336": "MONTCLAR",
					"5337": "MONTESQUIU",
					"5338": "MONTMAJOR",
					"5339": "MONTMANEU",
					"5340": "FIGARO-MONTMANY",
					"5341": "MONTMELO",
					"5342": "MONTORNES DEL VALLES",
					"5343": "MONTSENY",
					"5344": "MOIA",
					"5345": "MURA",
					"5346": "NAVARCLES",
					"5347": "NAVAS",
					"5348": "NOU DE BERGUEDA (LA)",
					"5349": "ÒDENA",
					"5350": "OLVAN",
					"5351": "OLERDOLA",
					"5352": "OLESA DE BONESVALLS",
					"5353": "OLESA DE MONTSERRAT",
					"5354": "OLIVELLA",
					"5355": "OLOST",
					"5356": "ORIS",
					"5357": "ORISTA",
					"5358": "ORPI",
					"5359": "ÒRRIUS",
					"5360": "PACS DEL PENEDES",
					"5361": "PALAFOLLS",
					"5362": "PALAU-SOLITA I PLEGAMANS",
					"5363": "PALLEJA",
					"5364": "PAPIOL (EL)",
					"5365": "PARETS DEL VALLES",
					"5366": "PERAFITA",
					"5367": "PIERA",
					"5368": "HOSTALETS DE PIEROLA (ELS)",
					"5369": "PINEDA DE MAR",
					"5370": "PLA DEL PENEDES (EL)",
					"5371": "POBLA DE CLARAMUNT (LA)",
					"5372": "POBLA DE LILLET (LA)",
					"5373": "POLINYA",
					"5374": "PONTONS",
					"5375": "PRAT DE LLOBREGAT (EL)",
					"5376": "PRATS DE REI (ELS)",
					"5377": "PRATS DE LLUÇANES",
					"5378": "PREMIA DE MAR",
					"5379": "PUIGDALBER",
					"5380": "PUIG-REIG",
					"5381": "PUJALT",
					"5382": "QUAR (LA)",
					"5383": "RELLINARS",
					"5384": "RIPOLLET",
					"5385": "PONT DE VILOMARA I ROCAFORT (E",
					"5386": "RODA DE TER",
					"5387": "RUBI",
					"5388": "SABADELL",
					"5389": "SAGAS",
					"5390": "SALDES",
					"5391": "SALLENT",
					"5392": "SANTPEDOR",
					"5393": "SANT ISCLE DE VALLALTA",
					"5394": "SANT AGUSTI DE LLUÇANES",
					"5395": "SANT ANDREU DE LA BARCA",
					"5396": "SANT ANDREU DE LLAVANERES",
					"5397": "SANT BARTOMEU DEL GRAU",
					"5398": "SANT BOI DE LLOBREGAT",
					"5841": "SANT CELONI",
					"5842": "SANT CEBRIA DE VALLALTA",
					"5843": "SANT CUGAT DEL VALLES",
					"5844": "SANT CUGAT SESGARRIGUES",
					"5845": "SANT ESTEVE DE PALAUTORDERA",
					"5846": "SANT ESTEVE SESROVIRES",
					"5847": "SANT FOST DE CAMPSENTELLES",
					"5848": "SANT FELIU DE LLOBREGAT",
					"5849": "SANT FELIU SASSERRA",
					"5850": "SANT FRUITOS DE BAGES",
					"5851": "VILASSAR DE DALT",
					"5852": "SANT JAUME DE FRONTANYA",
					"5853": "SANT JOAN DESPI",
					"5854": "SANT JOAN DE VILATORRADA",
					"5855": "VILASSAR DE MAR",
					"5856": "SANT JUST DESVERN",
					"5857": "SANT LLORENÇ D'HORTONS",
					"5858": "SANT LLORENÇ SAVALL",
					"5859": "SANT MARTI DE CENTELLES",
					"5860": "SANT MARTI DE TOUS",
					"5861": "SANT MARTI SARROCA",
					"5862": "SANT MARTI SESGUEIOLES",
					"5863": "SANT MATEU DE BAGES",
					"5864": "SANT PERE DE RIBES",
					"5865": "SANT PERE DE RIUDEBITLLES",
					"5866": "SANT PERE DE TORELLO",
					"5867": "SANT POL DE MAR",
					"5868": "SANT QUINTI DE MEDIONA",
					"5869": "SANT QUIRZE DE BESORA",
					"5870": "SANT QUIRZE DEL VALLES",
					"5871": "SANT SADURNI D'ANOIA",
					"5872": "SANT SADURNI D'OSORMORT",
					"5873": "MARGANELL",
					"5874": "SANTA CECILIA DE VOLTREGA",
					"5875": "SANTA COLOMA DE GRAMENET",
					"5876": "SANTA EUGENIA DE BERGA",
					"5877": "SANTA EULALIA DE RIUPRIMER",
					"5878": "SANTA EULALIA DE RONÇANA",
					"5879": "SANTA MARGARIDA DE MONTBUI",
					"5880": "SANTA MARGARIDA I ELS MONJOS",
					"5881": "BARBERA DEL VALLES",
					"5882": "SANTA MARIA DE BESORA",
					"5883": "SANTA MARIA DE MERLES",
					"5884": "SANTA MARIA DE MARTORELLES",
					"5885": "SANTA MARIA DE MIRALLES",
					"5886": "SANTA MARIA D'OLO",
					"5887": "SANTA PERPETUA DE MOGODA",
					"5888": "SANTA SUSANNA",
					"5889": "SANT VICENÇ DE CASTELLET",
					"5890": "SANT VICENÇ DELS HORTS",
					"5891": "SANT VICENÇ DE MONTALT",
					"5892": "CERDANYOLA DEL VALLES",
					"5893": "SENTMENAT",
					"5894": "CERCS",
					"5895": "SEVA",
					"5896": "SOBREMUNT",
					"5897": "SUBIRATS",
					"5898": "SURIA",
					"5899": "TAGAMANENT",
					"5900": "TALAMANCA",
					"5901": "TERRASSA",
					"5902": "TAVERTET",
					"5903": "TIANA",
					"5904": "TORDERA",
					"5905": "TORRE DE CLARAMUNT (LA)",
					"5906": "TORRELAVIT",
					"5907": "TORRELLES DE LLOBREGAT",
					"5908": "ULLASTRELL",
					"5909": "VACARISSES",
					"5910": "VALLCEBRE",
					"5911": "VALLGORGUINA",
					"5912": "VALLIRANA",
					"5913": "VECIANA",
					"5914": "VIC",
					"5915": "VILADA",
					"5916": "VILADECAVALLS",
					"5917": "VILADECANS",
					"5918": "VILANOVA DEL CAMI",
					"5919": "VILANOVA DE SAU",
					"5920": "VILOBI DEL PENEDES",
					"5921": "VILAFRANCA DEL PENEDES",
					"5922": "VILALBA SASSERRA",
					"5923": "VILANOVA I LA GELTRU",
					"5924": "VIVER I SERRATEIX",
					"5925": "RUPIT I PRUIT",
					"5926": "VILANOVA DEL VALLES",
					"5927": "SANT JULIA DE CERDANYOLA",
					"5928": "BADIA DEL VALLES",
					"5929": "PALMA DE CERVELLO (LA)",
					"5940": "CASTELLAR DEL RIU",
					"6838": "ABRERA",
					"6839": "AGUILAR DE SEGARRA",
					"6840": "ALELLA",
					"6841": "ALPENS",
					"6842": "AMETLLA DEL VALLES (L')",
					"6843": "ARENYS DE MAR",
					"6844": "ARENYS DE MUNT",
					"6845": "ARGENÇOLA",
					"6846": "ARGENTONA",
					"6847": "ARTES",
					"6848": "AVIA",
					"6849": "AVINYO",
					"6850": "AVINYONET DEL PENEDES",
					"6851": "AIGUAFREDA",
					"6852": "BADALONA",
					"6853": "BAGA",
					"6854": "BALENYA",
					"6855": "BALSARENY",
					"6856": "BARCELONA",
					"6857": "BEGUES",
					"6858": "BELLPRAT",
					"6859": "BERGA",
					"6860": "BIGUES I RIELLS",
					"6861": "BORREDA",
					"6862": "BRUC (EL)",
					"6863": "BRULL (EL)",
					"6864": "CABANYES (LES)",
					"6865": "CABRERA D'IGUALADA",
					"6866": "CABRERA DE MAR",
					"6867": "CABRILS",
					"6868": "CALAF",
					"6869": "CALDES D'ESTRAC",
					"6870": "CALDES DE MONTBUI",
					"6871": "CALDERS",
					"6872": "CALELLA",
					"6873": "CALONGE DE SEGARRA",
					"6874": "CALLDETENES",
					"6875": "CALLUS",
					"6876": "CAMPINS",
					"6877": "CANET DE MAR",
					"6878": "CANOVELLES",
					"6879": "CANOVES I SAMALUS",
					"6880": "CANYELLES",
					"6881": "CAPELLADES",
					"6882": "CAPOLAT",
					"6883": "CARDEDEU",
					"6884": "CARDONA",
					"6885": "CARME",
					"6886": "CASSERRES",
					"7952": "RAJADELL",
					"7953": "ROCA DEL VALLES (LA)",
					"7954": "RUBIO",
					"7955": "SANT PERE SALLAVINERA",
					"7956": "SANT ADRIA DE BESOS",
					"7957": "SANT ANTONI DE VILAMAJOR",
					"7958": "SANT CLIMENT DE LLOBREGAT",
					"7959": "SANT FELIU DE CODINES",
					"7960": "SANT HIPOLIT DE VOLTREGA",
					"7961": "SANT JULIA DE VILATORTA",
					"7962": "SANT MARTI D'ALBARS",
					"7963": "PREMIA DE DALT",
					"7964": "SANT PERE DE VILAMAJOR",
					"7965": "SANT QUIRZE SAFAJA",
					"7966": "SANTA COLOMA DE CERVELLO",
					"7967": "SANTA FE DEL PENEDES",
					"7968": "SANTA MARIA DE CORCO",
					"7969": "SANTA MARIA DE PALAUTORDERA",
					"7970": "SANT VICENÇ DE TORELLO",
					"7971": "SITGES",
					"7972": "SORA",
					"7973": "TAVERNOLES",
					"7974": "TARADELL",
					"7975": "TEIA",
					"7976": "TONA",
					"7977": "TORELLO",
					"7978": "TORRELLES DE FOIX",
					"7979": "VALLBONA D'ANOIA",
					"7980": "VALLROMANES"
				}
			},
			"9": {
				"nameProvincia": "Burgos",
				"idProvincia": "9",
				"localidades": {
					"4758": "SOTRESGUDO",
					"4759": "TAMARON",
					"4760": "TARDAJOS",
					"4761": "TEJADA",
					"4762": "TERRADILLOS DE ESGUEVA",
					"4763": "TOBAR",
					"4764": "TORDOMAR",
					"4765": "TORRECILLA DEL MONTE",
					"4766": "TORREGALINDO",
					"4767": "TORREPADRE",
					"4768": "TORRESANDINO",
					"4769": "TOSANTOS",
					"4770": "TRESPADERNE",
					"4771": "TUBILLA DEL AGUA",
					"4772": "URBEL DEL CASTILLO",
					"4773": "VADOCONDES",
					"4774": "VALDEANDE",
					"4775": "VALDEZATE",
					"4776": "VALMALA",
					"4777": "VALLARTA DE BUREBA",
					"4778": "VALLE DE MENA",
					"4779": "VALLE DE OCA",
					"4780": "VALLE DE TOBALINA",
					"4781": "VALLE DE VALDEBEZANA",
					"4782": "VALLE DE VALDELAGUNA",
					"4783": "VALLE DE VALDELUCIO",
					"4784": "VALLE DE ZAMANZAS",
					"4785": "VALLEJERA",
					"4786": "VALLES DE PALENZUELA",
					"4787": "VALLUERCANES",
					"4788": "VID Y BARRIOS (LA)",
					"4789": "VID DE BUREBA (LA)",
					"4790": "VILEÑA",
					"4791": "VILORIA DE RIOJA",
					"4792": "VILVIESTRE DEL PINAR",
					"4793": "VILLADIEGO",
					"4794": "VILLAESCUSA DE ROA",
					"4795": "VILLAESCUSA LA SOMBRIA",
					"4796": "VILLAESPASA",
					"4797": "VILLAFRANCA MONTES DE OCA",
					"4798": "VILLAFRUELA",
					"4799": "VILLAGALIJO",
					"4800": "VILLAGONZALO PEDERNALES",
					"4801": "VILLAHOZ",
					"4802": "VILLALBA DE DUERO",
					"4803": "VILLALBILLA DE BURGOS",
					"4804": "VILLALBILLA DE GUMIEL",
					"4805": "VILLALDEMIRO",
					"4806": "VILLALMANZO",
					"4807": "VILLAMAYOR DE LOS MONTES",
					"4808": "VILLAMAYOR DE TREVIÑO",
					"4809": "VILLAMBISTIA",
					"4810": "VILLAMEDIANILLA",
					"4811": "VILLAMIEL DE LA SIERRA",
					"4812": "VILLANGOMEZ",
					"4813": "VILLANUEVA DE ARGAÑO",
					"4814": "VILLANUEVA DE CARAZO",
					"4815": "VILLANUEVA DE GUMIEL",
					"4816": "VILLANUEVA DE TEBA",
					"4817": "VILLAQUIRAN DE LA PUEBLA",
					"4818": "VILLAQUIRAN DE LOS INFANTES",
					"4819": "VILLARIEZO",
					"4820": "VILLASANDINO",
					"4821": "VILLASUR DE HERREROS",
					"4822": "VILLATUELDA",
					"4823": "VILLAVERDE DEL MONTE",
					"4824": "VILLAVERDE-MOGINA",
					"4825": "VILLAYERNO MORQUILLAS",
					"4826": "VILLAZOPEQUE",
					"4827": "VILLEGAS",
					"4828": "VILLORUEBO",
					"4829": "VIZCAINOS",
					"4830": "ZAEL",
					"4831": "ZARZOSA DE RIO PISUERGA",
					"4832": "ZAZUAR",
					"4833": "ZUÑEDA",
					"4834": "QUINTANILLA DEL AGUA Y TORDUEL",
					"4835": "VALLE DE SANTIBAÑEZ",
					"4836": "VILLARCAYO DE MERINDAD DE CAST",
					"4837": "VALLE DE LAS NAVAS",
					"4838": "VALLE DE SEDANO",
					"4839": "MERINDAD DE RIO UBIERNA",
					"4840": "ALFOZ DE QUINTANADUEÑAS",
					"4841": "VALLE DE LOSA",
					"5187": "PAMPLIEGA",
					"5188": "PANCORBO",
					"5189": "PARDILLA",
					"5190": "PEDROSA DE DUERO",
					"5191": "PEDROSA DEL PARAMO",
					"5192": "PEDROSA DEL PRINCIPE",
					"5193": "PEDROSA DE RIO URBEL",
					"5194": "PEÑARANDA DE DUERO",
					"5195": "PERAL DE ARLANZA",
					"5196": "PINEDA DE LA SIERRA",
					"5197": "PINEDA TRASMONTE",
					"5198": "PINILLA DE LOS MOROS",
					"5199": "PINILLA TRASMONTE",
					"5200": "POZA DE LA SAL",
					"5201": "PRADANOS DE BUREBA",
					"5202": "PRESENCIO",
					"5203": "PUEBLA DE ARGANZON (LA)",
					"5204": "PUENTEDURA",
					"5205": "QUINTANABUREBA",
					"5206": "QUINTANAELEZ",
					"5207": "QUINTANAORTUÑO",
					"5208": "QUINTANAPALLA",
					"5209": "QUINTANAR DE LA SIERRA",
					"5210": "QUINTANILLA DE LA MATA",
					"5211": "QUINTANILLA DEL COCO",
					"5212": "QUINTANILLA SAN GARCIA",
					"5213": "QUINTANILLA VIVAR",
					"5214": "RABANERA DEL PINAR",
					"5215": "RABANOS",
					"5216": "REBOLLEDO DE LA TORRE",
					"5217": "REDECILLA DEL CAMINO",
					"5218": "REDECILLA DEL CAMPO",
					"5219": "REGUMIEL DE LA SIERRA",
					"5220": "RETUERTA",
					"5221": "REVILLA DEL CAMPO",
					"5222": "REVILLARRUZ",
					"5223": "REVILLA VALLEJERA",
					"5224": "REZMONDO",
					"5225": "ROA",
					"5226": "ROJAS",
					"5227": "ROYUELA DE RIO FRANCO",
					"5228": "RUBENA",
					"5229": "RUCANDIO",
					"5230": "SALAS DE BUREBA",
					"5231": "SALAS DE LOS INFANTES",
					"5232": "SALDAÑA DE BURGOS",
					"5233": "SAN ADRIAN DE JUARROS",
					"5234": "SAN JUAN DEL MONTE",
					"5235": "SAN MAMES DE BURGOS",
					"5236": "SAN MARTIN DE RUBIALES",
					"5237": "SANTA CECILIA",
					"5238": "SANTA CRUZ DE LA SALCEDA",
					"5239": "SANTA CRUZ DEL VALLE URBION",
					"5240": "SANTA INES",
					"5241": "SANTA MARIA DEL CAMPO",
					"5242": "SANTA MARIA DEL INVIERNO",
					"5243": "SANTA MARIA DEL MERCADILLO",
					"5244": "SANTA OLALLA DE BUREBA",
					"5245": "SANTIBAÑEZ DE ESGUEVA",
					"5246": "SANTIBAÑEZ DEL VAL",
					"5247": "SANTO DOMINGO DE SILOS",
					"5248": "SAN VICENTE DEL VALLE",
					"5249": "SARGENTES DE LA LORA",
					"5250": "SARRACIN",
					"5251": "SASAMON",
					"5252": "SEQUERA DE HAZA (LA)",
					"5253": "SOLARANA",
					"5254": "SORDILLOS",
					"5255": "SOTILLO DE LA RIBERA",
					"5256": "AMEYUGO",
					"5669": "SOTRAGERO",
					"5670": "ANGUIX",
					"5671": "ARANDILLA",
					"5672": "ARAUZO DE MIEL",
					"5673": "ARAUZO DE SALCE",
					"5674": "ARCOS",
					"5675": "ARENILLAS DE RIOPISUERGA",
					"5676": "ARIJA",
					"5677": "ARRAYA DE OCA",
					"5678": "ATAPUERCA",
					"5679": "AUSINES (LOS)",
					"5680": "AVELLANOSA DE MUÑO",
					"5681": "BAHABON DE ESGUEVA",
					"5682": "BALBASES (LOS)",
					"5683": "BAÑOS DE VALDEARADOS",
					"5684": "BAÑUELOS DE BUREBA",
					"5685": "BARBADILLO DE HERREROS",
					"5686": "BARBADILLO DEL MERCADO",
					"5687": "BARBADILLO DEL PEZ",
					"5688": "BARRIO DE MUÑO",
					"5689": "BARRIOS DE BUREBA (LOS)",
					"5690": "BARRIOS DE COLINA",
					"5691": "BASCONCILLOS DEL TOZO",
					"5692": "BASCUÑANA",
					"5693": "BELBIMBRE",
					"5694": "BELORADO",
					"5695": "BERBERANA",
					"5696": "BERLANGAS DE ROA",
					"5697": "BERZOSA DE BUREBA",
					"5698": "BOZOO",
					"5699": "BRAZACORTA",
					"5700": "BRIVIESCA",
					"5701": "BUGEDO",
					"5702": "BUNIEL",
					"5703": "BURGOS",
					"5704": "BUSTO DE BUREBA",
					"5705": "CABAÑES DE ESGUEVA",
					"5706": "CABEZON DE LA SIERRA",
					"5707": "CABIA",
					"5708": "CALERUEGA",
					"5709": "CAMPILLO DE ARANDA",
					"5710": "CAMPOLARA",
					"5711": "CANICOSA DE LA SIERRA",
					"5712": "CANTABRANA",
					"5713": "CARAZO",
					"5714": "CARCEDO DE BUREBA",
					"5715": "CARCEDO DE BURGOS",
					"5716": "CARDEÑADIJO",
					"5717": "CARDEÑAJIMENO",
					"5718": "CARDEÑUELA RIOPICO",
					"5719": "CARRIAS",
					"5720": "CASCAJARES DE BUREBA",
					"5721": "CASCAJARES DE LA SIERRA",
					"5722": "CASTELLANOS DE CASTRO",
					"5723": "CASTILDELGADO",
					"5724": "CASTIL DE PEONES",
					"5725": "CASTRILLO DE LA REINA",
					"5726": "CASTRILLO DE LA VEGA",
					"5727": "CASTRILLO DEL VAL",
					"5728": "CASTRILLO DE RIOPISUERGA",
					"5729": "CASTRILLO MATAJUDIOS",
					"5730": "CASTROJERIZ",
					"5731": "CAYUELA",
					"5732": "CEBRECOS",
					"5733": "CELADA DEL CAMINO",
					"5734": "CEREZO DE RIO TIRON",
					"5735": "CERRATON DE JUARROS",
					"5736": "CIADONCHA",
					"5737": "CILLAPERLATA",
					"5738": "CILLERUELO DE ABAJO",
					"5739": "CILLERUELO DE ARRIBA",
					"5740": "CIRUELOS DE CERVERA",
					"5741": "COGOLLOS",
					"5742": "CONDADO DE TREVIÑO",
					"5743": "CONTRERAS",
					"5744": "CORUÑA DEL CONDE",
					"5745": "COVARRUBIAS",
					"5746": "CUBILLO DEL CAMPO",
					"5747": "CUBO DE BUREBA",
					"5748": "CUEVA DE ROA (LA)",
					"5749": "CUEVAS DE SAN CLEMENTE",
					"5750": "ENCIO",
					"5751": "ESPINOSA DE CERVERA",
					"5752": "ESPINOSA DEL CAMINO",
					"5753": "ESPINOSA DE LOS MONTEROS",
					"5754": "ESTEPAR",
					"5755": "FONTIOSO",
					"5756": "FRANDOVINEZ",
					"5757": "FRESNEDA DE LA SIERRA TIRON",
					"5758": "FRESNEÑA",
					"5759": "FRESNILLO DE LAS DUEÑAS",
					"5760": "FRESNO DE RIO TIRON",
					"5761": "FRESNO DE RODILLA",
					"5762": "FRIAS",
					"5763": "FUENTEBUREBA",
					"5764": "FUENTECEN",
					"5765": "FUENTELCESPED",
					"5766": "FUENTELISENDO",
					"5767": "FUENTEMOLINOS",
					"5768": "FUENTENEBRO",
					"5769": "FUENTESPINA",
					"5770": "GALBARROS",
					"5771": "GALLEGA (LA)",
					"5772": "GRIJALBA",
					"5773": "GRISALEÑA",
					"5774": "GUMIEL DE IZAN",
					"5775": "GUMIEL DE MERCADO",
					"5776": "HACINAS",
					"5777": "HAZA",
					"5778": "HONTANAS",
					"5779": "HONTANGAS",
					"5780": "HONTORIA DE LA CANTERA",
					"5781": "HONTORIA DEL PINAR",
					"5782": "HONTORIA DE VALDEARADOS",
					"5783": "HORMAZAS (LAS)",
					"5784": "HORNILLOS DEL CAMINO",
					"5785": "HORRA (LA)",
					"5786": "HORTIGÜELA",
					"5787": "HOYALES DE ROA",
					"5788": "HUERMECES",
					"5789": "HUERTA DE ARRIBA",
					"5790": "HUERTA DE REY",
					"5791": "HUMADA",
					"5792": "HURONES",
					"5793": "IBEAS DE JUARROS",
					"5794": "IBRILLOS",
					"5795": "IGLESIARRUBIA",
					"5796": "IGLESIAS",
					"5797": "ISAR",
					"5798": "ITERO DEL CASTILLO",
					"5799": "JARAMILLO DE LA FUENTE",
					"5800": "JARAMILLO QUEMADO",
					"5801": "JUNTA DE TRASLALOMA",
					"5802": "JUNTA DE VILLALBA DE LOSA",
					"5803": "JURISDICCION DE LARA",
					"5804": "JURISDICCION DE SAN ZADORNIL",
					"5805": "LERMA",
					"5806": "LLANO DE BUREBA",
					"5807": "MADRIGAL DEL MONTE",
					"5808": "MADRIGALEJO DEL MONTE",
					"5809": "MAHAMUD",
					"5810": "MAMBRILLA DE CASTREJON",
					"5811": "MAMBRILLAS DE LARA",
					"5812": "MAMOLAR",
					"5813": "MANCILES",
					"5814": "MAZUELA",
					"5815": "MECERREYES",
					"5816": "MEDINA DE POMAR",
					"5817": "MERINDAD DE CUESTA-URRIA",
					"5818": "MERINDAD DE MONTIJA",
					"5819": "MERINDAD DE SOTOSCUEVA",
					"5820": "MERINDAD DE VALDEPORRES",
					"5821": "MILAGROS",
					"5822": "MIRANDA DE EBRO",
					"5823": "MIRAVECHE",
					"5824": "MODUBAR DE LA EMPAREDADA",
					"5825": "MONASTERIO DE RODILLA",
					"5826": "MONCALVILLO",
					"5827": "MONTERRUBIO DE LA DEMANDA",
					"5828": "MONTORIO",
					"5829": "MORADILLO DE ROA",
					"5830": "NAVAS DE BUREBA",
					"5831": "NEBREDA",
					"5832": "OLMEDILLO DE ROA",
					"5833": "OÑA",
					"5834": "OQUILLAS",
					"5835": "ORBANEJA RIOPICO",
					"5836": "PADILLA DE ABAJO",
					"5837": "PADRONES DE BUREBA",
					"5838": "PALACIOS DE LA SIERRA",
					"5839": "PALACIOS DE RIOPISUERGA",
					"5840": "PALAZUELOS DE MUÑO",
					"5930": "ABAJAS",
					"5931": "ADRADA DE HAZA",
					"5932": "AGUAS CANDIDAS",
					"5933": "AGUILAR DE BUREBA",
					"5934": "ALBILLOS",
					"5935": "ALCOCERO DE MOLA",
					"5936": "ALFOZ DE BRICIA",
					"5937": "ALFOZ DE SANTA GADEA",
					"5938": "ALTABLE",
					"5939": "ALTOS (LOS)",
					"7884": "SUSINOS DEL PARAMO",
					"7885": "TINIEBLAS DE LA SIERRA",
					"7886": "TORRELARA",
					"7887": "TORTOLES DE ESGUEVA",
					"7888": "TUBILLA DEL LAGO",
					"7889": "VALDORROS",
					"7890": "VALLE DE MANZANEDO",
					"7924": "ARANDA DE DUERO",
					"7925": "ARAUZO DE TORRE",
					"7926": "ARLANZON",
					"7927": "MELGAR DE FERNAMENTAL",
					"7928": "MERINDAD DE VALDIVIELSO",
					"7929": "MONASTERIO DE LA SIERRA",
					"7930": "NAVA DE ROA",
					"7931": "NEILA",
					"7932": "OLMILLOS DE MUÑO",
					"7933": "PADILLA DE ARRIBA",
					"7934": "PALAZUELOS DE LA SIERRA",
					"7935": "PARTIDO DE LA SIERRA EN TOBALI",
					"7936": "PIERNIGAS",
					"7937": "PINILLA DE LOS BARRUECOS",
					"7938": "PRADOLUENGO",
					"7939": "QUEMADA",
					"7940": "QUINTANA DEL PIDIO",
					"7941": "QUINTANAVIDES",
					"7942": "QUINTANILLAS (LAS)",
					"7943": "RABE DE LAS CALZADAS",
					"7944": "REINOSO",
					"7945": "REVILLA Y AHEDO (LA)",
					"7946": "RIOCAVADO DE LA SIERRA",
					"7947": "RUBLACEDO DE ABAJO",
					"7948": "SALINILLAS DE BUREBA",
					"7949": "SAN MILLAN DE LARA",
					"7950": "SANTA GADEA DEL CID",
					"7951": "SANTA MARIA RIVARREDONDA"
				}
			},
			"10": {
				"nameProvincia": "Cáceres",
				"idProvincia": "10",
				"localidades": {
					"4842": "ABADIA",
					"4843": "ABERTURA",
					"4844": "ACEBO",
					"4845": "ACEHUCHE",
					"4846": "ACEITUNA",
					"4847": "AHIGAL",
					"4848": "ALBALA",
					"4849": "ALCANTARA",
					"4850": "ALCOLLARIN",
					"4851": "ALCUESCAR",
					"4852": "ALDEACENTENERA",
					"4853": "ALDEA DEL CANO",
					"4854": "ALDEA DEL OBISPO (LA)",
					"4855": "ALDEANUEVA DE LA VERA",
					"4856": "ALDEANUEVA DEL CAMINO",
					"4857": "ALDEHUELA DE JERTE",
					"4858": "ALIA",
					"4859": "ALISEDA",
					"4860": "ALMARAZ",
					"4861": "ALMOHARIN",
					"4862": "ARROYO DE LA LUZ",
					"4863": "ARROYOMOLINOS DE LA VERA",
					"4864": "ARROYOMOLINOS",
					"4865": "BAÑOS DE MONTEMAYOR",
					"4866": "BARRADO",
					"4867": "BELVIS DE MONROY",
					"4868": "BENQUERENCIA",
					"4869": "BERROCALEJO",
					"4870": "BERZOCANA",
					"4871": "BOHONAL DE IBOR",
					"4872": "BOTIJA",
					"4873": "BROZAS",
					"4874": "CABAÑAS DEL CASTILLO",
					"4875": "CABEZABELLOSA",
					"4876": "CABEZUELA DEL VALLE",
					"4877": "CABRERO",
					"4878": "CACERES",
					"4879": "CACHORRILLA",
					"4880": "CADALSO",
					"4881": "CALZADILLA",
					"4882": "CAMINOMORISCO",
					"4883": "CAMPILLO DE DELEITOSA",
					"4884": "CAMPO LUGAR",
					"4885": "CAÑAMERO",
					"4886": "CAÑAVERAL",
					"4887": "CARBAJO",
					"4888": "CARCABOSO",
					"4889": "CARRASCALEJO",
					"4890": "CASAR DE CACERES",
					"4891": "CASAR DE PALOMERO",
					"4892": "CASARES DE LAS HURDES",
					"4893": "CASAS DE DON ANTONIO",
					"4894": "CASAS DE DON GOMEZ",
					"4895": "CASAS DEL CASTAÑAR",
					"4896": "CASAS DEL MONTE",
					"4897": "CASAS DE MILLAN",
					"4898": "CASAS DE MIRAVETE",
					"4899": "CASATEJADA",
					"4900": "CASILLAS DE CORIA",
					"4901": "CASTAÑAR DE IBOR",
					"4902": "CECLAVIN",
					"4903": "CEDILLO",
					"4904": "CEREZO",
					"4905": "CILLEROS",
					"4906": "COLLADO",
					"4907": "CONQUISTA DE LA SIERRA",
					"4908": "CORIA",
					"4909": "CUACOS DE YUSTE",
					"4910": "CUMBRE (LA)",
					"4911": "DELEITOSA",
					"4912": "DESCARGAMARIA",
					"4913": "ELJAS",
					"4914": "ESCURIAL",
					"4915": "FRESNEDOSO DE IBOR",
					"4916": "GARCIAZ",
					"4917": "GARGANTA (LA)",
					"4918": "GARGANTILLA",
					"4919": "GARGÜERA",
					"4920": "GARROVILLAS DE ALCONETAR",
					"4921": "GATA",
					"4922": "GRANJA (LA)",
					"4923": "GUADALUPE",
					"4924": "GUIJO DE GALISTEO",
					"4925": "GUIJO DE GRANADILLA",
					"4926": "GUIJO DE SANTA BARBARA",
					"4927": "HERNAN-PEREZ",
					"4928": "HERRERA DE ALCANTARA",
					"4929": "HERRERUELA",
					"4930": "HIGUERA",
					"4931": "HOLGUERA",
					"4932": "HOYOS",
					"4933": "IBAHERNANDO",
					"4934": "JARAIZ DE LA VERA",
					"4935": "JARANDILLA DE LA VERA",
					"4936": "JERTE",
					"4937": "LADRILLAR",
					"4938": "LOSAR DE LA VERA",
					"4939": "MADRIGAL DE LA VERA",
					"4940": "MADROÑERA",
					"4941": "MAJADAS",
					"4942": "MALPARTIDA DE PLASENCIA",
					"4943": "MARCHAGAZ",
					"4944": "MATA DE ALCANTARA",
					"4945": "MEMBRIO",
					"4946": "MIAJADAS",
					"4947": "MILLANES",
					"4948": "MIRABEL",
					"4949": "MONROY",
					"4950": "MONTANCHEZ",
					"4951": "MONTEHERMOSO",
					"4952": "MORALEJA",
					"4953": "NAVACONCEJO",
					"4954": "NAVALMORAL DE LA MATA",
					"4955": "NAVAS DEL MADROÑO",
					"4956": "NAVEZUELAS",
					"4957": "NUÑOMORAL",
					"4958": "PALOMERO",
					"5627": "VILLA DEL REY",
					"5628": "PASARON DE LA VERA",
					"5629": "PEDROSO DE ACIM",
					"5630": "PERALEDA DE LA MATA",
					"5631": "PERALES DEL PUERTO",
					"5632": "PESCUEZA",
					"5633": "PESGA (LA)",
					"5634": "PIEDRAS ALBAS",
					"5635": "PIORNAL",
					"5636": "PLASENCIA",
					"5637": "PLASENZUELA",
					"5638": "PORTEZUELO",
					"5639": "PUERTO DE SANTA CRUZ",
					"5640": "REBOLLAR",
					"5641": "RIOLOBOS",
					"5642": "ROBLEDILLO DE GATA",
					"5643": "ROBLEDILLO DE TRUJILLO",
					"5644": "ROBLEDOLLANO",
					"5645": "ROMANGORDO",
					"5646": "RUANES",
					"5647": "SALVATIERRA DE SANTIAGO",
					"5648": "SAN MARTIN DE TREVEJO",
					"5649": "SANTA CRUZ DE LA SIERRA",
					"5650": "SANTA CRUZ DE PANIAGUA",
					"5651": "SANTIAGO DE ALCANTARA",
					"5652": "SANTIAGO DEL CAMPO",
					"5653": "SANTIBAÑEZ EL ALTO",
					"5654": "SANTIBAÑEZ EL BAJO",
					"5655": "SEGURA DE TORO",
					"5656": "SERRADILLA",
					"5657": "SIERRA DE FUENTES",
					"5658": "TALAVAN",
					"5659": "TALAYUELA",
					"5660": "TEJEDA DE TIETAR",
					"5661": "TORIL",
					"5662": "TORNAVACAS",
					"5663": "TORRECILLA DE LOS ANGELES",
					"5664": "TORRECILLAS DE LA TIESA",
					"5665": "TORRE DE SANTA MARIA",
					"5666": "TORREJONCILLO",
					"5667": "TORREJON EL RUBIO",
					"5668": "TORREMENGA",
					"6265": "TORREQUEMADA",
					"6266": "TRUJILLO",
					"6267": "VALDECAÑAS DE TAJO",
					"6268": "VALDEFUENTES",
					"6269": "VALDEHUNCAR",
					"6270": "VALDEMORALES",
					"6271": "VALDEOBISPO",
					"6272": "VALENCIA DE ALCANTARA",
					"6273": "VALVERDE DEL FRESNO",
					"6274": "VIANDAR DE LA VERA",
					"6275": "VILLA DEL CAMPO",
					"6276": "VILLAMIEL",
					"6277": "VILLANUEVA DE LA SIERRA",
					"7601": "VALDASTILLAS",
					"7602": "VALDELACASA DE TAJO",
					"7603": "VALVERDE DE LA VERA",
					"7604": "VILLAMESIAS",
					"7605": "VILLANUEVA DE LA VERA",
					"7606": "ZARZA DE MONTANCHEZ",
					"7891": "GALISTEO",
					"7892": "GARGANTA LA OLLA",
					"7893": "GARVIN",
					"7894": "GORDO (EL)",
					"7895": "GUIJO DE CORIA",
					"7896": "HERGUIJUELA",
					"7897": "HERVAS",
					"7898": "HINOJAL",
					"7899": "HUELAGA",
					"7900": "JARAICEJO",
					"7901": "JARILLA",
					"7902": "LOGROSAN",
					"7903": "MADRIGALEJO",
					"7904": "MALPARTIDA DE CACERES",
					"7905": "MESAS DE IBOR",
					"7906": "MOHEDAS DE GRANADILLA",
					"7907": "MORCILLO",
					"7908": "NAVALVILLAR DE IBOR",
					"7909": "OLIVA DE PLASENCIA",
					"7910": "PERALEDA DE SAN ROMAN",
					"7911": "PINOFRANQUEADO",
					"7912": "PORTAJE",
					"7913": "POZUELO DE ZARZON",
					"7914": "ROBLEDILLO DE LA VERA",
					"7915": "SALORINO",
					"7916": "SANTA ANA",
					"7917": "SANTA MARTA DE MAGASCA",
					"7918": "SAUCEDILLA",
					"7919": "SERREJON",
					"7920": "TALAVERUELA DE LA VERA",
					"7921": "TORNO (EL)",
					"7922": "TORRE DE DON MIGUEL",
					"7923": "TORREMOCHA",
					"4520": "VILLAR DEL PEDROSO",
					"4521": "VILLAR DE PLASENCIA",
					"4522": "VILLASBUENAS DE GATA",
					"4523": "ZARZA DE GRANADILLA",
					"4524": "ZARZA LA MAYOR",
					"4525": "ZORITA",
					"4526": "ROSALEJO",
					"4757": "TORREORGAZ",
				}
			},
			"11": {
				"nameProvincia": "Cádiz",
				"idProvincia": "11",
				"localidades": {
					"4527": "ALCALA DE LOS GAZULES",
					"4528": "ALGAR",
					"4529": "ALGECIRAS",
					"4530": "ALGODONALES",
					"4531": "BARBATE",
					"4532": "BARRIOS (LOS)",
					"4533": "BENAOCAZ",
					"4534": "BORNOS",
					"4535": "CADIZ",
					"4536": "CASTELLAR DE LA FRONTERA",
					"4537": "CHICLANA DE LA FRONTERA",
					"4538": "CHIPIONA",
					"4539": "ESPERA",
					"4540": "GASTOR (EL)",
					"4541": "JEREZ DE LA FRONTERA",
					"4542": "JIMENA DE LA FRONTERA",
					"4543": "MEDINA-SIDONIA",
					"4544": "OLVERA",
					"4545": "PATERNA DE RIVERA",
					"4546": "PRADO DEL REY",
					"4547": "PUERTO DE SANTA MARIA (EL)",
					"4548": "PUERTO REAL",
					"4549": "PUERTO SERRANO",
					"4550": "ROTA",
					"4551": "SAN FERNANDO",
					"4552": "SANLUCAR DE BARRAMEDA",
					"4553": "SAN ROQUE",
					"4554": "SETENIL DE LAS BODEGAS",
					"4555": "TARIFA",
					"4556": "TORRE ALHAQUIME",
					"4557": "TREBUJENA",
					"4558": "UBRIQUE",
					"4559": "VEJER DE LA FRONTERA",
					"4560": "VILLALUENGA DEL ROSARIO",
					"4561": "VILLAMARTIN",
					"4562": "ZAHARA",
					"4563": "BENALUP-CASAS VIEJAS",
					"4564": "SAN JOSE DEL VALLE",
					"7607": "ALCALA DEL VALLE",
					"7608": "ARCOS DE LA FRONTERA",
					"7609": "BOSQUE (EL)",
					"7610": "CONIL DE LA FRONTERA",
					"7611": "GRAZALEMA",
					"7612": "LINEA DE LA CONCEPCION (LA)"
				}
			},
			"12": {
				"nameProvincia": "Castellón / Castelló",
				"idProvincia": "12",
				"localidades": {
					"4565": "ATZENETA DEL MAESTRAT",
					"4566": "AIN",
					"4567": "ALBOCASSER",
					"4568": "ALCALA DE XIVERT",
					"4569": "ALCORA (L')",
					"4570": "ALCUDIA DE VEO",
					"4571": "ALFONDEGUILLA",
					"4572": "ALGIMIA DE ALMONACID",
					"4573": "ALMAZORA/ALMASSORA",
					"4574": "ALMEDIJAR",
					"4575": "ALMENARA",
					"4576": "ALTURA",
					"4577": "ARAÑUEL",
					"4578": "ARES DEL MAESTRE",
					"4579": "ARGELITA",
					"4580": "ARTANA",
					"4581": "AYODAR",
					"4582": "AZUEBAR",
					"4583": "BARRACAS",
					"4584": "BETXI",
					"4585": "BEJIS",
					"4586": "BENAFER",
					"4587": "BENAFIGOS",
					"4588": "BENASAL",
					"4589": "BENICARLO",
					"4590": "BENICASIM/BENICASSIM",
					"4591": "BENLLOCH",
					"4592": "BORRIOL",
					"4593": "BURRIANA",
					"4594": "CABANES",
					"4595": "CALIG",
					"4596": "CANET LO ROIG",
					"4597": "CASTELL DE CABRES",
					"4598": "CASTELLFORT",
					"4599": "CASTELLNOVO",
					"4600": "CASTELLON DE LA PLANA/CASTELLO",
					"4601": "CASTILLO DE VILLAMALEFA",
					"4602": "CATI",
					"4603": "CAUDIEL",
					"4604": "CERVERA DEL MAESTRE",
					"4605": "CINCTORRES",
					"4606": "CIRAT",
					"4607": "CORTES DE ARENOSO",
					"4608": "COSTUR",
					"4609": "COVES DE VINROMA (LES)",
					"4610": "CULLA",
					"4611": "CHERT/XERT",
					"4612": "CHILCHES/XILXES",
					"4613": "CHODOS/XODOS",
					"4614": "CHOVAR",
					"4615": "ESLIDA",
					"4616": "ESPADILLA",
					"4617": "FANZARA",
					"4618": "FIGUEROLES",
					"4619": "FORCALL",
					"4620": "FUENTE LA REINA",
					"4621": "FUENTES DE AYODAR",
					"4622": "GAIBIEL",
					"4623": "GELDO",
					"4624": "HERBES",
					"4625": "HIGUERAS",
					"4626": "JANA (LA)",
					"4627": "JERICA",
					"4628": "LUCENA DEL CID",
					"4629": "LUDIENTE",
					"4630": "LLOSA (LA)",
					"4631": "MATA DE MORELLA (LA)",
					"4632": "MATET",
					"4633": "MONCOFA",
					"4634": "MONTAN",
					"4635": "MONTANEJOS",
					"4636": "MORELLA",
					"4637": "NAVAJAS",
					"4638": "NULES",
					"4639": "OLOCAU DEL REY",
					"4640": "ONDA",
					"4641": "OROPESA DEL MAR/ORPESA",
					"4642": "PALANQUES",
					"4643": "PAVIAS",
					"4644": "PEÑISCOLA",
					"4645": "PINA DE MONTALGRAO",
					"4646": "PORTELL DE MORELLA",
					"4647": "PUEBLA DE ARENOSO",
					"4648": "POBLA DE BENIFASSA (LA)",
					"4649": "POBLA TORNESA (LA)",
					"4650": "RIBESALBES",
					"4651": "ROSSELL",
					"4652": "SACAÑET",
					"4653": "SALZADELLA (LA)",
					"4654": "SANT JORDI/SAN JORGE",
					"4655": "SANT MATEU",
					"4656": "SAN RAFAEL DEL RIO",
					"4657": "SANTA MAGDALENA DE PULPIS",
					"4658": "SARRATELLA",
					"4659": "SEGORBE",
					"4660": "SIERRA ENGARCERAN",
					"4661": "SONEJA",
					"4662": "SOT DE FERRER",
					"4663": "SUERAS/SUERA",
					"4664": "TALES",
					"4665": "TERESA",
					"4666": "TIRIG",
					"4667": "TODOLELLA",
					"4668": "TOGA",
					"4669": "TORAS",
					"4670": "TORO (EL)",
					"4671": "TORRALBA DEL PINAR",
					"4672": "TORREBLANCA",
					"4673": "TORRECHIVA",
					"4674": "TORRE D'EN BESORA (LA)",
					"4675": "TORRE ENDOMENECH",
					"4676": "TRAIGUERA",
					"4677": "USERAS/USERES (LES)",
					"4678": "VALLAT",
					"4679": "VALL D'ALBA",
					"4680": "VALL DE ALMONACID",
					"4681": "VALLIBONA",
					"4682": "VILAFAMES",
					"4683": "VILLAFRANCA DEL CID",
					"4684": "VILLAMALUR",
					"4685": "VILANOVA D'ALCOLEA",
					"4686": "VILLANUEVA DE VIVER",
					"4687": "VILAR DE CANES",
					"4688": "VILAVELLA (LA)",
					"4689": "VILLORES",
					"4690": "VINAROS",
					"4691": "VISTABELLA DEL MAESTRAZGO",
					"4692": "ZORITA DEL MAESTRAZGO",
					"4693": "ALQUERIAS DEL NIÑO PERDIDO",
					"4694": "SANT JOAN DE MORO",
					"7613": "VALL D'UIXO (LA)",
					"7614": "VILLAHERMOSA DEL RIO",
					"7615": "VILLARREAL/VILA-REAL",
					"7616": "VIVER",
					"7617": "ZUCAINA"
				}
			},
			"13": {
				"nameProvincia": "Ciudad Real",
				"idProvincia": "13",
				"localidades": {
					"4695": "AGUDO",
					"4696": "ALAMILLO",
					"4697": "ALCAZAR DE SAN JUAN",
					"4698": "ALCOBA",
					"4699": "ALCUBILLAS",
					"4700": "ALDEA DEL REY",
					"4701": "ALHAMBRA",
					"4702": "ALMADEN",
					"4703": "ALMAGRO",
					"4704": "ALMEDINA",
					"4705": "ALMURADIEL",
					"4706": "ANCHURAS",
					"4707": "ARENAS DE SAN JUAN",
					"4708": "ARGAMASILLA DE ALBA",
					"4709": "ARROBA DE LOS MONTES",
					"4710": "BALLESTEROS DE CALATRAVA",
					"4711": "BOLAÑOS DE CALATRAVA",
					"4712": "BRAZATORTAS",
					"4713": "CABEZARRUBIAS DEL PUERTO",
					"4714": "CALZADA DE CALATRAVA",
					"4715": "CAÑADA DE CALATRAVA",
					"4716": "CARACUEL DE CALATRAVA",
					"4717": "CARRION DE CALATRAVA",
					"4718": "CARRIZOSA",
					"4719": "CIUDAD REAL",
					"4720": "CORRAL DE CALATRAVA",
					"4721": "CORTIJOS (LOS)",
					"4722": "COZAR",
					"4723": "DAIMIEL",
					"4724": "FONTANAREJO",
					"4725": "FUENCALIENTE",
					"4726": "FUENLLANA",
					"4727": "FUENTE EL FRESNO",
					"4728": "GUADALMEZ",
					"4729": "HERENCIA",
					"4730": "HINOJOSAS DE CALATRAVA",
					"4731": "HORCAJO DE LOS MONTES",
					"4732": "LUCIANA",
					"4733": "MALAGON",
					"4734": "MEMBRILLA",
					"4735": "MESTANZA",
					"4736": "MIGUELTURRA",
					"4737": "MORAL DE CALATRAVA",
					"4738": "NAVAS DE ESTENA",
					"4739": "PEDRO MUÑOZ",
					"4740": "PIEDRABUENA",
					"4741": "POBLETE",
					"4742": "POZUELO DE CALATRAVA",
					"4743": "PUEBLA DE DON RODRIGO",
					"4744": "PUEBLA DEL PRINCIPE",
					"4745": "PUERTO LAPICE",
					"4746": "PUERTOLLANO",
					"4747": "RETUERTA DEL BULLAQUE",
					"4748": "SAN CARLOS DEL VALLE",
					"4749": "SAN LORENZO DE CALATRAVA",
					"4750": "SANTA CRUZ DE MUDELA",
					"4751": "SOCUELLAMOS",
					"4752": "SOLANA (LA)",
					"4753": "SOLANA DEL PINO",
					"4754": "TERRINCHES",
					"4755": "TORRALBA DE CALATRAVA",
					"4756": "TORRE DE JUAN ABAD",
					"5588": "VALDEPEÑAS",
					"5589": "VILLAHERMOSA",
					"5590": "VILLAMANRIQUE",
					"5591": "VILLAMAYOR DE CALATRAVA",
					"5592": "VILLANUEVA DE LA FUENTE",
					"5593": "VILLANUEVA DE SAN CARLOS",
					"5594": "VILLAR DEL POZO",
					"5595": "VILLARRUBIA DE LOS OJOS",
					"5596": "VILLARTA DE SAN JUAN",
					"5597": "VISO DEL MARQUES",
					"5598": "RUIDERA",
					"5599": "ARENALES DE SAN GREGORIO",
					"5600": "LLANOS DEL CAUDILLO",
					"6264": "VALDEMANCO DEL ESTERAS",
					"6735": "CASTELLAR DE SANTIAGO",
					"7400": "CHILLON",
					"7551": "VALENZUELA DE CALATRAVA",
					"7552": "VILLANUEVA DE LOS INFANTES",
					"7553": "ROBLEDO (EL)",
					"7618": "ABENOJAR",
					"7619": "ALBALADEJO",
					"7620": "ALCOLEA DE CALATRAVA",
					"7621": "ALMADENEJOS",
					"7622": "ALMODOVAR DEL CAMPO",
					"7623": "ARGAMASILLA DE CALATRAVA",
					"7624": "CABEZARADOS",
					"7625": "CAMPO DE CRIPTANA",
					"7871": "FERNAN CABALLERO",
					"7872": "GRANATULA DE CALATRAVA",
					"7873": "LABORES (LAS)",
					"7874": "MANZANARES",
					"7875": "MONTIEL",
					"7876": "NAVALPINO",
					"7877": "PICON",
					"7878": "PORZUNA",
					"7879": "POZUELOS DE CALATRAVA (LOS)",
					"7880": "SACERUELA",
					"7881": "SANTA CRUZ DE LOS CAÑAMOS",
					"7882": "TOMELLOSO",
					"7883": "TORRENUEVA"
				}
			},
			"14": {
				"nameProvincia": "Córdoba",
				"idProvincia": "14",
				"localidades": {
					"5601": "AGUILAR DE LA FRONTERA",
					"5602": "ALMEDINILLA",
					"5603": "ALMODOVAR DEL RIO",
					"5604": "BAENA",
					"5605": "BELALCAZAR",
					"5606": "BENAMEJI",
					"5607": "BUJALANCE",
					"5608": "CABRA",
					"5609": "CAÑETE DE LAS TORRES",
					"5610": "CARDEÑA",
					"5611": "CARLOTA (LA)",
					"5612": "CASTRO DEL RIO",
					"5613": "CONQUISTA",
					"5614": "DOÑA MENCIA",
					"5615": "DOS TORRES",
					"5616": "ESPEJO",
					"5617": "ESPIEL",
					"5618": "FERNAN-NUÑEZ",
					"5619": "FUENTE OBEJUNA",
					"5620": "FUENTE PALMERA",
					"5621": "FUENTE-TOJAR",
					"5622": "GUADALCAZAR",
					"5623": "GUIJO (EL)",
					"5624": "HINOJOSA DEL DUQUE",
					"5625": "IZNAJAR",
					"5626": "LUCENA",
					"6046": "MONTALBAN DE CORDOBA",
					"6047": "MONTEMAYOR",
					"6048": "MONTORO",
					"6049": "MONTURQUE",
					"6050": "NUEVA CARTEYA",
					"6051": "PALENCIANA",
					"6052": "PALMA DEL RIO",
					"6053": "PEDROCHE",
					"6054": "PEÑARROYA-PUEBLONUEVO",
					"6055": "POZOBLANCO",
					"6056": "PUENTE GENIL",
					"6057": "RAMBLA (LA)",
					"6058": "RUTE",
					"6059": "SAN SEBASTIAN DE LOS BALLESTER",
					"6060": "SANTA EUFEMIA",
					"6061": "TORRECAMPO",
					"6062": "VALENZUELA",
					"6063": "VALSEQUILLO",
					"6064": "VICTORIA (LA)",
					"6065": "VILLA DEL RIO",
					"6066": "VILLAFRANCA DE CORDOBA",
					"6067": "VILLAHARTA",
					"6068": "VILLANUEVA DE CORDOBA",
					"6069": "VILLANUEVA DEL DUQUE",
					"6070": "VILLANUEVA DEL REY",
					"6071": "VILLARALTO",
					"6072": "VILLAVICIOSA DE CORDOBA",
					"6073": "VISO (EL)",
					"6074": "ZUHEROS",
					"7554": "ADAMUZ",
					"7555": "ALCARACEJOS",
					"7556": "AÑORA",
					"7557": "BELMEZ",
					"7558": "BLAZQUEZ (LOS)",
					"7559": "CARCABUEY",
					"7560": "CARPIO (EL)",
					"7561": "CORDOBA",
					"7562": "ENCINAS REALES",
					"7563": "FUENTE LA LANCHA",
					"7564": "GRANJUELA (LA)",
					"7565": "HORNACHUELOS",
					"7566": "LUQUE",
					"7567": "MONTILLA",
					"7568": "MORILES",
					"7569": "OBEJO",
					"7570": "PEDRO ABAD",
					"7571": "POSADAS",
					"7572": "PRIEGO DE CORDOBA",
					"7573": "SANTAELLA"
				}
			},
			"15": {
				"nameProvincia": "La Coruña / A Coruña",
				"idProvincia": "15",
				"localidades": {
					"6075": "ABEGONDO",
					"6076": "AMES",
					"6077": "ARANGA",
					"6078": "ARES",
					"6079": "ARTEIXO",
					"6080": "ARZUA",
					"6081": "BAÑA (A)",
					"6082": "BERGONDO",
					"6083": "BETANZOS",
					"6084": "BOIMORTO",
					"6085": "BOIRO",
					"6086": "BOQUEIXON",
					"6087": "BRION",
					"6088": "CABANA DE BERGANTIÑOS",
					"6089": "CABANAS",
					"6090": "CAMARIÑAS",
					"6091": "CAMBRE",
					"6092": "CAPELA (A)",
					"6093": "CARBALLO",
					"6094": "CARNOTA",
					"6095": "CARRAL",
					"6096": "CEDEIRA",
					"6097": "CEE",
					"6098": "CERCEDA",
					"6099": "CERDIDO",
					"6101": "COIROS",
					"6102": "CORCUBION",
					"6103": "CORISTANCO",
					"6104": "CORUÑA (A)",
					"6105": "CULLEREDO",
					"6106": "CURTIS",
					"6107": "DODRO",
					"6108": "DUMBRIA",
					"6109": "FENE",
					"6110": "FERROL",
					"6111": "FISTERRA",
					"6112": "FRADES",
					"6113": "IRIXOA",
					"6114": "LAXE",
					"6115": "LARACHA (A)",
					"6116": "LOUSAME",
					"6117": "MALPICA DE BERGANTIÑOS",
					"6118": "MAÑON",
					"6119": "MAZARICOS",
					"6120": "MELIDE",
					"6121": "MESIA",
					"6122": "MIÑO",
					"6123": "MOECHE",
					"6124": "MONFERO",
					"6125": "MUGARDOS",
					"6126": "MUXIA",
					"6127": "MUROS",
					"6128": "NARON",
					"6129": "NEDA",
					"6130": "NEGREIRA",
					"6131": "NOIA",
					"6132": "OLEIROS",
					"6133": "ORDES",
					"6134": "OROSO",
					"6135": "ORTIGUEIRA",
					"6136": "OUTES",
					"6138": "PADERNE",
					"6139": "PADRON",
					"6140": "PINO (O)",
					"6141": "POBRA DO CARAMIÑAL (A)",
					"6142": "PONTECESO",
					"6143": "PONTEDEUME",
					"6144": "PONTES DE GARCIA RODRIGUEZ (AS",
					"6145": "PORTO DO SON",
					"6146": "RIANXO",
					"6147": "RIBEIRA",
					"6148": "ROIS",
					"6149": "SADA",
					"6150": "SAN SADURNIÑO",
					"6151": "SANTA COMBA",
					"6152": "SANTIAGO DE COMPOSTELA",
					"6153": "SANTISO",
					"6154": "SOBRADO",
					"6155": "SOMOZAS (AS)",
					"6156": "TEO",
					"6157": "TOQUES",
					"6158": "TORDOIA",
					"6159": "TOURO",
					"6160": "TRAZO",
					"6161": "VALDOVIÑO",
					"6162": "VAL DO DUBRA",
					"6163": "VEDRA",
					"6164": "VILASANTAR",
					"6165": "VILARMAIOR",
					"6166": "VIMIANZO",
					"6167": "ZAS",
					"6168": "CARIÑO"
				}
			},
			"16": {
				"nameProvincia": "Cuenca",
				"idProvincia": "16",
				"localidades": {
					"3791": "VILLAR DEL HUMO",
					"5122": "OLMEDILLA DE ALARCON",
					"5123": "OLMEDILLA DE ELIZ",
					"5124": "OSA DE LA VEGA",
					"5125": "PAJARONCILLO",
					"5126": "PALOMERA",
					"5127": "PARACUELLOS",
					"5128": "PAREDES",
					"5129": "PARRA DE LAS VEGAS (LA)",
					"5130": "PEDROÑERAS (LAS)",
					"5131": "PERAL (EL)",
					"5132": "PERALEJA (LA)",
					"5133": "PICAZO (EL)",
					"5134": "PINAREJO",
					"5135": "PIQUERAS DEL CASTILLO",
					"5136": "PORTALRUBIO DE GUADAMEJUD",
					"5137": "PORTILLA",
					"5138": "POYATOS",
					"5139": "POZORRUBIO",
					"5140": "POZUELO (EL)",
					"5141": "PROVENCIO (EL)",
					"5142": "PUEBLA DE DON FRANCISCO",
					"5143": "PUEBLA DEL SALVADOR",
					"5144": "QUINTANAR DEL REY",
					"5145": "RADA DE HARO",
					"5146": "ROZALEN DEL MONTE",
					"5147": "SAELICES",
					"5148": "SALINAS DEL MANZANO",
					"5149": "SALMERONCILLOS",
					"5150": "SALVACAÑETE",
					"5151": "SAN LORENZO DE LA PARRILLA",
					"5152": "SAN MARTIN DE BONICHES",
					"5153": "SANTA CRUZ DE MOYA",
					"5154": "SANTA MARIA DEL CAMPO RUS",
					"5155": "SANTA MARIA DE LOS LLANOS",
					"5156": "SANTA MARIA DEL VAL",
					"5157": "SOLERA DE GABALDON",
					"5158": "TARANCON",
					"5159": "TEBAR",
					"5160": "TEJADILLOS",
					"5161": "TORRALBA",
					"5162": "TORRUBIA DEL CAMPO",
					"5163": "TORRUBIA DEL CASTILLO",
					"5164": "TRAGACETE",
					"5165": "TRESJUNCOS",
					"5166": "UCLES",
					"5167": "UÑA",
					"5168": "VALDEMORILLO DE LA SIERRA",
					"5169": "VALDEMORO-SIERRA",
					"5170": "VALHERMOSO DE LA FUENTE",
					"5171": "VALSALOBRE",
					"5172": "VALVERDE DE JUCAR",
					"5173": "VARA DE REY",
					"5174": "VEGA DEL CODORNO",
					"5175": "VILLACONEJOS DE TRABAQUE",
					"5176": "VILLAESCUSA DE HARO",
					"5177": "VILLALBA DE LA SIERRA",
					"5178": "VILLALBA DEL REY",
					"5179": "VILLALGORDO DEL MARQUESADO",
					"5180": "VILLALPARDO",
					"5181": "VILLANUEVA DE GUADAMEJUD",
					"5182": "VILLANUEVA DE LA JARA",
					"5183": "VILLAR DE CAÑAS",
					"5184": "VILLAR DE DOMINGO GARCIA",
					"5185": "VILLAR DEL INFANTADO",
					"5186": "VILLAR DE OLALLA",
					"5402": "VILLAREJO DE LA PEÑUELA",
					"5403": "VILLAREJO-PERIESTEBAN",
					"5404": "VILLARES DEL SAZ",
					"5405": "VILLARRUBIO",
					"5406": "VILLARTA",
					"5407": "VILLAS DE LA VENTOSA",
					"5408": "VILLAVERDE Y PASACONSOL",
					"5409": "VILLORA",
					"5410": "VINDEL",
					"5411": "YEMEDA",
					"5412": "ZAFRA DE ZANCARA",
					"5413": "ZAFRILLA",
					"5414": "ZARZA DE TAJO",
					"5415": "ZARZUELA",
					"5416": "CAMPOS DEL PARAISO",
					"5417": "VALDETORTOLA",
					"5418": "VALERAS (LAS)",
					"5419": "FUENTENAVA DE JABAGA",
					"5420": "ARCAS DEL VILLAR",
					"5421": "VALDECOLMENAS (LOS)",
					"5422": "POZORRUBIELOS DE LA MANCHA",
					"5423": "SOTORRIBAS",
					"5424": "VILLAR Y VELASCO",
					"5581": "OLMEDA DE LA CUESTA",
					"6169": "ABIA DE LA OBISPALIA",
					"6170": "ACEBRON (EL)",
					"6171": "ALARCON",
					"6172": "ALBALADEJO DEL CUENDE",
					"6173": "ALBALATE DE LAS NOGUERAS",
					"6174": "ALBENDEA",
					"6175": "ALBERCA DE ZANCARA (LA)",
					"6176": "ALCALA DE LA VEGA",
					"6177": "ALCANTUD",
					"6178": "ALCAZAR DEL REY",
					"6179": "ALCOHUJATE",
					"6180": "ALCONCHEL DE LA ESTRELLA",
					"6181": "ALGARRA",
					"6182": "ALIAGUILLA",
					"6183": "ALMARCHA (LA)",
					"6184": "ALMENDROS",
					"6185": "ALMODOVAR DEL PINAR",
					"6186": "ALMONACID DEL MARQUESADO",
					"6187": "ALTAREJOS",
					"6188": "ARANDILLA DEL ARROYO",
					"6189": "ARCOS DE LA SIERRA",
					"6190": "CHILLARON DE CUENCA",
					"6191": "ARGUISUELAS",
					"6192": "ARRANCACEPAS",
					"6193": "ATALAYA DEL CAÑAVATE",
					"6194": "BARAJAS DE MELO",
					"6195": "BARCHIN DEL HOYO",
					"6196": "BASCUÑANA DE SAN PEDRO",
					"6197": "BEAMUD",
					"6198": "BELINCHON",
					"6199": "BELMONTEJO",
					"6200": "BETETA",
					"6201": "BUCIEGAS",
					"6202": "BUENACHE DE LA SIERRA",
					"6203": "BUENDIA",
					"6204": "CAMPILLO DE ALTOBUEY",
					"6205": "CAMPILLOS-PARAVIENTOS",
					"6206": "CANALEJAS DEL ARROYO",
					"6207": "CAÑADA DEL HOYO",
					"6208": "CAÑADA JUNCOSA",
					"6209": "CAÑAVATE (EL)",
					"6210": "CAÑAVERAS",
					"6211": "CAÑETE",
					"6212": "CAÑIZARES",
					"6213": "CARBONERAS DE GUADAZAON",
					"6214": "CARRASCOSA",
					"6215": "CARRASCOSA DE HARO",
					"6216": "CASAS DE FERNANDO ALONSO",
					"6217": "CASAS DE GARCIMOLINA",
					"6218": "CASAS DE GUIJARRO",
					"6219": "CASAS DE LOS PINOS",
					"6220": "CASASIMARRO",
					"6221": "CASTEJON",
					"6222": "CASTILLEJO-SIERRA",
					"6223": "CASTILLO-ALBARAÑEZ",
					"6224": "CASTILLO DE GARCIMUÑOZ",
					"6225": "CERVERA DEL LLANO",
					"6226": "CUENCA",
					"6227": "CUEVA DEL HIERRO",
					"6228": "ENGUIDANOS",
					"6229": "FRESNEDA DE ALTAREJOS",
					"6230": "FRONTERA (LA)",
					"6231": "FUENTE DE PEDRO NAHARRO",
					"6232": "FUENTELESPINO DE HARO",
					"6233": "FUENTELESPINO DE MOYA",
					"6234": "FUERTESCUSA",
					"6235": "GABALDON",
					"6236": "GASCUEÑA",
					"6237": "GRAJA DE CAMPALBO",
					"6238": "HENAREJOS",
					"6239": "HERRUMBLAR (EL)",
					"6240": "HINOJOSA (LA)",
					"6241": "HITO (EL)",
					"6242": "HONRUBIA",
					"6243": "HONTANAYA",
					"6244": "HORCAJO DE SANTIAGO",
					"6245": "HUELAMO",
					"6246": "HUERGUINA",
					"6247": "HUERTA DE LA OBISPALIA",
					"6248": "HUETE",
					"6249": "INIESTA",
					"6250": "LAGUNA DEL MARQUESADO",
					"6251": "LAGUNASECA",
					"6252": "LEDAÑA",
					"6253": "MAJADAS (LAS)",
					"6254": "MARIANA",
					"6255": "MESAS (LAS)",
					"6256": "MINGLANILLA",
					"6257": "MONREAL DEL LLANO",
					"6258": "MONTALBO",
					"6259": "MONTEAGUDO DE LAS SALINAS",
					"6260": "MOTA DE ALTAREJOS",
					"6261": "MOTILLA DEL PALANCAR",
					"6262": "MOYA",
					"6263": "NARBONETA",
					"7508": "OLMEDA DEL REY",
					"7509": "PAJARON",
					"7510": "PALOMARES DEL CAMPO",
					"7511": "PEDERNOSO (EL)",
					"7512": "PESQUERA (LA)",
					"7513": "PINEDA DE GIGÜELA",
					"7514": "POZOAMARGO",
					"7515": "PRIEGO",
					"7516": "PUEBLA DE ALMENARA",
					"7517": "REILLO",
					"7518": "SACEDA-TRASIERRA",
					"7519": "SAN CLEMENTE",
					"7520": "SAN PEDRO PALMICHES",
					"7521": "SISANTE",
					"7522": "TALAYUELAS",
					"7523": "TINAJAS",
					"7524": "TORREJONCILLO DEL REY",
					"7525": "TRIBALDOS",
					"7526": "VALDEMECA",
					"7527": "VALDEOLIVAS",
					"7528": "VALVERDEJO",
					"7529": "VELLISCA",
					"7530": "VILLAGARCIA DEL LLANO",
					"7531": "VILLAMAYOR DE SANTIAGO",
					"7532": "VILLAR DE LA ENCINA",
					"7533": "VILLAREJO DE FUENTES",
					"7574": "BELMONTE",
					"7575": "BONICHES",
					"7576": "BUENACHE DE ALARCON",
					"7577": "CAMPILLOS-SIERRA",
					"7578": "CAÑAMARES",
					"7579": "CAÑAVERUELAS",
					"7580": "CARDENETE",
					"7581": "CASAS DE BENITEZ",
					"7582": "CASAS DE HARO",
					"7583": "CASTILLEJO DE INIESTA",
					"7584": "CIERVA (LA)",
					"7585": "CHUMILLAS",
					"7586": "FRESNEDA DE LA SIERRA",
					"7587": "FUENTES",
					"7588": "GARABALLA",
					"7589": "GRAJA DE INIESTA",
					"7590": "HINOJOSOS (LOS)",
					"7591": "HONTECILLAS",
					"7592": "HUELVES",
					"7593": "HUERTA DEL MARQUESADO",
					"7594": "LANDETE",
					"7595": "LEGANIEL",
					"7596": "MASEGOSA",
					"7597": "MIRA",
					"7598": "MONTALBANEJO",
					"7599": "MOTA DEL CUERVO",
					"7600": "OLIVARES DE JUCAR"
				}
			},
			"17": {
				"nameProvincia": "Gerona / Girona",
				"idProvincia": "17",
				"localidades": {
					"4168": "SUSQUEDA",
					"4169": "TALLADA D'EMPORDA (LA)",
					"4170": "TORRENT",
					"4171": "TORROELLA DE FLUVIA",
					"4172": "TORTELLA",
					"4173": "TOSES",
					"4174": "TOSSA DE MAR",
					"4175": "ULTRAMORT",
					"4176": "ULLASTRET",
					"4177": "VALL D'EN BAS (LA)",
					"4178": "VALL-LLOBREGA",
					"4179": "VENTALLO",
					"4180": "VERGES",
					"4181": "VIDRA",
					"4182": "VILABERTRAN",
					"4183": "VILABLAREIX",
					"4184": "VILADAMAT",
					"4185": "VILADEMULS",
					"4186": "VILAFANT",
					"4187": "VILAÜR",
					"4188": "VILALLONGA DE TER",
					"4189": "VILAMACOLUM",
					"4190": "VILAMANISCLE",
					"4191": "VILANANT",
					"4192": "VILOPRIU",
					"4193": "VILOBI D'ONYAR",
					"4194": "CRUïLLES, MONELLS I SANT SADUR",
					"4195": "SANT JULIA DEL LLOR I BONMATI",
					"5097": "SILS",
					"5425": "AGULLANA",
					"5426": "AIGUAVIVA",
					"5427": "ALBANYA",
					"5428": "ALBONS",
					"5429": "FAR D'EMPORDA (EL)",
					"5430": "ALP",
					"5431": "AMER",
					"5432": "ANGLES",
					"5433": "ARBUCIES",
					"5434": "ARGELAGUER",
					"5435": "ARMENTERA (L')",
					"5436": "AVINYONET DE PUIGVENTOS",
					"5437": "BEGUR",
					"5438": "VAJOL (LA)",
					"5439": "BANYOLES",
					"5440": "BASCARA",
					"5441": "BELLCAIRE D'EMPORDA",
					"5442": "BESALU",
					"5443": "BESCANO",
					"5444": "BEUDA",
					"5445": "BISBAL D'EMPORDA (LA)",
					"5446": "BLANES",
					"5447": "BOLVIR",
					"5448": "BORDILS",
					"5449": "BORRASSA",
					"5450": "BREDA",
					"5451": "BRUNYOLA",
					"5452": "BOADELLA D'EMPORDA",
					"5453": "CABANES",
					"5454": "CABANELLES",
					"5455": "CADAQUES",
					"5456": "CALDES DE MALAVELLA",
					"5457": "CALONGE",
					"5458": "CAMOS",
					"5459": "CAMPDEVANOL",
					"5460": "CAMPELLES",
					"5461": "CAMPLLONG",
					"5462": "CAMPRODON",
					"5463": "CANET D'ADRI",
					"5464": "CANTALLOPS",
					"5465": "CAPMANY",
					"5466": "QUERALBS",
					"5467": "CASSA DE LA SELVA",
					"5468": "CASTELLFOLLIT DE LA ROCA",
					"5469": "CASTELLO D'EMPURIES",
					"5470": "CASTELL-PLATJA D'ARO",
					"5471": "CELRA",
					"5472": "CERVIA DE TER",
					"5473": "CISTELLA",
					"5474": "SIURANA",
					"5475": "COLERA",
					"5476": "COLOMERS",
					"5477": "CORNELLA DEL TERRI",
					"5478": "CORÇA",
					"5479": "CRESPIA",
					"5480": "DARNIUS",
					"5481": "DAS",
					"5482": "ESCALA (L')",
					"5483": "ESPINELVES",
					"5484": "ESPOLLA",
					"5485": "ESPONELLA",
					"5486": "FIGUERES",
					"5487": "FLAÇA",
					"5488": "FOIXA",
					"5489": "FONTANALS DE CERDANYA",
					"5490": "FONTANILLES",
					"5491": "FONTCOBERTA",
					"5492": "FORNELLS DE LA SELVA",
					"5493": "FORTIA",
					"5494": "GARRIGAS",
					"5495": "GARRIGOLES",
					"5496": "GARRIGUELLA",
					"5497": "GER",
					"5498": "GIRONA",
					"5499": "GOMBREN",
					"5500": "GUALTA",
					"5501": "GUILS DE CERDANYA",
					"5502": "HOSTALRIC",
					"5503": "ISOVOL",
					"5504": "JAFRE",
					"5505": "JONQUERA (LA)",
					"5506": "JUIA",
					"5507": "LLADO",
					"5508": "LLAGOSTERA",
					"5509": "LLAMBILLES",
					"5510": "LLANARS",
					"5511": "LLANÇA",
					"5512": "LLERS",
					"5513": "LLIVIA",
					"5514": "LLORET DE MAR",
					"5515": "LLOSSES (LES)",
					"5516": "MADREMANYA",
					"5517": "MAIA DE MONTCAL",
					"5518": "MERANGES",
					"5519": "MASARAC",
					"5520": "MASSANES",
					"5521": "MAÇANET DE CABRENYS",
					"5522": "MAÇANET DE LA SELVA",
					"5523": "MIERES",
					"5524": "MOLLET DE PERALADA",
					"5525": "MOLLO",
					"5526": "MONTAGUT",
					"5527": "MONT-RAS",
					"5528": "NAVATA",
					"5529": "OGASSA",
					"5530": "OLOT",
					"5531": "ORDIS",
					"5532": "OSOR",
					"5533": "PALAFRUGELL",
					"5534": "PALAMOS",
					"5535": "PALAU DE SANTA EULALIA",
					"5536": "PALAU-SAVERDERA",
					"5537": "PALAU-SATOR",
					"5538": "PALOL DE REVARDIT",
					"5539": "PARDINES",
					"5540": "PAU",
					"5541": "PEDRET I MARZA",
					"5542": "PERALADA",
					"5543": "PLANES D'HOSTOLES (LES)",
					"5544": "PONT DE MOLINS",
					"5545": "PONTOS",
					"5546": "PORTBOU",
					"5547": "PRESES (LES)",
					"5548": "PUIGCERDA",
					"5549": "QUART",
					"5550": "RABOS",
					"5551": "REGENCOS",
					"5552": "RIELLS I VIABREA",
					"5553": "RIPOLL",
					"5554": "RIUDARENES",
					"5555": "RIUDELLOTS DE LA SELVA",
					"5556": "ROSES",
					"5557": "RUPIA",
					"5558": "SALT",
					"5559": "SANT ANDREU SALOU",
					"5560": "SANT CLIMENT SESCEBES",
					"5561": "SANT FELIU DE GUIXOLS",
					"5562": "SANT FELIU DE PALLEROLS",
					"5563": "SANT FERRIOL",
					"5564": "SANT GREGORI",
					"5565": "SANT HILARI SACALM",
					"5566": "SANT JORDI DESVALLS",
					"5567": "SANT JOAN DE LES ABADESSES",
					"5568": "SANT JOAN DE MOLLET",
					"5569": "SANT JULIA DE RAMIS",
					"5570": "SANT LLORENÇ DE LA MUGA",
					"5571": "SANT MARTI DE LLEMENA",
					"5572": "SANT MARTI VELL",
					"5573": "SANT MIQUEL DE CAMPMAJOR",
					"5574": "SANT MORI",
					"5575": "SANT PAU DE SEGURIES",
					"5576": "SANT PERE PESCADOR",
					"5577": "SANTA COLOMA DE FARNERS",
					"5578": "SANTA LLOGAIA D'ÀLGUEMA",
					"5579": "SANT ANIOL DE FINESTRES",
					"5580": "SANTA PAU",
					"5582": "SARRIA DE TER",
					"5583": "SAUS",
					"5584": "SELVA DE MAR (LA)",
					"5585": "SERINYA",
					"5586": "SERRA DE DARO",
					"5587": "SETCASES",
					"7447": "TERRADES",
					"7448": "TORROELLA DE MONTGRI",
					"7449": "ULLA",
					"7450": "URUS",
					"7451": "VALL DE BIANYA (LA)",
					"7452": "VIDRERES",
					"7453": "VILADASENS",
					"7454": "VILADRAU",
					"7455": "VILAJUïGA",
					"7456": "VILAMALLA",
					"7457": "VILA-SACRA",
					"7458": "BIURE",
					"7459": "FORALLAC",
					"7534": "PALS",
					"7535": "PARLAVA",
					"7536": "PERA (LA)",
					"7537": "PLANOLES",
					"7538": "PORQUERES",
					"7539": "PORT DE LA SELVA (EL)",
					"7540": "RIBES DE FRESER",
					"7541": "RIUDAURA",
					"7542": "RIUMORS",
					"7543": "SALES DE LLIERCA",
					"7544": "SANT FELIU DE BUIXALLEU",
					"7545": "SANT JAUME DE LLIERCA",
					"7546": "VALLFOGONA DE RIPOLLES",
					"7547": "SANT MIQUEL DE FLUVIA",
					"7548": "SANTA CRISTINA D'ARO",
					"7549": "SANT JOAN LES FONTS",
					"7550": "CELLERA DE TER (LA)"
				}
			},
			"18": {
				"nameProvincia": "Granada",
				"idProvincia": "18",
				"localidades": {
					"4196": "AGRON",
					"4197": "ALBOLOTE",
					"4198": "ALBONDON",
					"4199": "ALBUÑOL",
					"4200": "ALBUÑUELAS",
					"4201": "ALFACAR",
					"4202": "ALGARINEJO",
					"4203": "ALHENDIN",
					"4204": "ALICUN DE ORTEGA",
					"4205": "ALMEGIJAR",
					"4206": "ALQUIFE",
					"4207": "ARENAS DEL REY",
					"4208": "ATARFE",
					"4209": "BAZA",
					"4210": "BEAS DE GUADIX",
					"4211": "BENALUA",
					"4212": "BENALUA DE LAS VILLAS",
					"4213": "BERCHULES",
					"4214": "BUBION",
					"4215": "CACIN",
					"4216": "CADIAR",
					"4217": "CALICASAS",
					"4218": "CANILES",
					"4219": "CAÑAR",
					"4220": "CARATAUNAS",
					"4221": "CASTARAS",
					"4222": "CASTRIL",
					"4223": "CENES DE LA VEGA",
					"4224": "CIJUELA",
					"4225": "COGOLLOS DE LA VEGA",
					"4226": "COLOMERA",
					"4227": "CORTES DE BAZA",
					"4228": "CULLAR",
					"4229": "CULLAR VEGA",
					"4230": "CHAUCHINA",
					"4231": "CHURRIANA DE LA VEGA",
					"4232": "DARRO",
					"4233": "DEIFONTES",
					"4234": "DIEZMA",
					"4235": "DILAR",
					"4236": "DOLAR",
					"4237": "DURCAL",
					"4238": "FERREIRA",
					"4239": "FONELAS",
					"4240": "FUENTE VAQUEROS",
					"4241": "GOBERNADOR",
					"4242": "GOJAR",
					"4243": "GORAFE",
					"4244": "GUADAHORTUNA",
					"4245": "GUALCHOS",
					"4246": "GÜEJAR SIERRA",
					"4247": "HUELAGO",
					"4248": "HUENEJA",
					"4249": "HUETOR DE SANTILLAN",
					"4250": "HUETOR VEGA",
					"4251": "ILLORA",
					"4252": "ITRABO",
					"4253": "JAYENA",
					"4254": "JEREZ DEL MARQUESADO",
					"4255": "JUN",
					"4256": "CALAHORRA (LA)",
					"4257": "LANJARON",
					"4258": "LANTEIRA",
					"4259": "LENTEGI",
					"4260": "LOJA",
					"4261": "LUGROS",
					"4262": "MALAHA (LA)",
					"4263": "MARACENA",
					"4264": "MARCHAL",
					"4265": "MOCLIN",
					"4266": "MOLVIZAR",
					"4267": "MONACHIL",
					"4268": "MONTEFRIO",
					"4269": "MONTEJICAR",
					"4270": "MONTILLANA",
					"4959": "MORALEDA DE ZAFAYONA",
					"4960": "MOTRIL",
					"4961": "MURTAS",
					"4962": "NIGÜELAS",
					"4963": "NIVAR",
					"4964": "OGIJARES",
					"4965": "ORCE",
					"4966": "ORGIVA",
					"4967": "OTIVAR",
					"4968": "OTURA",
					"4969": "PADUL",
					"4970": "PAMPANEIRA",
					"4971": "PEDRO MARTINEZ",
					"4972": "PELIGROS",
					"4973": "PEZA (LA)",
					"4974": "PINOS GENIL",
					"4975": "PINOS PUENTE",
					"4976": "PIÑAR",
					"4977": "POLICAR",
					"4978": "POLOPOS",
					"4979": "PORTUGOS",
					"4980": "PUEBLA DE DON FADRIQUE",
					"4981": "PULIANAS",
					"4982": "PURULLENA",
					"4983": "QUENTAR",
					"4984": "RUBITE",
					"4985": "SALAR",
					"4986": "SALOBREÑA",
					"4987": "SANTA CRUZ DEL COMERCIO",
					"4988": "SANTA FE",
					"4989": "SOPORTUJAR",
					"4990": "SORVILAN",
					"4991": "TORRE-CARDELA",
					"4992": "TORVIZCON",
					"4993": "TREVELEZ",
					"4994": "TURON",
					"4995": "UGIJAR",
					"4996": "VALOR",
					"4997": "VELEZ DE BENAUDALLA",
					"4998": "VENTAS DE HUELMA",
					"4999": "VILLANUEVA DE LAS TORRES",
					"5000": "VILLANUEVA MESIA",
					"5001": "VIZNAR",
					"5002": "ZAFARRAYA",
					"5003": "ZUBIA (LA)",
					"5004": "ZUJAR",
					"5005": "TAHA (LA)",
					"5006": "VALLE (EL)",
					"5007": "NEVADA",
					"5008": "ALPUJARRA DE LA SIERRA",
					"5009": "GABIAS (LAS)",
					"5010": "GUAJARES (LOS)",
					"5011": "VALLE DEL ZALABI",
					"5012": "VILLAMENA",
					"5013": "MORELABOR",
					"5014": "PINAR (EL)",
					"5015": "VEGAS DEL GENIL",
					"5016": "CUEVAS DEL CAMPO",
					"5017": "ZAGRA",
					"7460": "ALAMEDILLA",
					"7461": "ALBUÑAN",
					"7462": "ALDEIRE",
					"7463": "ALHAMA DE GRANADA",
					"7464": "ALMUÑECAR",
					"7465": "ARMILLA",
					"7466": "BEAS DE GRANADA",
					"7467": "BENAMAUREL",
					"7468": "BUSQUISTAR",
					"7469": "CAJAR",
					"7470": "CAMPOTEJAR",
					"7471": "CAPILEIRA",
					"7472": "CASTILLEJAR",
					"7473": "COGOLLOS DE GUADIX",
					"7474": "CORTES Y GRAENA",
					"7475": "CHIMENEAS",
					"7476": "DEHESAS DE GUADIX",
					"7477": "DUDAR",
					"7478": "ESCUZAR",
					"7479": "FREILA",
					"7480": "GALERA",
					"7481": "GOR",
					"7482": "GRANADA",
					"7483": "GUADIX",
					"7484": "GÜEVEJAR",
					"7485": "HUESCAR",
					"7486": "HUETOR TAJAR",
					"7487": "IZNALLOZ",
					"7488": "JETE",
					"7489": "JUVILES",
					"7490": "LACHAR",
					"7491": "LECRIN",
					"7492": "LOBRAS",
					"7493": "LUJAR"
				}
			},
			"19": {
				"nameProvincia": "Guadalajara",
				"idProvincia": "19",
				"localidades": {
					"3217": "HUERMECES DEL CERRO",
					"3218": "HUERTAHERNANDO",
					"3219": "HUEVA",
					"3220": "HUMANES",
					"3221": "ILLANA",
					"3222": "INIESTOLA",
					"3223": "INVIERNAS (LAS)",
					"3224": "IRUESTE",
					"3225": "JADRAQUE",
					"3226": "JIRUEQUE",
					"3227": "LEDANCA",
					"3228": "LUPIANA",
					"3229": "LUZAGA",
					"3230": "LUZON",
					"3231": "MALAGA DEL FRESNO",
					"3232": "MALAGUILLA",
					"3233": "MANTIEL",
					"3234": "MARANCHON",
					"3235": "MASEGOSO DE TAJUÑA",
					"3236": "MATARRUBIA",
					"3237": "MAZARETE",
					"3238": "MAZUECOS",
					"3239": "MEGINA",
					"3240": "MEMBRILLERA",
					"3241": "MIERLA (LA)",
					"3242": "MILMARCOS",
					"3243": "MILLANA",
					"3244": "MIRABUENO",
					"3245": "MIRALRIO",
					"3246": "MOCHALES",
					"3247": "MOLINA DE ARAGON",
					"3248": "MONASTERIO",
					"3249": "MONTARRON",
					"3250": "MORATILLA DE LOS MELEROS",
					"3251": "MUDUEX",
					"3252": "NAVAS DE JADRAQUE (LAS)",
					"3253": "OCENTEJO",
					"3254": "OLMEDA DE COBETA",
					"3255": "OLMEDA DE JADRAQUE (LA)",
					"3256": "ORDIAL (EL)",
					"3257": "PALMACES DE JADRAQUE",
					"3258": "PAREDES DE SIGÜENZA",
					"3259": "PASTRANA",
					"3260": "PEDREGAL (EL)",
					"3261": "PEÑALVER",
					"3262": "PERALVECHE",
					"3263": "PINILLA DE JADRAQUE",
					"3264": "PINILLA DE MOLINA",
					"3265": "PIOZ",
					"3266": "PIQUERAS",
					"3267": "POVEDA DE LA SIERRA",
					"3268": "POZO DE ALMOGUERA",
					"3269": "POZO DE GUADALAJARA",
					"3270": "PRADENA DE ATIENZA",
					"3271": "PUEBLA DE BELEÑA",
					"3272": "PUEBLA DE VALLES",
					"3273": "QUER",
					"3274": "RECUENCO (EL)",
					"3275": "RENERA",
					"3276": "RETIENDAS",
					"3277": "RIBA DE SAELICES",
					"3278": "RIOFRIO DEL LLANO",
					"3279": "ROBLEDILLO DE MOHERNANDO",
					"3280": "ROMANILLOS DE ATIENZA",
					"3281": "ROMANONES",
					"3282": "RUEDA DE LA SIERRA",
					"3283": "SACECORBO",
					"3284": "SAELICES DE LA SAL",
					"3285": "SAN ANDRES DEL CONGOSTO",
					"3286": "SAN ANDRES DEL REY",
					"3287": "SAUCA",
					"3288": "SAYATON",
					"3289": "SETILES",
					"3290": "SIENES",
					"3291": "SOLANILLOS DEL EXTREMO",
					"3292": "SOTILLO (EL)",
					"3293": "SOTODOSOS",
					"3294": "TARAGUDO",
					"3295": "TARAVILLA",
					"3296": "TENDILLA",
					"3297": "TERZAGA",
					"3298": "TOBA (LA)",
					"3299": "TORDELRABANO",
					"3300": "TORDESILOS",
					"3301": "TORIJA",
					"3302": "TORRECUADRADILLA",
					"3303": "TORRE DEL BURGO",
					"3304": "TORREJON DEL REY",
					"3305": "TORREMOCHA DE JADRAQUE",
					"3306": "TORREMOCHA DEL PINAR",
					"3307": "TORREMOCHUELA",
					"3308": "TORRUBIA",
					"3309": "TORTOLA DE HENARES",
					"3310": "TORTUERO",
					"3311": "TRAID",
					"3312": "TRILLO",
					"3313": "UCEDA",
					"3314": "UTANDE",
					"3315": "VALDEARENAS",
					"3316": "VALDEAVELLANO",
					"3317": "VALDEAVERUELO",
					"3318": "VALDEGRUDAS",
					"3319": "VALDELCUBO",
					"3320": "VALDEPEÑAS DE LA SIERRA",
					"3321": "VALDERREBOLLO",
					"3322": "VALDESOTOS",
					"3323": "VALFERMOSO DE TAJUÑA",
					"3324": "VALTABLADO DEL RIO",
					"3325": "VALVERDE DE LOS ARROYOS",
					"3326": "VILLANUEVA DE ALCORON",
					"3327": "VILLANUEVA DE ARGECILLA",
					"3328": "VILLANUEVA DE LA TORRE",
					"3329": "VILLARES DE JADRAQUE",
					"3330": "VILLASECA DE HENARES",
					"3331": "VILLASECA DE UCEDA",
					"3332": "VILLEL DE MESA",
					"3333": "VIÑUELAS",
					"3334": "YEBES",
					"3335": "YEBRA",
					"3336": "YELAMOS DE ABAJO",
					"3337": "YELAMOS DE ARRIBA",
					"3338": "YUNQUERA DE HENARES",
					"3339": "YUNTA (LA)",
					"4029": "SEMILLAS",
					"4138": "HUERCE (LA)",
					"4516": "ZAOREJAS",
					"4517": "ZARZUELA DE JADRAQUE",
					"4518": "ZORITA DE LOS CANES",
					"5018": "ABANADES",
					"5019": "ABLANQUE",
					"5020": "ADOBES",
					"5021": "ALAMINOS",
					"5022": "ALARILLA",
					"5023": "ALBALATE DE ZORITA",
					"5024": "ALBARES",
					"5025": "ALBENDIEGO",
					"5026": "ALCOCER",
					"5027": "ALCOLEA DE LAS PEÑAS",
					"5028": "ALCOLEA DEL PINAR",
					"5029": "ALCOROCHES",
					"5030": "ALDEANUEVA DE GUADALAJARA",
					"5031": "ALGAR DE MESA",
					"5032": "ALGORA",
					"5033": "ALHONDIGA",
					"5034": "ALIQUE",
					"5035": "ALMADRONES",
					"5036": "ALMOGUERA",
					"5037": "ALMONACID DE ZORITA",
					"5038": "ALOCEN",
					"5039": "ALOVERA",
					"5040": "ALUSTANTE",
					"5041": "ANGON",
					"5042": "ANGUITA",
					"5043": "ANQUELA DEL DUCADO",
					"5044": "ANQUELA DEL PEDREGAL",
					"5045": "ARANZUEQUE",
					"5046": "ARBANCON",
					"5047": "ARBETETA",
					"5048": "ARGECILLA",
					"5049": "ARMALLONES",
					"5050": "ARMUÑA DE TAJUÑA",
					"5051": "ARROYO DE LAS FRAGUAS",
					"5052": "ATANZON",
					"5053": "ATIENZA",
					"5054": "AUÑON",
					"5055": "AZUQUECA DE HENARES",
					"5056": "BAIDES",
					"5057": "BAÑOS DE TAJO",
					"5058": "BAÑUELOS",
					"5059": "BARRIOPEDRO",
					"5060": "BERNINCHES",
					"5061": "BODERA (LA)",
					"5062": "BRIHUEGA",
					"5063": "BUDIA",
					"5064": "BUJALARO",
					"5065": "BUSTARES",
					"5066": "CABANILLAS DEL CAMPO",
					"5067": "CAMPILLO DE DUEÑAS",
					"5068": "CAMPILLO DE RANAS",
					"5069": "CAMPISABALOS",
					"5070": "CANREDONDO",
					"5071": "CANTALOJAS",
					"5072": "CAÑIZAR",
					"5073": "CARDOSO DE LA SIERRA (EL)",
					"5074": "CASA DE UCEDA",
					"5075": "CASAR (EL)",
					"5076": "CASAS DE SAN GALINDO",
					"5077": "CASPUEÑAS",
					"5078": "CASTEJON DE HENARES",
					"5079": "CASTELLAR DE LA MUELA",
					"5080": "CASTILFORTE",
					"5081": "CASTILNUEVO",
					"5082": "CENDEJAS DE ENMEDIO",
					"5083": "CENDEJAS DE LA TORRE",
					"5084": "CENTENERA",
					"5085": "CINCOVILLAS",
					"5086": "CIRUELAS",
					"5087": "COBETA",
					"5088": "COGOLLOR",
					"5089": "COGOLLUDO",
					"5090": "CONDEMIOS DE ABAJO",
					"5091": "CONGOSTRINA",
					"5092": "COPERNAL",
					"5093": "CORDUENTE",
					"5094": "CHECA",
					"5095": "CHEQUILLA",
					"5096": "CHILOECHES",
					"5098": "DRIEBES",
					"5099": "DURON",
					"5100": "EMBID",
					"5101": "ESCAMILLA",
					"5102": "ESCOPETE",
					"5103": "ESPINOSA DE HENARES",
					"5104": "ESTABLES",
					"5105": "ESTRIEGANA",
					"5106": "FUEMBELLIDA",
					"5107": "FUENCEMILLAN",
					"5108": "FUENTELENCINA",
					"5109": "FUENTELSAZ",
					"5110": "FUENTELVIEJO",
					"5111": "FUENTENOVILLA",
					"5112": "GAJANEJOS",
					"5113": "GALVE DE SORBE",
					"5114": "GASCUEÑA DE BORNOVA",
					"5115": "HENCHE",
					"5116": "HERAS DE AYUSO",
					"5117": "HIENDELAENCINA",
					"5118": "HIJES",
					"5119": "HOMBRADOS",
					"5120": "HORCHE",
					"5121": "HORTEZUELA DE OCEN",
					"6732": "LORANCA DE TAJUÑA",
					"6733": "MAJAELRAYO",
					"6734": "MANDAYONA",
					"6964": "MARCHAMALO",
					"6965": "MATILLAS",
					"7401": "MEDRANDA",
					"7402": "MIEDES DE ATIENZA",
					"7403": "MIÑOSA (LA)",
					"7404": "MOHERNANDO",
					"7405": "MONDEJAR",
					"7406": "MORENILLA",
					"7407": "NEGREDO",
					"7408": "OLIVAR (EL)",
					"7409": "OREA",
					"7410": "PARDOS",
					"7411": "PAREJA",
					"7412": "PEÑALEN",
					"7413": "PERALEJOS DE LAS TRUCHAS",
					"7414": "POBO DE DUEÑAS (EL)",
					"7415": "PRADOS REDONDOS",
					"7416": "REBOLLOSA DE JADRAQUE",
					"7417": "RILLO DE GALLO",
					"7418": "ROBLEDO DE CORPES",
					"7419": "SACEDON",
					"7420": "SALMERON",
					"7421": "SANTIUSTE",
					"7422": "SELAS",
					"7423": "SIGÜENZA",
					"7424": "SOMOLINOS",
					"7425": "TAMAJON",
					"7426": "TARTANEDO",
					"7427": "TIERZO",
					"7428": "TORDELLEGO",
					"7429": "TORRECUADRADA DE MOLINA",
					"7430": "TORREMOCHA DEL CAMPO",
					"7431": "TORTUERA",
					"7432": "TRIJUEQUE",
					"7433": "UJADOS",
					"7434": "VALDARACHAS",
					"7435": "VALDECONCHA",
					"7436": "VALDENUÑO FERNANDEZ",
					"7437": "VALHERMOSO",
					"7438": "VIANA DE JADRAQUE",
					"7494": "CIFUENTES",
					"7495": "CIRUELOS DEL PINAR",
					"7496": "CONDEMIOS DE ARRIBA",
					"7497": "CUBILLO DE UCEDA (EL)",
					"7498": "CHILLARON DEL REY",
					"7499": "ESCARICHE",
					"7500": "ESPLEGARES",
					"7501": "FONTANAR",
					"7502": "FUENTELAHIGUERA DE ALBATAGES",
					"7503": "GALAPAGOS",
					"7504": "GUADALAJARA",
					"7505": "HERRERIA",
					"7506": "HITA",
					"7507": "HONTOBA"
				}
			},
			"20": {
				"nameProvincia": "Guipúzcoa / Gipuzkoa",
				"idProvincia": "20",
				"localidades": {
					"4030": "ABALTZISKETA",
					"4031": "ADUNA",
					"4032": "AIZARNAZABAL",
					"4033": "ALBIZTUR",
					"4034": "ALEGIA",
					"4035": "ALKIZA",
					"4036": "ALTZO",
					"4037": "AMEZKETA",
					"4038": "ANDOAIN",
					"4039": "ANOETA",
					"4040": "ANTZUOLA",
					"4041": "ARAMA",
					"4042": "ARETXABALETA",
					"4043": "ASTEASU",
					"4044": "ATAUN",
					"4045": "AIA",
					"4046": "AZKOITIA",
					"4047": "AZPEITIA",
					"4048": "BEASAIN",
					"4049": "BEIZAMA",
					"4050": "BELAUNTZA",
					"4051": "BERASTEGI",
					"4052": "BERROBI",
					"4053": "BIDEGOYAN",
					"4054": "ZEGAMA",
					"4055": "ZERAIN",
					"4056": "ZESTOA",
					"4057": "ZIZURKIL",
					"4058": "DEBA",
					"4059": "EIBAR",
					"4060": "ELDUAIN",
					"4061": "ELGOIBAR",
					"4062": "ELGETA",
					"4063": "ESKORIATZA",
					"4064": "EZKIO-ITSASO",
					"4065": "HONDARRIBIA",
					"4066": "GAINTZA",
					"4067": "GABIRIA",
					"4068": "GETARIA",
					"4069": "HERNANI",
					"4070": "HERNIALDE",
					"4071": "IBARRA",
					"4072": "IDIAZABAL",
					"4073": "IKAZTEGIETA",
					"4074": "IRUN",
					"4075": "IRURA",
					"4076": "ITSASONDO",
					"4077": "LARRAUL",
					"4078": "LAZKAO",
					"4079": "LEABURU",
					"4080": "LEGAZPI",
					"4081": "LEGORRETA",
					"4082": "LEZO",
					"4083": "LIZARTZA",
					"4084": "ARRASATE O MONDRAGON",
					"4085": "MUTRIKU",
					"4086": "MUTILOA",
					"4087": "OLABERRIA",
					"4088": "OÑATI",
					"4089": "OREXA",
					"4090": "ORIO",
					"4091": "ORMAIZTEGI",
					"4092": "OIARTZUN",
					"4093": "PASAIA",
					"4094": "SORALUZE/PLACENCIA DE LAS ARMA",
					"4095": "ERREZIL",
					"4096": "ERRENTERIA",
					"4097": "LEINTZ-GATZAGA",
					"4098": "DONOSTIA-SAN SEBASTIAN",
					"4099": "SEGURA",
					"4100": "TOLOSA",
					"4101": "URNIETA",
					"4102": "USURBIL",
					"4103": "BERGARA",
					"4104": "VILLABONA",
					"4105": "ORDIZIA",
					"4106": "URRETXU",
					"4107": "ZALDIBIA",
					"4108": "ZARAUTZ",
					"4109": "ZUMARRAGA",
					"4110": "ZUMAIA",
					"4111": "MENDARO",
					"4112": "LASARTE-ORIA",
					"4113": "ASTIGARRAGA",
					"4114": "BALIARRAIN",
					"4115": "ORENDAIN",
					"4116": "ALTZAGA",
					"4117": "GAZTELU"
				}
			},
			"21": {
				"nameProvincia": "Huelva",
				"idProvincia": "21",
				"localidades": {
					"3188": "PUEBLA DE GUZMAN",
					"3859": "PUERTO MORAL",
					"3860": "PUNTA UMBRIA",
					"3861": "ROCIANA DEL CONDADO",
					"3862": "ROSAL DE LA FRONTERA",
					"3863": "SAN BARTOLOME DE LA TORRE",
					"3864": "SAN JUAN DEL PUERTO",
					"3865": "SANLUCAR DE GUADIANA",
					"3866": "SAN SILVESTRE DE GUZMAN",
					"3867": "SANTA ANA LA REAL",
					"3868": "SANTA BARBARA DE CASA",
					"3869": "SANTA OLALLA DEL CALA",
					"3870": "TRIGUEROS",
					"3871": "VALDELARCO",
					"3872": "VALVERDE DEL CAMINO",
					"3873": "VILLABLANCA",
					"3874": "VILLALBA DEL ALCOR",
					"3875": "VILLANUEVA DE LAS CRUCES",
					"3876": "VILLANUEVA DE LOS CASTILLEJOS",
					"3877": "VILLARRASA",
					"3878": "ZALAMEA LA REAL",
					"3879": "ZUFRE",
					"4118": "ALAJAR",
					"4119": "ALJARAQUE",
					"4120": "ALMENDRO (EL)",
					"4121": "ALMONASTER LA REAL",
					"4122": "ALMONTE",
					"4123": "ALOSNO",
					"4124": "ARACENA",
					"4125": "AROCHE",
					"4126": "ARROYOMOLINOS DE LEON",
					"4127": "AYAMONTE",
					"4128": "BEAS",
					"4129": "BERROCAL",
					"4130": "BOLLULLOS PAR DEL CONDADO",
					"4131": "BONARES",
					"4132": "CABEZAS RUBIAS",
					"4133": "CALA",
					"4134": "CALAÑAS",
					"4135": "CAMPILLO (EL)",
					"4136": "CAMPOFRIO",
					"4137": "CAÑAVERAL DE LEON",
					"4139": "CARTAYA",
					"4140": "CASTAÑO DEL ROBLEDO",
					"4141": "CERRO DE ANDEVALO (EL)",
					"4142": "CORTECONCEPCION",
					"4143": "CORTEGANA",
					"4144": "CORTELAZOR",
					"4145": "CUMBRES DE ENMEDIO",
					"4146": "CUMBRES DE SAN BARTOLOME",
					"4147": "CUMBRES MAYORES",
					"4148": "CHUCENA",
					"4149": "ESCACENA DEL CAMPO",
					"4150": "FUENTEHERIDOS",
					"4151": "GALAROZA",
					"4152": "GRANADA DE RIO-TINTO (LA)",
					"4153": "GRANADO (EL)",
					"4154": "HINOJALES",
					"4155": "HINOJOS",
					"4156": "HUELVA",
					"4157": "JABUGO",
					"4158": "LEPE",
					"4159": "LINARES DE LA SIERRA",
					"4160": "MANZANILLA",
					"4161": "MARINES (LOS)",
					"4162": "MINAS DE RIOTINTO",
					"4163": "NAVA (LA)",
					"4164": "NERVA",
					"4165": "PALMA DEL CONDADO (LA)",
					"4166": "PATERNA DEL CAMPO",
					"4167": "PAYMOGO",
					"7439": "ENCINASOLA",
					"7440": "GIBRALEON",
					"7441": "HIGUERA DE LA SIERRA",
					"7442": "ISLA CRISTINA",
					"7443": "LUCENA DEL PUERTO",
					"7444": "MOGUER",
					"7445": "NIEBLA",
					"7446": "PALOS DE LA FRONTERA"
				}
			},
			"22": {
				"nameProvincia": "Huesca",
				"idProvincia": "22",
				"localidades": {
					"3116": "SAN MIGUEL DEL CINCA",
					"3117": "SOTONERA (LA)",
					"3118": "LUPIÑEN-ORTILLA",
					"3119": "SANTA MARIA DE DULCIS",
					"3120": "AINSA-SOBRARBE",
					"3121": "HOZ Y COSTEAN",
					"3122": "VENCILLON",
					"3880": "ABIEGO",
					"3881": "ABIZANDA",
					"3882": "ADAHUESCA",
					"3883": "AGÜERO",
					"3884": "AISA",
					"3885": "ALBALATE DE CINCA",
					"3886": "ALBALATILLO",
					"3887": "ALBELDA",
					"3888": "ALBERO ALTO",
					"3889": "ALBERO BAJO",
					"3890": "ALBERUELA DE TUBO",
					"3891": "ALCALA DE GURREA",
					"3892": "ALCALA DEL OBISPO",
					"3893": "ALCAMPELL",
					"3894": "ALCOLEA DE CINCA",
					"3895": "ALCUBIERRE",
					"3896": "ALERRE",
					"3897": "ALFANTEGA",
					"3898": "ALMUDEVAR",
					"3899": "ALMUNIA DE SAN JUAN",
					"3900": "ALMUNIENTE",
					"3901": "ALTORRICON",
					"3902": "ANGÜES",
					"3903": "ANTILLON",
					"3904": "AREN",
					"3905": "ARGAVIESO",
					"3906": "ARGUIS",
					"3907": "AZANUY-ALINS",
					"3908": "AZARA",
					"3909": "BAELLS",
					"3910": "BALDELLOU",
					"3911": "BANASTAS",
					"3912": "BARBASTRO",
					"3913": "BARBUÑALES",
					"3914": "BARCABO",
					"3915": "BENABARRE",
					"3916": "BENASQUE",
					"3917": "BERBEGAL",
					"3918": "BIERGE",
					"3919": "BINACED",
					"3920": "BINEFAR",
					"3921": "BISCARRUES",
					"3922": "BLECUA Y TORRES",
					"3923": "BONANSA",
					"3924": "BORAU",
					"3925": "CALDEARENAS",
					"3926": "CAMPORRELLS",
					"3927": "CANDASNOS",
					"3928": "CANFRANC",
					"3929": "CAPDESASO",
					"3930": "CASBAS DE HUESCA",
					"3931": "CASTEJON DEL PUENTE",
					"3932": "CASTEJON DE SOS",
					"3933": "CASTELFLORITE",
					"3934": "CASTIELLO DE JACA",
					"3935": "CASTIGALEU",
					"3936": "CASTILLONROY",
					"3937": "COLUNGO",
					"3938": "CHIA",
					"3939": "CHIMILLAS",
					"3940": "ESTADA",
					"3941": "ESTADILLA",
					"3942": "FAGO",
					"3943": "FANLO",
					"3944": "FISCAL",
					"3945": "FONZ",
					"3946": "FRAGA",
					"3947": "FUEVA (LA)",
					"3948": "GISTAIN",
					"3949": "GRADO (EL)",
					"3950": "GRAUS",
					"3951": "HOZ DE JACA",
					"3952": "HUERTO",
					"3953": "HUESCA",
					"3954": "IBIECA",
					"3955": "ILCHE",
					"3956": "JACA",
					"3957": "JASA",
					"3958": "LALUENGA",
					"3959": "LALUEZA",
					"3960": "LAPERDIGUERA",
					"3961": "LASCUARRE",
					"3962": "LASPAULES",
					"3963": "LASPUÑA",
					"3964": "LOPORZANO",
					"3965": "LOSCORRALES",
					"3966": "MONFLORITE-LASCASAS",
					"3967": "MONTANUY",
					"3968": "MONZON",
					"3969": "NOVALES",
					"3970": "NUENO",
					"3971": "ONTIÑENA",
					"3972": "PALO",
					"3973": "PANTICOSA",
					"3974": "PEÑALBA",
					"3975": "PERALTA DE ALCOFEA",
					"3976": "PERALTA DE CALASANZ",
					"3977": "PERALTILLA",
					"3978": "PERARRUA",
					"3979": "PIRACES",
					"3980": "POLEÑINO",
					"3981": "POZAN DE VERO",
					"3982": "PUENTE DE MONTAÑANA",
					"3983": "PUERTOLAS",
					"3984": "PUEYO DE ARAGUAS (EL)",
					"3985": "PUEYO DE SANTA CRUZ",
					"3986": "ROBRES",
					"3987": "SAHUN",
					"3988": "SALAS ALTAS",
					"3989": "SALILLAS",
					"3990": "SALLENT DE GALLEGO",
					"3991": "SAN ESTEBAN DE LITERA",
					"3992": "SAN JUAN DE PLAN",
					"3993": "SANTA CILIA",
					"3994": "SANTALIESTRA Y SAN QUILEZ",
					"3995": "SARIÑENA",
					"3996": "SECASTILLA",
					"3997": "SEIRA",
					"3998": "SENES DE ALCUBIERRE",
					"3999": "SESUE",
					"4000": "SOPEIRA",
					"4001": "TAMARITE DE LITERA",
					"4002": "TARDIENTA",
					"4003": "TELLA-SIN",
					"4004": "TIERZ",
					"4005": "TOLVA",
					"4006": "TORLA",
					"4007": "TORRALBA DE ARAGON",
					"4008": "TORRE LA RIBERA",
					"4009": "TORRENTE DE CINCA",
					"4010": "TORRES DE ALCANADRE",
					"4011": "TORRES DE BARBUES",
					"4012": "TRAMACED",
					"4013": "VALFARTA",
					"4014": "VALLE DE BARDAJI",
					"4015": "VALLE DE LIERP",
					"4016": "VELILLA DE CINCA",
					"4017": "VERACRUZ",
					"4018": "VIACAMP Y LITERA",
					"4019": "VICIEN",
					"4020": "VILLANOVA",
					"4021": "VILLANUA",
					"4022": "VILLANUEVA DE SIGENA",
					"4023": "YEBRA DE BASA",
					"4024": "YESERO",
					"4025": "ZAIDIN",
					"4026": "VALLE DE HECHO",
					"4272": "PUENTE LA REINA DE JACA",
					"6685": "ALQUEZAR",
					"6686": "ANSO",
					"6687": "ARAGÜES DEL PUERTO",
					"6688": "AYERBE",
					"6689": "AZLOR",
					"6690": "BAILO",
					"6691": "BALLOBAR",
					"6692": "BARBUES",
					"6693": "BELVER DE CINCA",
					"6694": "BIELSA",
					"6695": "BIESCAS",
					"6696": "BISAURRI",
					"6697": "BOLTAÑA",
					"6698": "BROTO",
					"6699": "CAMPO",
					"6700": "CANAL DE BERDUN",
					"6701": "CAPELLA",
					"6702": "CASTEJON DE MONEGROS",
					"6703": "CASTILLAZUELO",
					"6704": "CHALAMERA",
					"6705": "ESPLUS",
					"6706": "ESTOPIÑAN DEL CASTILLO",
					"6707": "FORADADA DEL TOSCAR",
					"6708": "GRAÑEN",
					"6709": "GURREA DE GALLEGO",
					"6710": "IGRIES",
					"6711": "ISABENA",
					"6712": "LABUERDA",
					"6713": "LANAJA",
					"6714": "LASCELLAS-PONZANO",
					"6715": "LOARRE",
					"6716": "MONESMA Y CAJIGAR",
					"6717": "NAVAL",
					"6718": "OLVENA",
					"6719": "OSSO DE CINCA",
					"6720": "PEÑAS DE RIGLOS (LAS)",
					"6721": "PERTUSA",
					"6722": "PLAN",
					"6723": "PUEBLA DE CASTRO (LA)",
					"6724": "QUICENA",
					"6725": "SABIÑANIGO",
					"6726": "SALAS BAJAS",
					"6727": "SANGARREN",
					"6728": "SANTA CRUZ DE LA SEROS",
					"6729": "SENA",
					"6730": "SESA",
					"6731": "SIETAMO"
				}
			},
			"23": {
				"nameProvincia": "Jaén",
				"idProvincia": "23",
				"localidades": {
					"2931": "VILLATORRES",
					"2932": "SANTIAGO-PONTONES",
					"2933": "ARROYO DEL OJANCO",
					"3123": "ALBANCHEZ DE MAGINA",
					"3124": "ALCALA LA REAL",
					"3125": "ALCAUDETE",
					"3126": "ALDEAQUEMADA",
					"3127": "ANDUJAR",
					"3128": "ARJONA",
					"3129": "ARJONILLA",
					"3130": "ARQUILLOS",
					"3131": "BAEZA",
					"3132": "BAILEN",
					"3133": "BAÑOS DE LA ENCINA",
					"3134": "BEAS DE SEGURA",
					"3135": "BEGIJAR",
					"3136": "BELMEZ DE LA MORALEDA",
					"3137": "BENATAE",
					"3138": "CABRA DEL SANTO CRISTO",
					"3139": "CAMBIL",
					"3140": "CAMPILLO DE ARENAS",
					"3141": "CANENA",
					"3142": "CARBONEROS",
					"3143": "CAROLINA (LA)",
					"3144": "CASTELLAR",
					"3145": "CASTILLO DE LOCUBIN",
					"3146": "CAZALILLA",
					"3147": "CAZORLA",
					"3148": "CHICLANA DE SEGURA",
					"3149": "CHILLUEVAR",
					"3150": "ESCAÑUELA",
					"3151": "ESPELUY",
					"3152": "FRAILES",
					"3153": "FUENSANTA DE MARTOS",
					"3154": "FUERTE DEL REY",
					"3155": "GENAVE",
					"3156": "GUARDIA DE JAEN (LA)",
					"3157": "GUARROMAN",
					"3158": "LAHIGUERA",
					"3159": "HIGUERA DE CALATRAVA",
					"3160": "HINOJARES",
					"3161": "HORNOS",
					"3162": "HUELMA",
					"3163": "HUESA",
					"3164": "IBROS",
					"3165": "IRUELA (LA)",
					"3166": "IZNATORAF",
					"3167": "JABALQUINTO",
					"3168": "JAEN",
					"3169": "JAMILENA",
					"3170": "JIMENA",
					"3171": "JODAR",
					"3172": "LARVA",
					"3173": "LINARES",
					"3174": "LOPERA",
					"3175": "LUPION",
					"3176": "MANCHA REAL",
					"3177": "MARMOLEJO",
					"3178": "MARTOS",
					"3179": "MENGIBAR",
					"3180": "MONTIZON",
					"3181": "NAVAS DE SAN JUAN",
					"3182": "NOALEJO",
					"3183": "ORCERA",
					"3184": "PEAL DE BECERRO",
					"3185": "PEGALAJAR",
					"3186": "PORCUNA",
					"3187": "POZO ALCON",
					"3189": "PUENTE DE GENAVE",
					"3190": "PUERTA DE SEGURA (LA)",
					"3191": "QUESADA",
					"3192": "RUS",
					"3193": "SABIOTE",
					"3194": "SANTA ELENA",
					"3195": "SANTIAGO DE CALATRAVA",
					"3196": "SANTISTEBAN DEL PUERTO",
					"3197": "SANTO TOME",
					"3198": "SEGURA DE LA SIERRA",
					"3199": "SILES",
					"3200": "SORIHUELA DEL GUADALIMAR",
					"3201": "TORREBLASCOPEDRO",
					"3202": "TORRE DEL CAMPO",
					"3203": "TORREDONJIMENO",
					"3204": "TORREPEROGIL",
					"3205": "TORRES",
					"3206": "TORRES DE ALBANCHEZ",
					"3207": "UBEDA",
					"3208": "VALDEPEÑAS DE JAEN",
					"3209": "VILCHES",
					"3210": "VILLACARRILLO",
					"3211": "VILLANUEVA DE LA REINA",
					"3212": "VILLANUEVA DEL ARZOBISPO",
					"3213": "VILLARDOMPARDO",
					"3214": "VILLARES (LOS)",
					"3215": "VILLARRODRIGO",
					"3216": "CARCHELES",
					"3858": "BEDMAR Y GARCIEZ"
				}
			},
			"24": {
				"nameProvincia": "León",
				"idProvincia": "24",
				"localidades": {
					"2934": "ACEBEDO",
					"2935": "ALGADEFE",
					"2936": "ALIJA DEL INFANTADO",
					"2937": "ALMANZA",
					"2938": "ANTIGUA (LA)",
					"2939": "ARDON",
					"2940": "ARGANZA",
					"2941": "ASTORGA",
					"2942": "BALBOA",
					"2943": "BAÑEZA (LA)",
					"2944": "BARJAS",
					"2945": "BARRIOS DE LUNA (LOS)",
					"2946": "BEMBIBRE",
					"2947": "BENAVIDES",
					"2948": "BENUZA",
					"2949": "BERCIANOS DEL PARAMO",
					"2950": "BERCIANOS DEL REAL CAMINO",
					"2951": "BERLANGA DEL BIERZO",
					"2952": "BOCA DE HUERGANO",
					"2953": "BOÑAR",
					"2954": "BORRENES",
					"2955": "BRAZUELO",
					"2956": "BURGO RANERO (EL)",
					"2957": "BURON",
					"2958": "BUSTILLO DEL PARAMO",
					"2959": "CABAÑAS RARAS",
					"2960": "CABREROS DEL RIO",
					"2961": "CABRILLANES",
					"2962": "CACABELOS",
					"2963": "CALZADA DEL COTO",
					"2964": "CAMPAZAS",
					"2965": "CAMPO DE VILLAVIDEL",
					"2966": "CAMPONARAYA",
					"2967": "CANDIN",
					"2968": "CARMENES",
					"2969": "CARRACEDELO",
					"2970": "CARRIZO",
					"2971": "CARROCERA",
					"2972": "CARUCEDO",
					"2973": "CASTILFALE",
					"2974": "CASTRILLO DE CABRERA",
					"2975": "CASTRILLO DE LA VALDUERNA",
					"2976": "CASTROCALBON",
					"2977": "CASTROCONTRIGO",
					"2978": "CASTROPODAME",
					"2979": "CASTROTIERRA DE VALMADRIGAL",
					"2980": "CEA",
					"2981": "CEBANICO",
					"2982": "CEBRONES DEL RIO",
					"2983": "CIMANES DE LA VEGA",
					"2984": "CIMANES DEL TEJAR",
					"2985": "CISTIERNA",
					"2986": "CONGOSTO",
					"2987": "CORBILLOS DE LOS OTEROS",
					"2988": "CREMENES",
					"2989": "CUADROS",
					"2990": "CUBILLAS DE RUEDA",
					"2991": "CUBILLOS DEL SIL",
					"2992": "CHOZAS DE ABAJO",
					"2993": "DESTRIANA",
					"2994": "ERCINA (LA)",
					"2995": "ESCOBAR DE CAMPOS",
					"2996": "FOLGOSO DE LA RIBERA",
					"2997": "FUENTES DE CARBAJAL",
					"2998": "GARRAFE DE TORIO",
					"2999": "GORDALIZA DEL PINO",
					"3000": "GORDONCILLO",
					"3001": "GRAJAL DE CAMPOS",
					"3002": "GUSENDOS DE LOS OTEROS",
					"3003": "IGÜEÑA",
					"3004": "IZAGRE",
					"3005": "JOARILLA DE LAS MATAS",
					"3006": "LAGUNA DE NEGRILLOS",
					"3007": "LEON",
					"3008": "LUCILLO",
					"3009": "LLAMAS DE LA RIBERA",
					"3010": "MANSILLA DE LAS MULAS",
					"3011": "MANSILLA MAYOR",
					"3012": "MARAÑA",
					"3013": "MATALLANA DE TORIO",
					"3014": "MATANZA",
					"3015": "MOLINASECA",
					"3016": "MURIAS DE PAREDES",
					"3017": "OENCIA",
					"3018": "OMAÑAS (LAS)",
					"3019": "OSEJA DE SAJAMBRE",
					"3020": "PAJARES DE LOS OTEROS",
					"3021": "PALACIOS DEL SIL",
					"3022": "PARAMO DEL SIL",
					"3023": "PERANZANES",
					"3024": "POBLADURA DE PELAYO GARCIA",
					"3025": "PONFERRADA",
					"3026": "POSADA DE VALDEON",
					"3027": "POZUELO DEL PARAMO",
					"3028": "PRADO DE LA GUZPEÑA",
					"3029": "PRIORO",
					"3030": "PUEBLA DE LILLO",
					"3031": "PUENTE DE DOMINGO FLOREZ",
					"3032": "QUINTANA DEL CASTILLO",
					"3033": "QUINTANA Y CONGOSTO",
					"3034": "REGUERAS DE ARRIBA",
					"3035": "REYERO",
					"3036": "RIEGO DE LA VEGA",
					"3037": "RIELLO",
					"3038": "ROBLA (LA)",
					"3039": "ROPERUELOS DEL PARAMO",
					"3040": "SABERO",
					"3041": "SAN ADRIAN DEL VALLE",
					"3042": "SANCEDO",
					"3043": "SAN CRISTOBAL DE LA POLANTERA",
					"3044": "SAN EMILIANO",
					"3045": "SAN ESTEBAN DE NOGALES",
					"3046": "SAN JUSTO DE LA VEGA",
					"3047": "SAN PEDRO BERCIANOS",
					"3048": "SANTA COLOMBA DE CURUEÑO",
					"3049": "SANTA COLOMBA DE SOMOZA",
					"3050": "SANTA CRISTINA DE VALMADRIGAL",
					"3051": "SANTA ELENA DE JAMUZ",
					"3052": "SANTA MARIA DEL MONTE DE CEA",
					"3053": "SANTA MARIA DEL PARAMO",
					"3054": "SANTA MARIA DE ORDAS",
					"3055": "SANTA MARINA DEL REY",
					"3056": "SANTIAGO MILLAS",
					"3057": "SANTOVENIA DE LA VALDONCINA",
					"3058": "SARIEGOS",
					"3059": "SOBRADO",
					"3060": "SOTO DE LA VEGA",
					"3061": "TORAL DE LOS GUZMANES",
					"3062": "TORENO",
					"3063": "TORRE DEL BIERZO",
					"3064": "TRUCHAS",
					"3065": "TURCIA",
					"3066": "VALDEFRESNO",
					"3067": "VALDEFUENTES DEL PARAMO",
					"3068": "VALDELUGUEROS",
					"3069": "VALDEPIELAGO",
					"3070": "VALDEPOLO",
					"3071": "VALDERREY",
					"3072": "VALDERRUEDA",
					"3073": "VAL DE SAN LORENZO",
					"3074": "VALDEVIMBRE",
					"3075": "VALENCIA DE DON JUAN",
					"3076": "VALVERDE-ENRIQUE",
					"3077": "VALLECILLO",
					"3078": "VECILLA (LA)",
					"3079": "VEGACERVERA",
					"3080": "VEGA DE INFANZONES",
					"3081": "VEGA DE VALCARCE",
					"3082": "VEGAQUEMADA",
					"3083": "VEGAS DEL CONDADO",
					"3084": "VILLABLINO",
					"3085": "VILLABRAZ",
					"3086": "VILLADANGOS DEL PARAMO",
					"3087": "VILLADECANES",
					"3088": "VILLADEMOR DE LA VEGA",
					"3089": "VILLAFRANCA DEL BIERZO",
					"3090": "VILLAGATON",
					"3091": "VILLAMANDOS",
					"3092": "VILLAMAÑAN",
					"3093": "VILLAMARTIN DE DON SANCHO",
					"3094": "VILLAMEJIL",
					"3095": "VILLAMOL",
					"3096": "VILLAMONTAN DE LA VALDUERNA",
					"3097": "VILLAMORATIEL DE LAS MATAS",
					"3098": "VILLANUEVA DE LAS MANZANAS",
					"3099": "VILLAOBISPO DE OTERO",
					"3100": "VILLAQUEJIDA",
					"3101": "VILLAQUILAMBRE",
					"3102": "VILLAREJO DE ORBIGO",
					"3103": "VILLARES DE ORBIGO",
					"3104": "VILLASABARIEGO",
					"3105": "VILLASELAN",
					"3106": "VILLATURIEL",
					"3107": "VILLAZALA",
					"3108": "VILLAZANZO DE VALDERADUEY",
					"3109": "ZOTES DEL PARAMO",
					"3110": "VILLAMANIN",
					"3111": "VILLAORNATE Y CASTRO",
					"6652": "CORULLON",
					"6653": "CUBILLAS DE LOS OTEROS",
					"6654": "ENCINEDO",
					"6655": "FABERO",
					"6656": "FRESNO DE LA VEGA",
					"6657": "GRADEFES",
					"6658": "HOSPITAL DE ORBIGO",
					"6659": "LAGUNA DALGA",
					"6660": "LUYEGO",
					"6661": "MAGAZ DE CEPEDA",
					"6662": "MATADEON DE LOS OTEROS",
					"6663": "NOCEDA",
					"6664": "ONZONILLA",
					"6665": "PALACIOS DE LA VALDUERNA",
					"6666": "POLA DE GORDON (LA)",
					"6667": "PRIARANZA DEL BIERZO",
					"6668": "QUINTANA DEL MARCO",
					"6669": "RIAÑO",
					"6670": "RIOSECO DE TAPIA",
					"6671": "SAHAGUN",
					"6672": "SAN ANDRES DEL RABANEDO",
					"6673": "SAN MILLAN DE LOS CABALLEROS",
					"6674": "SANTA MARIA DE LA ISLA",
					"6675": "SANTAS MARTAS",
					"6676": "SENA DE LUNA",
					"6677": "SOTO Y AMIO",
					"6678": "TRABADELO",
					"6679": "URDIALES DEL PARAMO",
					"6680": "VALDEMORA",
					"6681": "VALDERAS",
					"6682": "VALDESAMARIO",
					"6683": "VALVERDE DE LA VIRGEN",
					"6684": "VEGA DE ESPINAREDA"
				}
			},
			"25": {
				"nameProvincia": "Lérida / Lleida",
				"idProvincia": "25",
				"localidades": {
					"2028": "CORBINS",
					"2029": "CUBELLS",
					"2448": "ÀGER",
					"2930": "CLARIANA DE CARDENER",
					"3112": "ABELLA DE LA CONCA",
					"3113": "AGRAMUNT",
					"3342": "ESPLUGA CALBA (L')",
					"3343": "ESPOT",
					"3561": "COGUL (EL)",
					"3562": "COLL DE NARGO",
					"3563": "ALAMUS (ELS)",
					"3564": "ALAS I CERC",
					"3565": "ESTARAS",
					"3566": "ESTERRI D'ÀNEU",
					"3567": "ESTERRI DE CARDOS",
					"3568": "ESTAMARIU",
					"3569": "FARRERA",
					"3570": "FLORESTA (LA)",
					"3571": "FONDARELLA",
					"3572": "FORADADA",
					"3573": "FULIOLA (LA)",
					"3574": "FULLEDA",
					"3575": "GAVET DE LA CONCA",
					"3576": "GOLMES",
					"3577": "GOSOL",
					"3578": "GRANADELLA (LA)",
					"3579": "GRANJA D'ESCARP (LA)",
					"3580": "GRANYANELLA",
					"3581": "GRANYENA DE SEGARRA",
					"3582": "GRANYENA DE LES GARRIGUES",
					"3583": "GUIMERA",
					"3584": "GUISSONA",
					"3585": "GUIXERS",
					"3586": "IVARS DE NOGUERA",
					"3587": "IVARS D'URGELL",
					"3588": "IVORRA",
					"3589": "ISONA I CONCA DELLA",
					"3590": "JUNCOSA",
					"3591": "JUNEDA",
					"3592": "LLEIDA",
					"3593": "LES",
					"3594": "LINYOLA",
					"3595": "LLADORRE",
					"3596": "LLADURS",
					"3597": "LLARDECANS",
					"3598": "LLAVORSI",
					"3599": "LLES DE CERDANYA",
					"3600": "LLIMIANA",
					"3601": "LLOBERA",
					"3602": "MALDA",
					"3603": "MASSALCOREIG",
					"3604": "MASSOTERES",
					"3605": "MAIALS",
					"3606": "MENARGUENS",
					"3607": "MIRALCAMP",
					"3608": "MOLSOSA (LA)",
					"3609": "MOLLERUSSA",
					"3610": "MONTGAI",
					"3611": "MONTELLA I MARTINET",
					"3612": "MONTFERRER I CASTELLBO",
					"3613": "MONTOLIU DE SEGARRA",
					"3614": "MONTOLIU DE LLEIDA",
					"3615": "MONTORNES DE SEGARRA",
					"3616": "NALEC",
					"3617": "NAVES",
					"3618": "ODEN",
					"3619": "OLIANA",
					"3620": "OLIOLA",
					"3621": "OLIUS",
					"3622": "OLUGES (LES)",
					"3623": "OMELLONS (ELS)",
					"3624": "OMELLS DE NA GAIA (ELS)",
					"3625": "ORGANYA",
					"3626": "OS DE BALAGUER",
					"3627": "OSSO DE SIO",
					"3628": "PALAU D'ANGLESOLA (EL)",
					"3629": "CONCA DE DALT",
					"3630": "COMA I LA PEDRA (LA)",
					"3631": "PENELLES",
					"3632": "PERAMOLA",
					"3633": "PINELL DE SOLSONES",
					"3634": "PINOS",
					"3635": "POAL (EL)",
					"3636": "POBLA DE CERVOLES (LA)",
					"3637": "BELLAGUARDA",
					"3638": "POBLA DE SEGUR (LA)",
					"3639": "PONT DE SUERT (EL)",
					"3640": "PRATS I SANSOR",
					"3641": "PREIXANA",
					"3642": "PREIXENS",
					"3643": "PUIGGROS",
					"3644": "PUIGVERD DE LLEIDA",
					"3645": "RIALP",
					"3646": "RIBERA D'URGELLET",
					"3647": "RINER",
					"3648": "SALAS DE PALLARS",
					"3649": "SANAÜJA",
					"3650": "SANT LLORENÇ DE MORUNYS",
					"3651": "SANT RAMON",
					"3652": "SANT ESTEVE DE LA SARGA",
					"3653": "SANT GUIM DE LA PLANA",
					"3654": "SARROCA DE BELLERA",
					"3655": "SENTERADA",
					"3656": "SEU D'URGELL (LA)",
					"3657": "SIDAMON",
					"3658": "SOLERAS (EL)",
					"3659": "SORIGUERA",
					"3660": "SOSES",
					"3661": "SUDANELL",
					"3662": "TALARN",
					"3663": "TARREGA",
					"3664": "TARRES",
					"3665": "TERMENS",
					"3666": "TIRVIA",
					"3667": "TIURANA",
					"3668": "TORMS (ELS)",
					"3669": "TORNABOUS",
					"3670": "TORRE DE CABDELLA (LA)",
					"3671": "TORREFARRERA",
					"3672": "TORRELAMEU",
					"3673": "TORRES DE SEGRE",
					"3674": "TREMP",
					"3675": "VALLBONA DE LES MONGES",
					"3676": "VALLS DE VALIRA (LES)",
					"3677": "VERDU",
					"3678": "VIELHA E MIJARAN",
					"3679": "VILAGRASSA",
					"3680": "VILALLER",
					"3681": "VILANOVA DE BELLPUIG",
					"3682": "VILANOVA DE L'AGUDA",
					"3683": "VILANOVA DE SEGRIA",
					"3684": "VILA-SANA",
					"3685": "VILOSELL (EL)",
					"3686": "VINAIXA",
					"3687": "VALL DE CARDOS",
					"3688": "SANT MARTI DE RIUCORB",
					"3689": "GUINGUETA D'ÀNEU (LA)",
					"3690": "RIBERA D'ONDARA",
					"3691": "VALLS D'AGUILAR (LES)",
					"3692": "FIGOLS I ALINYA",
					"3693": "VANSA I FORNOLS (LA)",
					"3694": "JOSA I TUIXEN",
					"3695": "PLANS DE SIO (ELS)",
					"3696": "RIU DE CERDANYA",
					"3795": "ALBAGES (L')",
					"3796": "ALBATARREC",
					"3797": "ALBESA",
					"3798": "ALBI (L')",
					"3799": "ALCANO",
					"3800": "ALCARRAS",
					"3801": "ALCOLETGE",
					"3802": "ALFARRAS",
					"3803": "ALFES",
					"3804": "ALGERRI",
					"3805": "ALGUAIRE",
					"3806": "ALINS",
					"3807": "ALMACELLES",
					"3808": "ALMATRET",
					"3809": "ALMENAR",
					"3810": "ALOS DE BALAGUER",
					"3811": "ALPICAT",
					"3812": "ALT ÀNEU",
					"3813": "NAUT ARAN",
					"3814": "ANGLESOLA",
					"3815": "ARBECA",
					"3816": "PONT DE BAR (EL)",
					"3817": "ARRES",
					"3818": "ARSEGUEL",
					"3819": "ARTESA DE LLEIDA",
					"3820": "ARTESA DE SEGRE",
					"3821": "SENTIU DE SIO (LA)",
					"3822": "ASPA",
					"3823": "AVELLANES I SANTA LINYA (LES)",
					"3824": "AITONA",
					"3825": "BAIX PALLARS",
					"3826": "BALAGUER",
					"3827": "BARBENS",
					"3828": "BARONIA DE RIALB (LA)",
					"3829": "VALL DE BOI (LA)",
					"3830": "BASSELLA",
					"3831": "BAUSEN",
					"3832": "BELIANES",
					"3833": "BELLCAIRE D'URGELL",
					"3834": "BELL-LLOC D'URGELL",
					"3835": "BELLMUNT D'URGELL",
					"3836": "BELLPUIG",
					"3837": "BELLVER DE CERDANYA",
					"3838": "BELLVIS",
					"3839": "BENAVENT DE SEGRIA",
					"3840": "BIOSCA",
					"3841": "BOVERA",
					"3842": "BORDES (ES)",
					"3843": "BORGES BLANQUES (LES)",
					"3844": "BOSSOST",
					"3845": "CABANABONA",
					"3846": "CABO",
					"3847": "CAMARASA",
					"3848": "CANEJAN",
					"3849": "CASTELLAR DE LA RIBERA",
					"3850": "CASTELLDANS",
					"3851": "CASTELLNOU DE SEANA",
					"3852": "CASTELLO DE FARFANYA",
					"3853": "CASTELLSERA",
					"3854": "CAVA",
					"3855": "CERVERA",
					"3856": "CERVIA DE LES GARRIGUES",
					"3857": "CIUTADILLA",
					"6610": "PONTS",
					"6611": "PORTELLA (LA)",
					"6612": "PRULLANS",
					"6613": "PUIGVERD D'AGRAMUNT",
					"6614": "ROSSELLO",
					"6615": "SANT GUIM DE FREIXENET",
					"6616": "SARROCA DE LLEIDA",
					"6617": "SEROS",
					"6618": "SOLSONA",
					"6619": "SORT",
					"6620": "SUNYER",
					"6621": "TALAVERA",
					"6622": "TARROJA DE SEGARRA",
					"6623": "TORA",
					"6624": "TORREBESSES",
					"6625": "TORREGROSSA",
					"6626": "TORRE-SERONA",
					"6627": "VALLFOGONA DE BALAGUER",
					"6628": "VILAMOS",
					"6629": "VILANOVA DE MEIA",
					"6630": "VILANOVA DE LA BARCA",
					"6631": "CASTELL DE MUR",
					"6632": "TORREFETA I FLOREJACS",
					"6633": "GIMENELLS I EL PLA DE LA FONT"
				}
			},
			"26": {
				"nameProvincia": "La Rioja",
				"idProvincia": "26",
				"localidades": {
					"1795": "PRADEJON",
					"2907": "REDAL (EL)",
					"2908": "RIBAFRECHA",
					"2909": "RINCON DE SOTO",
					"2910": "ROBRES DEL CASTILLO",
					"2911": "RODEZNO",
					"2912": "SAJAZARRA",
					"2913": "SAN ASENSIO",
					"2914": "SAN MILLAN DE LA COGOLLA",
					"2915": "SAN MILLAN DE YECORA",
					"2916": "SAN ROMAN DE CAMEROS",
					"2917": "SANTA COLOMA",
					"2918": "SANTA ENGRACIA DEL JUBERA",
					"2919": "SANTA EULALIA BAJERA",
					"2920": "SANTO DOMINGO DE LA CALZADA",
					"2921": "SAN TORCUATO",
					"2922": "SANTURDE DE RIOJA",
					"2923": "SANTURDEJO",
					"2924": "SAN VICENTE DE LA SONSIERRA",
					"2925": "SOJUELA",
					"2926": "SORZANO",
					"2927": "SOTES",
					"2928": "SOTO EN CAMEROS",
					"2929": "TERROBA",
					"3560": "TIRGO",
					"3697": "ABALOS",
					"3698": "AGONCILLO",
					"3699": "AGUILAR DEL RIO ALHAMA",
					"3700": "AJAMIL",
					"3701": "ALBELDA DE IREGUA",
					"3702": "ALCANADRE",
					"3703": "ALDEANUEVA DE EBRO",
					"3704": "ALESON",
					"3705": "ALMARZA DE CAMEROS",
					"3706": "ANGUCIANA",
					"3707": "ARENZANA DE ABAJO",
					"3708": "ARENZANA DE ARRIBA",
					"3709": "ARNEDO",
					"3710": "ARRUBAL",
					"3711": "AUTOL",
					"3712": "BADARAN",
					"3713": "BAÑARES",
					"3714": "BAÑOS DE RIO TOBIA",
					"3715": "BERCEO",
					"3716": "BERGASA",
					"3717": "BEZARES",
					"3718": "BOBADILLA",
					"3719": "BRIEVA DE CAMEROS",
					"3720": "BRIONES",
					"3721": "CABEZON DE CAMEROS",
					"3722": "CAMPROVIN",
					"3723": "CANALES DE LA SIERRA",
					"3724": "CAÑAS",
					"3725": "CARDENAS",
					"3726": "CASALARREINA",
					"3727": "CASTAÑARES DE RIOJA",
					"3728": "CELLORIGO",
					"3729": "CENICERO",
					"3730": "CIDAMON",
					"3731": "CIHURI",
					"3732": "CIRUEÑA",
					"3733": "CLAVIJO",
					"3734": "CORERA",
					"3735": "CORNAGO",
					"3736": "CUZCURRITA DE RIO TIRON",
					"3737": "DAROCA DE RIOJA",
					"3738": "ENTRENA",
					"3739": "ESTOLLO",
					"3740": "FONCEA",
					"3741": "FONZALECHE",
					"3742": "FUENMAYOR",
					"3743": "GALBARRULI",
					"3744": "GALILEA",
					"3745": "GALLINERO DE CAMEROS",
					"3746": "GIMILEO",
					"3747": "GRAÑON",
					"3748": "GRAVALOS",
					"3749": "HARO",
					"3750": "HERCE",
					"3751": "HERRAMELLURI",
					"3752": "HERVIAS",
					"3753": "HORMILLA",
					"3754": "HORMILLEJA",
					"3755": "HORNILLOS DE CAMEROS",
					"3756": "HORNOS DE MONCALVILLO",
					"3757": "HUERCANOS",
					"3758": "IGEA",
					"3759": "JALON DE CAMEROS",
					"3760": "LAGUNA DE CAMEROS",
					"3761": "LAGUNILLA DEL JUBERA",
					"3762": "LARDERO",
					"3763": "LEDESMA DE LA COGOLLA",
					"3764": "LEIVA",
					"3765": "LEZA DE RIO LEZA",
					"3766": "LOGROÑO",
					"3767": "LUMBRERAS",
					"3768": "MANJARRES",
					"3769": "MANSILLA DE LA SIERRA",
					"3770": "MANZANARES DE RIOJA",
					"3771": "MATUTE",
					"3772": "MEDRANO",
					"3773": "MUNILLA",
					"3774": "MURILLO DE RIO LEZA",
					"3775": "MURO DE AGUAS",
					"3776": "MURO EN CAMEROS",
					"3777": "NAJERA",
					"3778": "NALDA",
					"3779": "NAVAJUN",
					"3780": "NAVARRETE",
					"3781": "NESTARES",
					"3782": "NIEVA DE CAMEROS",
					"3783": "OCON",
					"3784": "OCHANDURI",
					"3785": "OJACASTRO",
					"3786": "OLLAURI",
					"3787": "ORTIGOSA DE CAMEROS",
					"3788": "PAZUENGOS",
					"3789": "PEDROSO",
					"3790": "PINILLOS",
					"3792": "PRADILLO",
					"3793": "PREJANO",
					"4273": "RABANERA",
					"4274": "RASILLO DE CAMEROS (EL)",
					"4481": "TOBIA",
					"4482": "TORMANTOS",
					"4483": "TORRECILLA EN CAMEROS",
					"4484": "TORRECILLA SOBRE ALESANCO",
					"4485": "TORRE EN CAMEROS",
					"4486": "TORREMONTALBO",
					"4487": "TREVIANA",
					"4488": "TRICIO",
					"4489": "TUDELILLA",
					"4490": "URUÑUELA",
					"4491": "VALDEMADERA",
					"4492": "VALGAÑON",
					"4493": "VENTOSA",
					"4494": "VENTROSA",
					"4495": "VIGUERA",
					"4496": "VILLALBA DE RIOJA",
					"4497": "VILLALOBAR DE RIOJA",
					"4498": "VILLAMEDIANA DE IREGUA",
					"4499": "VILLANUEVA DE CAMEROS",
					"4500": "VILLAR DE ARNEDO (EL)",
					"4501": "VILLAR DE TORRE",
					"4502": "VILLAREJO",
					"4503": "VILLARROYA",
					"4504": "VILLARTA-QUINTANA",
					"4505": "VILLAVELAYO",
					"4506": "VILLAVERDE DE RIOJA",
					"4507": "VILLOSLADA DE CAMEROS",
					"4508": "VINIEGRA DE ABAJO",
					"4509": "VINIEGRA DE ARRIBA",
					"4510": "ZARRATON",
					"4511": "ZARZOSA",
					"4512": "ZORRAQUIN",
					"4519": "QUEL",
					"6634": "ALBERITE",
					"6635": "ALESANCO",
					"6636": "ALFARO",
					"6637": "ANGUIANO",
					"6638": "ARNEDILLO",
					"6639": "AUSEJO",
					"6640": "AZOFRA",
					"6641": "BAÑOS DE RIOJA",
					"6642": "BERGASILLAS BAJERA",
					"6643": "BRIÑAS",
					"6644": "CALAHORRA",
					"6645": "CANILLAS DE RIO TUERTO",
					"6646": "CASTROVIEJO",
					"6647": "CERVERA DEL RIO ALHAMA",
					"6648": "CORDOVIN",
					"6649": "CORPORALES",
					"6650": "ENCISO",
					"6651": "EZCARAY"
				}
			},
			"27": {
				"nameProvincia": "Lugo",
				"idProvincia": "27",
				"localidades": {
					"3114": "BARREIROS",
					"3115": "BECERREA",
					"3344": "BEGONTE",
					"3345": "BOVEDA",
					"3346": "CARBALLEDO",
					"3347": "CASTRO DE REI",
					"3348": "CASTROVERDE",
					"3349": "CERVANTES",
					"3350": "CERVO",
					"3351": "CORGO (O)",
					"3352": "COSPEITO",
					"3353": "CHANTADA",
					"3354": "FOLGOSO DO COUREL",
					"3355": "FONSAGRADA (A)",
					"3356": "FOZ",
					"3357": "FRIOL",
					"3358": "XERMADE",
					"3359": "GUITIRIZ",
					"3360": "GUNTIN",
					"3361": "INCIO (O)",
					"3362": "XOVE",
					"3363": "LANCARA",
					"3364": "LOURENZA",
					"3365": "LUGO",
					"3366": "MEIRA",
					"3367": "MONDOÑEDO",
					"3368": "MONFORTE DE LEMOS",
					"3369": "MONTERROSO",
					"3370": "MURAS",
					"3371": "NAVIA DE SUARNA",
					"3372": "NEGUEIRA DE MUÑIZ",
					"3373": "NOGAIS (AS)",
					"3374": "OUROL",
					"3375": "OUTEIRO DE REI",
					"3376": "PALAS DE REI",
					"3377": "PANTON",
					"3378": "PARADELA",
					"3379": "PARAMO (O)",
					"3380": "PASTORIZA (A)",
					"3381": "PEDRAFITA DO CEBREIRO",
					"3382": "POL",
					"3383": "POBRA DO BROLLON (A)",
					"3384": "PONTENOVA (A)",
					"3385": "PORTOMARIN",
					"3386": "QUIROGA",
					"3387": "RIBADEO",
					"3388": "RIBAS DE SIL",
					"3389": "RIBEIRA DE PIQUIN",
					"3390": "RIOTORTO",
					"3391": "SAMOS",
					"3392": "RABADE",
					"3393": "SARRIA",
					"3394": "SAVIÑAO (O)",
					"3395": "SOBER",
					"3396": "TABOADA",
					"3397": "TRABADA",
					"3398": "TRIACASTELA",
					"3399": "VALADOURO (O)",
					"3400": "VICEDO (O)",
					"3401": "VILALBA",
					"3402": "VIVEIRO",
					"3403": "BARALLA",
					"4271": "BALEIRA",
					"4513": "ABADIN",
					"4514": "ALFOZ",
					"4515": "ANTAS DE ULLA",
					"6572": "BURELA"
				}
			},
			"28": {
				"nameProvincia": "Madrid",
				"idProvincia": "28",
				"localidades": {
					"3404": "ACEBEDA (LA)",
					"3405": "AJALVIR",
					"3406": "ALAMO (EL)",
					"3407": "ALCALA DE HENARES",
					"3408": "ALCOBENDAS",
					"3409": "ALDEA DEL FRESNO",
					"3410": "ALGETE",
					"3411": "AMBITE",
					"3412": "ANCHUELO",
					"3413": "ARGANDA DEL REY",
					"3414": "ARROYOMOLINOS",
					"3415": "BATRES",
					"3416": "BECERRIL DE LA SIERRA",
					"3417": "BERZOSA DEL LOZOYA",
					"3418": "BERRUECO (EL)",
					"3419": "BOADILLA DEL MONTE",
					"3420": "BRAOJOS",
					"3421": "BREA DE TAJO",
					"3422": "BUITRAGO DEL LOZOYA",
					"3423": "BUSTARVIEJO",
					"3424": "CABRERA (LA)",
					"3425": "CADALSO DE LOS VIDRIOS",
					"3426": "CAMARMA DE ESTERUELAS",
					"3427": "CAMPO REAL",
					"3428": "CARABAÑA",
					"3429": "CASARRUBUELOS",
					"3430": "CERCEDILLA",
					"3431": "CERVERA DE BUITRAGO",
					"3432": "COBEÑA",
					"3433": "COLMENAR DEL ARROYO",
					"3434": "COLMENAR DE OREJA",
					"3435": "COLMENAR VIEJO",
					"3436": "COLLADO MEDIANO",
					"3437": "CORPA",
					"3438": "COSLADA",
					"3439": "CUBAS DE LA SAGRA",
					"3440": "CHINCHON",
					"3441": "DAGANZO DE ARRIBA",
					"3442": "ESCORIAL (EL)",
					"3443": "FRESNEDILLAS DE LA OLIVA",
					"3444": "FRESNO DE TOROTE",
					"3445": "FUENTE EL SAZ DE JARAMA",
					"3446": "FUENTIDUEÑA DE TAJO",
					"3447": "GARGANTA DE LOS MONTES",
					"3448": "GARGANTILLA DEL LOZOYA Y PINIL",
					"3449": "GETAFE",
					"3450": "GRIÑON",
					"3451": "GUADARRAMA",
					"3452": "HIRUELA (LA)",
					"3453": "HORCAJO DE LA SIERRA",
					"3454": "HORCAJUELO DE LA SIERRA",
					"3455": "HUMANES DE MADRID",
					"3456": "LEGANES",
					"3457": "LOECHES",
					"3458": "MADARCOS",
					"3459": "MADRID",
					"3460": "MANZANARES EL REAL",
					"3461": "MECO",
					"3462": "MIRAFLORES DE LA SIERRA",
					"3463": "MOLAR (EL)",
					"3464": "MOLINOS (LOS)",
					"3465": "MONTEJO DE LA SIERRA",
					"3466": "MORALZARZAL",
					"3467": "MORATA DE TAJUÑA",
					"3468": "MOSTOLES",
					"3469": "NAVALAFUENTE",
					"3470": "NAVALAGAMELLA",
					"3471": "NAVALCARNERO",
					"3472": "NAVAS DEL REY",
					"3473": "NUEVO BAZTAN",
					"3474": "OLMEDA DE LAS FUENTES",
					"3475": "ORUSCO DE TAJUÑA",
					"3476": "PARLA",
					"3477": "PATONES",
					"3478": "PEDREZUELA",
					"3479": "PELAYOS DE LA PRESA",
					"3480": "PEZUELA DE LAS TORRES",
					"3481": "PINILLA DEL VALLE",
					"3482": "PINTO",
					"3483": "POZUELO DE ALARCON",
					"3484": "POZUELO DEL REY",
					"3485": "PRADENA DEL RINCON",
					"3486": "PUEBLA DE LA SIERRA",
					"3487": "RASCAFRIA",
					"3488": "REDUEÑA",
					"3489": "RIVAS-VACIAMADRID",
					"3490": "ROBLEDILLO DE LA JARA",
					"3491": "ROBREGORDO",
					"3492": "ROZAS DE MADRID (LAS)",
					"3493": "ROZAS DE PUERTO REAL",
					"3494": "SAN FERNANDO DE HENARES",
					"3495": "SAN LORENZO DE EL ESCORIAL",
					"3496": "SAN MARTIN DE LA VEGA",
					"3497": "SAN MARTIN DE VALDEIGLESIAS",
					"3498": "SAN SEBASTIAN DE LOS REYES",
					"3499": "SANTORCAZ",
					"3500": "SANTOS DE LA HUMOSA (LOS)",
					"3501": "SERNA DEL MONTE (LA)",
					"3502": "SERRANILLOS DEL VALLE",
					"3503": "SEVILLA LA NUEVA",
					"3504": "SOTO DEL REAL",
					"3505": "TALAMANCA DE JARAMA",
					"3506": "TITULCIA",
					"3507": "TORREJON DE ARDOZ",
					"3508": "TORREJON DE LA CALZADA",
					"3509": "TORREJON DE VELASCO",
					"3510": "TORRELAGUNA",
					"3511": "TORRELODONES",
					"3512": "TORREMOCHA DE JARAMA",
					"3513": "TORRES DE LA ALAMEDA",
					"3514": "VALDARACETE",
					"3515": "VALDEAVERO",
					"3516": "VALDELAGUNA",
					"3517": "VALDEMANCO",
					"3518": "VALDEMAQUEDA",
					"3519": "VALDEMORILLO",
					"3520": "VALDEMORO",
					"3521": "VALDEOLMOS-ALALPARDO",
					"3522": "VALDEPIELAGOS",
					"3523": "VALDETORRES DE JARAMA",
					"3524": "VALDILECHA",
					"3525": "VALVERDE DE ALCALA",
					"3526": "VELILLA DE SAN ANTONIO",
					"3527": "VELLON (EL)",
					"3528": "VENTURADA",
					"3529": "VILLACONEJOS",
					"3530": "VILLA DEL PRADO",
					"3531": "VILLALBILLA",
					"3532": "VILLAMANRIQUE DE TAJO",
					"3533": "VILLAMANTA",
					"3534": "VILLAMANTILLA",
					"3535": "VILLANUEVA DE LA CAÑADA",
					"3536": "VILLANUEVA DEL PARDILLO",
					"3537": "VILLANUEVA DE PERALES",
					"3538": "VILLAR DEL OLMO",
					"3539": "VILLAREJO DE SALVANES",
					"3540": "VILLAVICIOSA DE ODON",
					"3541": "VILLAVIEJA DEL LOZOYA",
					"3542": "ZARZALEJO",
					"3543": "LOZOYUELA-NAVAS-SIETEIGLESIAS",
					"3544": "PUENTES VIEJAS",
					"3545": "TRES CANTOS",
					"6573": "ALAMEDA DEL VALLE",
					"6574": "ALCORCON",
					"6575": "ALPEDRETE",
					"6576": "ARANJUEZ",
					"6577": "ATAZAR (EL)",
					"6578": "BELMONTE DE TAJO",
					"6579": "BOALO (EL)",
					"6580": "BRUNETE",
					"6581": "CABANILLAS DE LA SIERRA",
					"6582": "CANENCIA",
					"6583": "CENICIENTOS",
					"6584": "CIEMPOZUELOS",
					"6585": "COLMENAREJO",
					"6586": "COLLADO VILLALBA",
					"6587": "CHAPINERIA",
					"6588": "ESTREMERA",
					"6589": "FUENLABRADA",
					"6590": "GALAPAGAR",
					"6591": "GASCONES",
					"6592": "GUADALIX DE LA SIERRA",
					"6593": "HOYO DE MANZANARES",
					"6594": "LOZOYA",
					"6595": "MAJADAHONDA",
					"6596": "MEJORADA DEL CAMPO",
					"6597": "MORALEJA DE ENMEDIO",
					"6598": "NAVACERRADA",
					"6599": "NAVARREDONDA Y SAN MAMES",
					"6600": "PARACUELLOS DE JARAMA",
					"6601": "PERALES DE TAJUÑA",
					"6602": "PIÑUECAR-GANDULLAS",
					"6603": "QUIJORNA",
					"6604": "RIBATEJADA",
					"6605": "ROBLEDO DE CHAVELA",
					"6606": "SAN AGUSTIN DEL GUADALIX",
					"6607": "SANTA MARIA DE LA ALAMEDA",
					"6608": "SOMOSIERRA",
					"6609": "TIELMES"
				}
			},
			"29": {
				"nameProvincia": "Málaga",
				"idProvincia": "29",
				"localidades": {
					"2606": "ARCHEZ",
					"2607": "ARCHIDONA",
					"2608": "ARDALES",
					"2609": "ARENAS",
					"2610": "ARRIATE",
					"2611": "ATAJATE",
					"2612": "BENADALID",
					"2613": "BENAHAVIS",
					"2614": "BENALAURIA",
					"2615": "BENALMADENA",
					"2616": "BENAMARGOSA",
					"2617": "BENAMOCARRA",
					"2618": "BENAOJAN",
					"2619": "BENARRABA",
					"2620": "BORGE (EL)",
					"2621": "BURGO (EL)",
					"2622": "CAMPILLOS",
					"2623": "CANILLAS DE ACEITUNO",
					"2624": "CANILLAS DE ALBAIDA",
					"2625": "CAÑETE LA REAL",
					"2626": "CARRATRACA",
					"2627": "CARTAJIMA",
					"2628": "CARTAMA",
					"2629": "CASABERMEJA",
					"2630": "CASARABONELA",
					"2631": "CASARES",
					"2632": "COIN",
					"2633": "COLMENAR",
					"2634": "COMARES",
					"2635": "COMPETA",
					"2636": "CORTES DE LA FRONTERA",
					"2637": "CUEVAS BAJAS",
					"2638": "CUEVAS DEL BECERRO",
					"2639": "CUEVAS DE SAN MARCOS",
					"2640": "CUTAR",
					"2641": "ESTEPONA",
					"2642": "FARAJAN",
					"2643": "FRIGILIANA",
					"2644": "FUENGIROLA",
					"2645": "FUENTE DE PIEDRA",
					"2646": "GAUCIN",
					"2647": "GENALGUACIL",
					"2648": "GUARO",
					"2649": "HUMILLADERO",
					"2650": "IGUALEJA",
					"2651": "ISTAN",
					"2652": "IZNATE",
					"2653": "JIMERA DE LIBAR",
					"2654": "JUBRIQUE",
					"2655": "JUZCAR",
					"2656": "MACHARAVIAYA",
					"2657": "MALAGA",
					"2658": "MANILVA",
					"2659": "MARBELLA",
					"2660": "MIJAS",
					"2661": "MOCLINEJO",
					"2662": "MOLLINA",
					"2663": "MONDA",
					"2664": "MONTEJAQUE",
					"2665": "NERJA",
					"2666": "OJEN",
					"2667": "PARAUTA",
					"2668": "PERIANA",
					"2669": "PIZARRA",
					"2670": "PUJERRA",
					"2671": "RINCON DE LA VICTORIA",
					"2672": "RIOGORDO",
					"2673": "RONDA",
					"2674": "SALARES",
					"2675": "SAYALONGA",
					"2676": "SEDELLA",
					"2677": "SIERRA DE YEGUAS",
					"2678": "TEBA",
					"2679": "TOLOX",
					"2680": "TORROX",
					"2681": "TOTALAN",
					"3340": "VALLE DE ABDALAJIS",
					"3546": "ALAMEDA",
					"3547": "ALCAUCIN",
					"3548": "ALFARNATE",
					"3549": "ALFARNATEJO",
					"3550": "ALGARROBO",
					"3551": "ALGATOCIN",
					"3552": "ALHAURIN DE LA TORRE",
					"3553": "ALHAURIN EL GRANDE",
					"3554": "ALMACHAR",
					"3555": "ALMARGEN",
					"3556": "ALMOGIA",
					"3557": "ALORA",
					"3558": "ALOZAINA",
					"3559": "ALPANDEIRE",
					"3794": "VILLANUEVA DEL ROSARIO",
					"4027": "VELEZ-MALAGA",
					"4028": "VILLANUEVA DE ALGAIDAS",
					"4275": "VILLANUEVA DEL TRABUCO",
					"4276": "VILLANUEVA DE TAPIA",
					"4277": "VIÑUELA",
					"4278": "YUNQUERA",
					"4279": "TORREMOLINOS",
					"4442": "ANTEQUERA"
				}
			},
			"30": {
				"nameProvincia": "Murcia",
				"idProvincia": "30",
				"localidades": {
					"4280": "ABANILLA",
					"4281": "ABARAN",
					"4282": "AGUILAS",
					"4283": "ALBUDEITE",
					"4284": "ALCANTARILLA",
					"4285": "ALEDO",
					"4286": "ALGUAZAS",
					"4287": "ALHAMA DE MURCIA",
					"4288": "ARCHENA",
					"4289": "BENIEL",
					"4290": "BLANCA",
					"4291": "BULLAS",
					"4292": "CALASPARRA",
					"4293": "CAMPOS DEL RIO",
					"4294": "CARAVACA DE LA CRUZ",
					"4295": "CARTAGENA",
					"4296": "CEHEGIN",
					"4297": "CEUTI",
					"4298": "CIEZA",
					"4299": "FORTUNA",
					"4300": "FUENTE ALAMO DE MURCIA",
					"4301": "JUMILLA",
					"4302": "LIBRILLA",
					"4303": "LORCA",
					"4304": "LORQUI",
					"4305": "MAZARRON",
					"4306": "MOLINA DE SEGURA",
					"4307": "MORATALLA",
					"4308": "MULA",
					"4309": "MURCIA",
					"4310": "OJOS",
					"4311": "PLIEGO",
					"4312": "PUERTO LUMBRERAS",
					"4313": "RICOTE",
					"4314": "SAN JAVIER",
					"4315": "SAN PEDRO DEL PINATAR",
					"4316": "TORRE-PACHECO",
					"4317": "TORRES DE COTILLAS (LAS)",
					"4318": "TOTANA",
					"4319": "ULEA",
					"4320": "UNION (LA)",
					"4321": "VILLANUEVA DEL RIO SEGURA",
					"4322": "YECLA",
					"4323": "SANTOMERA",
					"6512": "ALCAZARES (LOS)"
				}
			},
			"31": {
				"nameProvincia": "Navarra / Nafarroa",
				"idProvincia": "31",
				"localidades": {
					"1923": "SANSOL",
					"1924": "SANTACARA",
					"1925": "DONEZTEBE/SANTESTEBAN",
					"1926": "SARTAGUDA",
					"1927": "SESMA",
					"1928": "SORLADA",
					"1929": "TAFALLA",
					"1930": "TIEBAS-MURUARTE DE RETA",
					"1931": "TORRALBA DEL RIO",
					"1932": "TORRES DEL RIO",
					"1933": "TULEBRAS",
					"1934": "UJUE",
					"1935": "ULTZAMA",
					"1936": "UNCITI",
					"1937": "UNZUE",
					"1938": "URDAZUBI/URDAX",
					"1939": "URDIAIN",
					"1940": "URRAUL ALTO",
					"1941": "URRAUL BAJO",
					"1942": "URROZ",
					"1943": "URROTZ",
					"1944": "URZAINQUI",
					"1945": "UTERGA",
					"1946": "UZTARROZ/UZTARROZE",
					"1947": "LUZAIDE/VALCARLOS",
					"1948": "VALTIERRA",
					"1949": "BERA/VERA DE BIDASOA",
					"1950": "VIANA",
					"1951": "VIDANGOZ/BIDANKOZE",
					"1952": "BIDAURRETA",
					"1953": "VILLAFRANCA",
					"1954": "VILLAMAYOR DE MONJARDIN",
					"1955": "HIRIBERRI/VILLANUEVA DE AEZKOA",
					"1956": "VILLATUERTA",
					"1957": "VILLAVA/ATARRABIA",
					"1958": "IGANTZI",
					"1959": "YERRI",
					"1960": "YESA",
					"1961": "ZABALZA",
					"1962": "ZUBIETA",
					"1963": "ZUGARRAMURDI",
					"1964": "ZUÑIGA",
					"1965": "BARAÑAIN",
					"1966": "BERRIOPLANO",
					"1967": "BERRIOZAR",
					"1968": "IRURTZUN",
					"1969": "BERIAIN",
					"1970": "ORCOYEN",
					"1971": "ZIZUR MAYOR/ZIZUR NAGUSIA",
					"1972": "LEKUNBERRI",
					"2587": "SANGÜESA/ZANGOZA",
					"4324": "ABAIGAR",
					"4325": "ABARZUZA",
					"4326": "ABAURREGAINA/ABAURREA ALTA",
					"4327": "ABERIN",
					"4328": "ABLITAS",
					"4329": "ADIOS",
					"4330": "AGUILAR DE CODES",
					"4331": "AIBAR/OIBAR",
					"4332": "ALLIN",
					"4333": "ALLO",
					"4334": "AMESCOA BAJA",
					"4335": "ANDOSILLA",
					"4336": "ANUE",
					"4337": "AÑORBE",
					"4338": "ARAITZ",
					"4339": "ARANARACHE",
					"4340": "ARANGUREN",
					"4341": "ARANO",
					"4342": "ARAS",
					"4343": "ARCE/ARTZI",
					"4344": "ARCOS (LOS)",
					"4345": "ARESO",
					"4346": "ARGUEDAS",
					"4347": "ARIBE",
					"4348": "ARRONIZ",
					"4349": "ARRUAZU",
					"4350": "ARTAZU",
					"4351": "ATEZ",
					"4352": "AZAGRA",
					"4353": "BAKAIKU",
					"4354": "BARASOAIN",
					"4355": "BARGOTA",
					"4356": "BARILLAS",
					"4357": "BAZTAN",
					"4358": "BEIRE",
					"4359": "BERBINZANA",
					"4360": "BERTIZARANA",
					"4361": "BIURRUN-OLCOZ",
					"4362": "AURITZ/BURGUETE",
					"4363": "BURGUI/BURGI",
					"4364": "BUSTO (EL)",
					"4365": "CABANILLAS",
					"4366": "CABREDO",
					"4367": "CAPARROSO",
					"4368": "CARCAR",
					"4369": "CASCANTE",
					"4370": "CASEDA",
					"4371": "CASTILLONUEVO",
					"4372": "CINTRUENIGO",
					"4373": "CIRAUQUI",
					"4374": "CIZUR",
					"4375": "CORELLA",
					"4376": "DESOJO",
					"4377": "DONAMARIA",
					"4378": "ETXALAR",
					"4379": "ECHARRI",
					"4380": "ETXAURI",
					"4381": "EGÜES",
					"4382": "ELGORRIAGA",
					"4383": "ENERIZ",
					"4384": "ERATSUN",
					"4385": "ERGOIENA",
					"4386": "ERRO",
					"4387": "EZCAROZ/EZKAROZE",
					"4388": "ESPARZA DE SALAZAR",
					"4389": "ESPRONCEDA",
					"4390": "ESTERIBAR",
					"4391": "ETAYO",
					"4392": "EULATE",
					"4393": "EZKURRA",
					"4394": "EZPROGUI",
					"4395": "FITERO",
					"4396": "FUNES",
					"4397": "FUSTIÑANA",
					"4398": "GALLIPIENZO",
					"4399": "GARAIOA",
					"4400": "GARDE",
					"4401": "GARINOAIN",
					"4402": "GENEVILLA",
					"4403": "GOIZUETA",
					"4404": "GÜESA/GORZA",
					"4405": "GUIRGUILLANO",
					"4406": "HUARTE/UHARTE",
					"4407": "IBARGOITI",
					"4408": "IGUZQUIZA",
					"4409": "IMOTZ",
					"4410": "ISABA/IZABA",
					"4411": "ITURMENDI",
					"4412": "IZA",
					"4413": "IZALZU/ITZALTZU",
					"4414": "JAURRIETA",
					"4415": "JUSLAPEÑA",
					"4416": "BEINTZA-LABAIEN",
					"4417": "LANA",
					"4418": "LAPOBLACION",
					"4419": "LARRAGA",
					"4420": "LARRAUN",
					"4421": "LAZAGURRIA",
					"4422": "LEGARDA",
					"4423": "LEITZA",
					"4424": "LEOZ",
					"4425": "LERIN",
					"4426": "LEZAUN",
					"4427": "LIEDENA",
					"4428": "LODOSA",
					"4429": "LUMBIER",
					"4430": "LUQUIN",
					"4431": "MAÑERU",
					"4432": "MARCILLA",
					"4433": "MELIDA",
					"4434": "MENDAZA",
					"4435": "MENDIGORRIA",
					"4436": "MILAGRO",
					"4437": "MIRAFUENTES",
					"4438": "MONREAL",
					"4439": "MONTEAGUDO",
					"4440": "MORENTIN",
					"4441": "MURCHANTE",
					"4443": "MURILLO EL CUENDE",
					"4444": "MURILLO EL FRUTO",
					"4445": "MURUZABAL",
					"4446": "NAVASCUES",
					"4447": "NAZAR",
					"4448": "OBANOS",
					"4449": "OCO",
					"4450": "OCHAGAVIA",
					"4451": "ODIETA",
					"4452": "OITZ",
					"4453": "OLAIBAR",
					"4454": "OLAZTI/OLAZAGUTIA",
					"4455": "OLEJUA",
					"4456": "OLITE",
					"4457": "OLORIZ",
					"4458": "OLZA",
					"4459": "OLLO",
					"4460": "ORBAITZETA",
					"4461": "ORBARA",
					"4462": "ORISOAIN",
					"4463": "ORONZ",
					"4464": "OROZ-BETELU",
					"4465": "OTEIZA",
					"4466": "PAMPLONA/IRUÑA",
					"4467": "PERALTA",
					"4468": "PETILLA DE ARAGON",
					"4469": "PIEDRAMILLERA",
					"4470": "PITILLAS",
					"4471": "PUENTE LA REINA/GARES",
					"4472": "PUEYO",
					"4473": "RIBAFORADA",
					"4474": "ROMANZADO",
					"4475": "RONCAL/ERRONKARI",
					"4476": "ORREAGA/RONCESVALLES",
					"4477": "SADA",
					"4478": "SALDIAS",
					"4479": "SALINAS DE ORO",
					"4480": "SAN ADRIAN",
					"6513": "ABAURREPEA/ABAURREA BAJA",
					"6514": "ALTSASU/ALSASUA",
					"6515": "ANCIN",
					"6516": "ANSOAIN",
					"6517": "AOIZ/AGOITZ",
					"6518": "ARANTZA",
					"6519": "ARAKIL",
					"6520": "ARBIZU",
					"6521": "ARELLANO",
					"6522": "ARIA",
					"6523": "ARMAÑANZAS",
					"6524": "ARTAJONA",
					"6525": "AYEGUI",
					"6526": "AZUELO",
					"6527": "BARBARIN",
					"6528": "BASABURUA",
					"6529": "BELASCOAIN",
					"6530": "BETELU",
					"6531": "BUÑUEL",
					"6532": "BURLADA/BURLATA",
					"6533": "CADREITA",
					"6534": "CARCASTILLO",
					"6535": "CASTEJON",
					"6536": "ZIORDIA",
					"6537": "CIRIZA",
					"6538": "CORTES",
					"6539": "DICASTILLO",
					"6540": "ETXARRI-ARANATZ",
					"6541": "NOAIN (VALLE DE ELORZ)/NOAIN (",
					"6542": "ESLAVA",
					"6543": "ESTELLA/LIZARRA",
					"6544": "EZCABARTE",
					"6545": "FALCES",
					"6546": "FONTELLAS",
					"6547": "GALAR",
					"6548": "GALLUES/GALOZE",
					"6549": "GARRALDA",
					"6550": "GOÑI",
					"6551": "GUESALAZ",
					"6552": "UHARTE-ARAKIL",
					"6553": "IRAÑETA",
					"6554": "ITUREN",
					"6555": "IZAGAONDOA",
					"6556": "JAVIER",
					"6557": "LAKUNTZA",
					"6558": "LANTZ",
					"6559": "LARRAONA",
					"6560": "LEACHE",
					"6561": "LEGARIA",
					"6562": "LERGA",
					"6563": "LESAKA",
					"6564": "LIZOAIN",
					"6565": "LONGUIDA/LONGIDA",
					"6566": "MARAÑON",
					"6567": "MENDAVIA",
					"6568": "METAUTEN",
					"6569": "MIRANDA DE ARGA",
					"6570": "MUES",
					"6571": "MURIETA",
					"7357": "SAN MARTIN DE UNX",
					"7358": "SARRIES/SARTZE",
					"7359": "SUNBILLA",
					"7360": "TIRAPU",
					"7361": "TUDELA",
					"7362": "UCAR"
				}
			},
			"32": {
				"nameProvincia": "Orense / Ourense",
				"idProvincia": "32",
				"localidades": {
					"1973": "ALLARIZ",
					"1974": "AMOEIRO",
					"1975": "ARNOIA (A)",
					"1976": "AVION",
					"1977": "BALTAR",
					"1978": "BANDE",
					"1979": "BAÑOS DE MOLGAS",
					"1980": "BARBADAS",
					"1981": "BARCO DE VALDEORRAS (O)",
					"1982": "BEADE",
					"1983": "BEARIZ",
					"1984": "BLANCOS (OS)",
					"1985": "BOBORAS",
					"1986": "BOLA (A)",
					"1987": "BOLO (O)",
					"1988": "CALVOS DE RANDIN",
					"1989": "CARBALLEDA DE VALDEORRAS",
					"1990": "CARBALLEDA DE AVIA",
					"1991": "CARBALLIÑO (O)",
					"1992": "CARTELLE",
					"1993": "CASTRELO DO VAL",
					"1994": "CASTRELO DE MIÑO",
					"1995": "CASTRO CALDELAS",
					"1996": "CELANOVA",
					"1997": "CENLLE",
					"1998": "COLES",
					"1999": "CORTEGADA",
					"2000": "CUALEDRO",
					"2001": "CHANDREXA DE QUEIXA",
					"2002": "ENTRIMO",
					"2003": "ESGOS",
					"2004": "XINZO DE LIMIA",
					"2005": "GOMESENDE",
					"2006": "GUDIÑA (A)",
					"2007": "IRIXO (O)",
					"2008": "XUNQUEIRA DE AMBIA",
					"2009": "XUNQUEIRA DE ESPADANEDO",
					"2010": "LAROUCO",
					"2011": "LAZA",
					"2012": "LEIRO",
					"2013": "LOBEIRA",
					"2014": "LOBIOS",
					"2015": "MACEDA",
					"2016": "MANZANEDA",
					"2017": "MASIDE",
					"2018": "MELON",
					"2019": "MERCA (A)",
					"2020": "MEZQUITA (A)",
					"2021": "MONTEDERRAMO",
					"2022": "MONTERREI",
					"2023": "MUIÑOS",
					"2024": "NOGUEIRA DE RAMUIN",
					"2025": "OIMBRA",
					"2026": "OURENSE",
					"2027": "PADERNE DE ALLARIZ",
					"2451": "PADRENDA",
					"2452": "PARADA DE SIL",
					"2453": "PEREIRO DE AGUIAR (O)",
					"2454": "PEROXA (A)",
					"2455": "PETIN",
					"2456": "PIÑOR",
					"2457": "PORQUEIRA",
					"2458": "POBRA DE TRIVES (A)",
					"2459": "PONTEDEVA",
					"2460": "PUNXIN",
					"2461": "QUINTELA DE LEIRADO",
					"2462": "RAIRIZ DE VEIGA",
					"2463": "RAMIRAS",
					"2464": "RIBADAVIA",
					"2465": "SAN XOAN DE RIO",
					"2466": "RIOS",
					"2467": "RUA (A)",
					"2468": "RUBIA",
					"2469": "SAN AMARO",
					"2470": "SAN CIBRAO DAS VIÑAS",
					"2471": "SAN CRISTOVO DE CEA",
					"2472": "SANDIAS",
					"2473": "SARREAUS",
					"2474": "TABOADELA",
					"2475": "TEIXEIRA (A)",
					"2476": "TOEN",
					"2477": "TRASMIRAS",
					"2478": "VEIGA (A)",
					"2479": "VEREA",
					"2480": "VERIN",
					"2481": "VIANA DO BOLO",
					"2482": "VILAMARIN",
					"2483": "VILAMARTIN DE VALDEORRAS",
					"2484": "VILAR DE BARRIO",
					"2485": "VILAR DE SANTOS",
					"2486": "VILARDEVOS",
					"2487": "VILARIÑO DE CONSO"
				}
			},
			"33": {
				"nameProvincia": "Asturias",
				"idProvincia": "33",
				"localidades": {
					"2488": "ALLANDE",
					"2489": "ALLER",
					"2490": "AMIEVA",
					"2491": "AVILES",
					"2492": "BELMONTE DE MIRANDA",
					"2493": "BIMENES",
					"2494": "BOAL",
					"2495": "CABRANES",
					"2496": "CANDAMO",
					"2497": "CANGAS DE ONIS",
					"2498": "CARAVIA",
					"2499": "CARREÑO",
					"2500": "CASTRILLON",
					"2501": "COAÑA",
					"2502": "COLUNGA",
					"2503": "CUDILLERO",
					"2504": "DEGAÑA",
					"2505": "FRANCO (EL)",
					"2506": "GIJON",
					"2507": "GRADO",
					"2508": "IBIAS",
					"2509": "ILLANO",
					"2510": "ILLAS",
					"2511": "LAVIANA",
					"2512": "LENA",
					"2513": "LLANERA",
					"2514": "LLANES",
					"2515": "MORCIN",
					"2516": "NAVA",
					"2517": "NAVIA",
					"2518": "NOREÑA",
					"2519": "OVIEDO",
					"2520": "PEÑAMELLERA ALTA",
					"2521": "PEÑAMELLERA BAJA",
					"2522": "PILOÑA",
					"2523": "PRAVIA",
					"2524": "QUIROS",
					"2525": "REGUERAS (LAS)",
					"2526": "RIBADESELLA",
					"2527": "RIBERA DE ARRIBA",
					"2528": "SALAS",
					"2529": "SAN MARTIN DE OSCOS",
					"2530": "SANTA EULALIA DE OSCOS",
					"2531": "SAN TIRSO DE ABRES",
					"2532": "SANTO ADRIANO",
					"2533": "SARIEGO",
					"2534": "SOBRESCOBIO",
					"2535": "SOTO DEL BARCO",
					"2536": "TAPIA DE CASARIEGO",
					"2537": "TEVERGA",
					"2538": "TINEO",
					"2539": "VILLANUEVA DE OSCOS",
					"2540": "VILLAVICIOSA",
					"2541": "YERNES Y TAMEZA",
					"7363": "CABRALES",
					"7364": "CANGAS DEL NARCEA",
					"7365": "CASO",
					"7366": "CASTROPOL",
					"7367": "CORVERA DE ASTURIAS",
					"7368": "GOZON",
					"7369": "GRANDAS DE SALIME",
					"7370": "LANGREO",
					"7371": "VALDES",
					"7372": "MIERES",
					"7373": "MUROS DE NALON",
					"7374": "ONIS",
					"7375": "PARRES",
					"7376": "PESOZ",
					"7377": "PONGA",
					"7378": "PROAZA",
					"7379": "RIBADEDEVA",
					"7380": "RIOSA",
					"7381": "SAN MARTIN DEL REY AURELIO",
					"7382": "SIERO",
					"7383": "SOMIEDO",
					"7384": "TARAMUNDI",
					"7385": "VEGADEO",
					"7386": "VILLAYON"
				}
			},
			"34": {
				"nameProvincia": "Palencia",
				"idProvincia": "34",
				"localidades": {
					"1922": "MENESES DE CAMPOS",
					"2330": "MICIECES DE OJEDA",
					"2331": "MORATINOS",
					"2332": "MUDA",
					"2333": "NOGAL DE LAS HUERTAS",
					"2334": "OLMOS DE OJEDA",
					"2335": "OSORNILLO",
					"2336": "PALENCIA",
					"2337": "PARAMO DE BOEDO",
					"2338": "PAREDES DE NAVA",
					"2339": "PEDRAZA DE CAMPOS",
					"2340": "PEDROSA DE LA VEGA",
					"2341": "PERALES",
					"2342": "PIÑA DE CAMPOS",
					"2343": "POBLACION DE ARROYO",
					"2344": "POBLACION DE CERRATO",
					"2345": "POLENTINOS",
					"2346": "POMAR DE VALDIVIA",
					"2347": "POZA DE LA VEGA",
					"2348": "PRADANOS DE OJEDA",
					"2349": "PUEBLA DE VALDAVIA (LA)",
					"2350": "QUINTANA DEL PUENTE",
					"2351": "REINOSO DE CERRATO",
					"2352": "RENEDO DE LA VEGA",
					"2353": "REQUENA DE CAMPOS",
					"2354": "RESPENDA DE LA PEÑA",
					"2355": "REVENGA DE CAMPOS",
					"2356": "REVILLA DE COLLAZOS",
					"2357": "RIBAS DE CAMPOS",
					"2358": "RIBEROS DE LA CUEZA",
					"2359": "SALDAÑA",
					"2360": "SALINAS DE PISUERGA",
					"2361": "SAN CEBRIAN DE CAMPOS",
					"2362": "SAN CEBRIAN DE MUDA",
					"2363": "SAN CRISTOBAL DE BOEDO",
					"2364": "SAN MAMES DE CAMPOS",
					"2365": "SAN ROMAN DE LA CUBA",
					"2366": "SANTA CECILIA DEL ALCOR",
					"2367": "SANTA CRUZ DE BOEDO",
					"2368": "SANTERVAS DE LA VEGA",
					"2369": "SANTIBAÑEZ DE ECLA",
					"2370": "SANTIBAÑEZ DE LA PEÑA",
					"2371": "SANTOYO",
					"2372": "SERNA (LA)",
					"2373": "SOTOBAÑADO Y PRIORATO",
					"2374": "SOTO DE CERRATO",
					"2375": "TABANERA DE CERRATO",
					"2376": "TABANERA DE VALDAVIA",
					"2377": "TAMARA DE CAMPOS",
					"2378": "TARIEGO DE CERRATO",
					"2379": "TORQUEMADA",
					"2380": "TORREMORMOJON",
					"2381": "TRIOLLO",
					"2382": "VALBUENA DE PISUERGA",
					"2383": "VALDEOLMILLOS",
					"2384": "VALDERRABANO",
					"2385": "VALDE-UCIEZA",
					"2386": "VALLE DE CERRATO",
					"2387": "VELILLA DEL RIO CARRION",
					"2388": "VERTAVILLO",
					"2389": "VILLABASTA DE VALDAVIA",
					"2390": "VILLACIDALER",
					"2391": "VILLACONANCIO",
					"2392": "VILLADA",
					"2393": "VILLAELES DE VALDAVIA",
					"2394": "VILLAHAN",
					"2395": "VILLAHERREROS",
					"2396": "VILLALACO",
					"2397": "VILLALBA DE GUARDO",
					"2398": "VILLALCAZAR DE SIRGA",
					"2399": "VILLALCON",
					"2400": "VILLALOBON",
					"2401": "VILLALUENGA DE LA VEGA",
					"2402": "VILLAMARTIN DE CAMPOS",
					"2403": "VILLAMEDIANA",
					"2404": "VILLAMERIEL",
					"2405": "VILLAMORONTA",
					"2406": "VILLAMUERA DE LA CUEZA",
					"2407": "VILLAMURIEL DE CERRATO",
					"2408": "VILLANUEVA DEL REBOLLAR",
					"2409": "VILLANUÑO DE VALDAVIA",
					"2410": "VILLAPROVEDO",
					"2411": "VILLARMENTERO DE CAMPOS",
					"2412": "VILLARRABE",
					"2413": "VILLARRAMIEL",
					"2414": "VILLASARRACINO",
					"2415": "VILLASILA DE VALDAVIA",
					"2416": "VILLATURDE",
					"2417": "VILLAUMBRALES",
					"2418": "VILLAVIUDAS",
					"2419": "VILLERIAS DE CAMPOS",
					"2420": "VILLODRE",
					"2421": "VILLODRIGO",
					"2422": "VILLOLDO",
					"2423": "VILLOTA DEL PARAMO",
					"2424": "VILLOVIECO",
					"2425": "OSORNO LA MAYOR",
					"2426": "VALLE DEL RETORTILLO",
					"2427": "LOMA DE UCIEZA",
					"2428": "PERNIA (LA)",
					"2542": "ABARCA DE CAMPOS",
					"2543": "AGUILAR DE CAMPOO",
					"2544": "ALAR DEL REY",
					"2545": "ALBA DE CERRATO",
					"2546": "AMPUDIA",
					"2547": "AMUSCO",
					"2548": "ANTIGÜEDAD",
					"2549": "ARCONADA",
					"2550": "AUTILLA DEL PINO",
					"2551": "AUTILLO DE CAMPOS",
					"2552": "BALTANAS",
					"2553": "BAQUERIN DE CAMPOS",
					"2554": "BARCENA DE CAMPOS",
					"2555": "BARRUELO DE SANTULLAN",
					"2556": "BECERRIL DE CAMPOS",
					"2557": "BELMONTE DE CAMPOS",
					"2558": "BERZOSILLA",
					"2559": "BOADILLA DEL CAMINO",
					"2560": "BOADILLA DE RIOSECO",
					"2561": "BRAÑOSERA",
					"2562": "BUSTILLO DE LA VEGA",
					"2563": "BUSTILLO DEL PARAMO DE CARRION",
					"2564": "CALAHORRA DE BOEDO",
					"2565": "CALZADA DE LOS MOLINOS",
					"2566": "CAPILLAS",
					"2567": "CARRION DE LOS CONDES",
					"2568": "CASTIL DE VELA",
					"2569": "CASTREJON DE LA PEÑA",
					"2570": "CASTRILLO DE DON JUAN",
					"2571": "CASTRILLO DE VILLAVEGA",
					"2572": "CASTROMOCHO",
					"2573": "CERVATOS DE LA CUEZA",
					"2574": "CEVICO DE LA TORRE",
					"2575": "CEVICO NAVERO",
					"2576": "CISNEROS",
					"2577": "COBOS DE CERRATO",
					"2578": "CONGOSTO DE VALDAVIA",
					"2579": "CORDOVILLA LA REAL",
					"2580": "CUBILLAS DE CERRATO",
					"2581": "DEHESA DE ROMANOS",
					"2582": "DUEÑAS",
					"2583": "ESPINOSA DE CERRATO",
					"2584": "ESPINOSA DE VILLAGONZALO",
					"2585": "FRESNO DEL RIO",
					"2586": "FROMISTA",
					"2588": "FUENTES DE VALDEPERO",
					"2589": "GRIJOTA",
					"2590": "GUAZA DE CAMPOS",
					"2591": "HERRERA DE PISUERGA",
					"2592": "HERRERA DE VALDECAÑAS",
					"2593": "HONTORIA DE CERRATO",
					"2594": "HORNILLOS DE CERRATO",
					"2595": "ITERO DE LA VEGA",
					"2596": "LAGARTOS",
					"2597": "VID DE OJEDA (LA)",
					"2598": "LEDIGOS",
					"2599": "MAGAZ DE PISUERGA",
					"2600": "MANQUILLOS",
					"2601": "MANTINOS",
					"2602": "MARCILLA DE CAMPOS",
					"2603": "MAZARIEGOS",
					"2604": "MAZUECOS DE VALDEGINATE",
					"2605": "MELGAR DE YUSO",
					"6504": "DEHESA DE MONTEJO",
					"6505": "FRECHILLA",
					"6506": "FUENTES DE NAVA",
					"6507": "GUARDO",
					"6508": "HERMEDES DE CERRATO",
					"6509": "HUSILLOS",
					"6510": "LANTADILLA",
					"6511": "LOMAS",
					"7316": "MONZON DE CAMPOS",
					"7317": "OLEA DE BOEDO",
					"7318": "PALENZUELA",
					"7319": "PAYO DE OJEDA",
					"7320": "PINO DEL RIO",
					"7321": "POBLACION DE CAMPOS",
					"7322": "POZO DE URAMA",
					"7323": "QUINTANILLA DE ONSOÑA",
					"7387": "ABIA DE LAS TORRES",
					"7388": "AMAYUELAS DE ARRIBA",
					"7389": "ASTUDILLO",
					"7390": "AYUELA",
					"7391": "VENTA DE BAÑOS",
					"7392": "BASCONES DE OJEDA",
					"7393": "BOADA DE CAMPOS",
					"7394": "BUENAVISTA DE VALDAVIA",
					"7395": "CARDEÑOSA DE VOLPEJERA",
					"7396": "CASTRILLO DE ONIELO",
					"7397": "CERVERA DE PISUERGA",
					"7626": "COLLAZOS DE BOEDO"
				}
			},
			"35": {
				"nameProvincia": "Las Palmas",
				"idProvincia": "35",
				"localidades": {
					"1798": "SANTA LUCIA DE TIRAJANA",
					"1799": "SANTA MARIA DE GUIA DE GRAN CA",
					"1800": "TEGUISE",
					"1801": "TEJEDA",
					"1802": "TELDE",
					"1803": "TEROR",
					"1804": "TIAS",
					"1805": "TINAJO",
					"1806": "TUINEJE",
					"1807": "VALSEQUILLO DE GRAN CANARIA",
					"1808": "VALLESECO",
					"1809": "VEGA DE SAN MATEO",
					"1810": "YAIZA",
					"2429": "AGAETE",
					"2430": "AGÜIMES",
					"2431": "ANTIGUA",
					"2432": "ARRECIFE",
					"2433": "ARTENARA",
					"2434": "ARUCAS",
					"2435": "BETANCURIA",
					"2436": "FIRGAS",
					"2437": "GALDAR",
					"2438": "HARIA",
					"2439": "INGENIO",
					"2440": "MOGAN",
					"2441": "MOYA",
					"2442": "OLIVA (LA)",
					"2443": "PAJARA",
					"2444": "PALMAS DE GRAN CANARIA (LAS)",
					"2445": "PUERTO DEL ROSARIO",
					"2446": "SAN BARTOLOME",
					"2447": "SAN BARTOLOME DE TIRAJANA",
					"2449": "SAN NICOLAS DE TOLENTINO",
					"2450": "SANTA BRIGIDA"
				}
			},
			"36": {
				"nameProvincia": "Pontevedra",
				"idProvincia": "36",
				"localidades": {
					"1811": "ARBO",
					"1812": "BARRO",
					"1813": "BAIONA",
					"1814": "BUEU",
					"1815": "CALDAS DE REIS",
					"1816": "CAMBADOS",
					"1817": "CAMPO LAMEIRO",
					"1818": "CANGAS",
					"1819": "CAÑIZA (A)",
					"1820": "CATOIRA",
					"1823": "COVELO",
					"1824": "CRECENTE",
					"1825": "CUNTIS",
					"1826": "DOZON",
					"1827": "ESTRADA (A)",
					"1828": "FORCAREI",
					"1829": "FORNELOS DE MONTES",
					"1830": "AGOLADA",
					"1831": "GONDOMAR",
					"1832": "GROVE (O)",
					"1833": "GUARDA (A)",
					"1834": "LALIN",
					"1835": "LAMA (A)",
					"1836": "MARIN",
					"1837": "MEAÑO",
					"1838": "MEIS",
					"1839": "MOAÑA",
					"1840": "MONDARIZ-BALNEARIO",
					"1841": "MORAÑA",
					"1842": "NEVES (AS)",
					"1843": "OIA",
					"1844": "PONTEVEDRA",
					"1845": "PORRIÑO (O)",
					"1846": "PORTAS",
					"1847": "PONTEAREAS",
					"1848": "PONTECESURES",
					"1849": "REDONDELA",
					"1850": "RIBADUMIA",
					"1851": "ROSAL (O)",
					"1852": "SALCEDA DE CASELAS",
					"1853": "SANXENXO",
					"1854": "SILLEDA",
					"1855": "SOUTOMAIOR",
					"1856": "TUI",
					"1857": "VALGA",
					"1858": "VILABOA",
					"1859": "VILAGARCIA DE AROUSA",
					"1860": "VILANOVA DE AROUSA",
					"1861": "ILLA DE AROUSA (A)",
					"7324": "MONDARIZ",
					"7325": "MOS",
					"7326": "NIGRAN",
					"7327": "PAZOS DE BORBEN",
					"7328": "POIO",
					"7329": "PONTE CALDELAS",
					"7330": "RODEIRO",
					"7331": "SALVATERRA DE MIÑO",
					"7332": "TOMIÑO",
					"7333": "VIGO",
					"7334": "VILA DE CRUCES"
				}
			},
			"37": {
				"nameProvincia": "Salamanca",
				"idProvincia": "37",
				"localidades": {
					"207": "PUERTAS",
					"1124": "PUEBLA DE YELTES",
					"1384": "VITIGUDINO",
					"1385": "ZAMARRA",
					"1386": "ZAMAYON",
					"1387": "ZARAPICOS",
					"1388": "ZORITA DE LA FRONTERA",
					"1862": "AGALLAS",
					"1863": "AHIGAL DE LOS ACEITEROS",
					"1864": "ALAMEDA DE GARDON (LA)",
					"1865": "ALAMEDILLA (LA)",
					"1866": "ALARAZ",
					"1867": "ALBA DE YELTES",
					"1868": "ALBERCA (LA)",
					"1869": "ALBERGUERIA DE ARGAÑAN (LA)",
					"1870": "ALDEACIPRESTE",
					"1871": "ALDEADAVILA DE LA RIBERA",
					"1872": "ALDEALENGUA",
					"1873": "ALDEANUEVA DE FIGUEROA",
					"1874": "ALDEANUEVA DE LA SIERRA",
					"1875": "ALDEARRUBIA",
					"1876": "ALDEASECA DE ALBA",
					"1877": "ALDEASECA DE LA FRONTERA",
					"1878": "ALDEAVIEJA DE TORMES",
					"1879": "ALDEHUELA DE LA BOVEDA",
					"1880": "ALMENARA DE TORMES",
					"1881": "ALMENDRA",
					"1882": "ANAYA DE ALBA",
					"1883": "AÑOVER DE TORMES",
					"1884": "ARAPILES",
					"1885": "ARCEDIANO",
					"1886": "ARCO (EL)",
					"1887": "SAN MIGUEL DEL ROBLEDO",
					"1888": "ATALAYA (LA)",
					"1889": "BABILAFUENTE",
					"1890": "BARBADILLO",
					"1891": "BARBALOS",
					"1892": "BARRUECOPARDO",
					"1893": "BEJAR",
					"1894": "BELEÑA",
					"1895": "BERMELLAR",
					"1896": "BERROCAL DE SALVATIERRA",
					"1897": "BOADA",
					"1898": "BODON (EL)",
					"1899": "BOUZA (LA)",
					"1900": "BOVEDA DEL RIO ALMAR",
					"1901": "BUENAMADRE",
					"1902": "BUENAVISTA",
					"1903": "CABEZABELLOSA DE LA CALZADA",
					"1904": "CABEZA DE BEJAR (LA)",
					"1905": "CABRERIZOS",
					"1906": "CABRILLAS",
					"1907": "CALVARRASA DE ABAJO",
					"1908": "CALZADA DE BEJAR (LA)",
					"1909": "CALZADA DE DON DIEGO",
					"1910": "CALZADA DE VALDUNCIEL",
					"1911": "CAMPILLO DE AZABA",
					"1912": "CANDELARIO",
					"1913": "CANILLAS DE ABAJO",
					"1914": "CANTAGALLO",
					"1915": "CANTALAPIEDRA",
					"1916": "CANTALPINO",
					"1917": "CARBAJOSA DE LA SAGRADA",
					"1918": "CARPIO DE AZABA",
					"1919": "CARRASCAL DEL OBISPO",
					"1920": "CASAFRANCA",
					"1921": "CASAS DEL CONDE (LAS)",
					"2093": "VILLORUELA",
					"2094": "CASTILLEJO DE MARTIN VIEJO",
					"2095": "CASTRAZ",
					"2096": "CEPEDA",
					"2097": "CERECEDA DE LA SIERRA",
					"2098": "CERRALBO",
					"2099": "CERRO (EL)",
					"2100": "CESPEDOSA DE TORMES",
					"2101": "CILLEROS DE LA BASTIDA",
					"2102": "CIUDAD RODRIGO",
					"2103": "COCA DE ALBA",
					"2104": "CORDOVILLA",
					"2105": "CRISTOBAL",
					"2106": "CUBO DE DON SANCHO (EL)",
					"2107": "CHAGARCIA MEDIANERO",
					"2108": "DOÑINOS DE LEDESMA",
					"2109": "DOÑINOS DE SALAMANCA",
					"2110": "EJEME",
					"2111": "ENCINA DE SAN SILVESTRE",
					"2112": "ENCINAS DE ABAJO",
					"2113": "ENCINASOLA DE LOS COMENDADORES",
					"2114": "ENDRINAL",
					"2115": "ESCURIAL DE LA SIERRA",
					"2116": "ESPEJA",
					"2117": "ESPINO DE LA ORBADA",
					"2118": "FORFOLEDA",
					"2119": "FRADES DE LA SIERRA",
					"2120": "FREGENEDA (LA)",
					"2121": "FRESNEDOSO",
					"2122": "FUENTE DE SAN ESTEBAN (LA)",
					"2123": "FUENTEGUINALDO",
					"2124": "FUENTELIANTE",
					"2125": "FUENTES DE BEJAR",
					"2126": "FUENTES DE OÑORO",
					"2127": "GAJATES",
					"2128": "GALINDO Y PERAHUY",
					"2129": "GALINDUSTE",
					"2130": "GALLEGOS DE ARGAÑAN",
					"2131": "GALLEGOS DE SOLMIRON",
					"2132": "GARCIBUEY",
					"2133": "GARCIHERNANDEZ",
					"2134": "GARCIRREY",
					"2135": "GEJUELO DEL BARRO",
					"2136": "GOLPEJAS",
					"2137": "GOMECELLO",
					"2138": "GUADRAMIRO",
					"2139": "GUIJO DE AVILA",
					"2140": "GUIJUELO",
					"2141": "HERGUIJUELA DE CIUDAD RODRIGO",
					"2142": "HERGUIJUELA DE LA SIERRA",
					"2143": "HERGUIJUELA DEL CAMPO",
					"2144": "HINOJOSA DE DUERO",
					"2145": "HORCAJO DE MONTEMAYOR",
					"2146": "HORCAJO MEDIANERO",
					"2147": "HOYA (LA)",
					"2148": "HUERTA",
					"2149": "IRUELOS",
					"2150": "ITUERO DE AZABA",
					"2151": "JUZBADO",
					"2152": "LAGUNILLA",
					"2153": "LARRODRIGO",
					"2154": "LEDESMA",
					"2155": "LEDRADA",
					"2156": "LINARES DE RIOFRIO",
					"2157": "LUMBRALES",
					"2158": "MACOTERA",
					"2159": "MACHACON",
					"2160": "MADROÑAL",
					"2161": "MAILLO (EL)",
					"2162": "MALPARTIDA",
					"2163": "MANCERA DE ABAJO",
					"2164": "MANZANO (EL)",
					"2165": "MARTIAGO",
					"2166": "MARTINAMOR",
					"2167": "MARTIN DE YELTES",
					"2168": "MASUECO",
					"2169": "CASTELLANOS DE VILLIQUERA",
					"2170": "MATA DE LEDESMA (LA)",
					"2171": "MATILLA DE LOS CAÑOS DEL RIO",
					"2172": "MAYA (LA)",
					"2173": "MEMBRIBE DE LA SIERRA",
					"2174": "MIEZA",
					"2175": "MILANO (EL)",
					"2176": "MIRANDA DE AZAN",
					"2177": "MIRANDA DEL CASTAÑAR",
					"2178": "MOGARRAZ",
					"2179": "MOLINILLO",
					"2180": "MONFORTE DE LA SIERRA",
					"2181": "MONLEON",
					"2182": "MONLERAS",
					"2183": "MONSAGRO",
					"2184": "MONTEJO",
					"2185": "MONTEMAYOR DEL RIO",
					"2186": "MONTERRUBIO DE ARMUÑA",
					"2187": "MONTERRUBIO DE LA SIERRA",
					"2188": "MORASVERDES",
					"2189": "MORILLE",
					"2190": "MORIÑIGO",
					"2191": "MORISCOS",
					"2192": "MORONTA",
					"2193": "MOZARBEZ",
					"2194": "NARROS DE MATALAYEGUA",
					"2195": "NAVACARROS",
					"2196": "NAVA DE BEJAR",
					"2197": "NAVA DE FRANCIA",
					"2198": "NAVA DE SOTROBAL",
					"2199": "NAVALES",
					"2200": "NAVALMORAL DE BEJAR",
					"2201": "NAVAMORALES",
					"2202": "NAVARREDONDA DE LA RINCONADA",
					"2203": "NAVASFRIAS",
					"2204": "NEGRILLA DE PALENCIA",
					"2205": "OLMEDO DE CAMACES",
					"2206": "ORBADA (LA)",
					"2207": "PAJARES DE LA LAGUNA",
					"2208": "PALACIOS DEL ARZOBISPO",
					"2209": "PALACIOSRUBIOS",
					"2210": "PALENCIA DE NEGRILLA",
					"2211": "PARADA DE ARRIBA",
					"2212": "PARADA DE RUBIALES",
					"2213": "PARADINAS DE SAN JUAN",
					"2214": "PASTORES",
					"2215": "PAYO (EL)",
					"2216": "PEDRAZA DE ALBA",
					"2217": "PEDROSILLO DE ALBA",
					"2218": "PEDROSILLO DE LOS AIRES",
					"2219": "PEDROSILLO EL RALO",
					"2220": "PEDROSO DE LA ARMUÑA (EL)",
					"2221": "PELABRAVO",
					"2222": "PELARRODRIGUEZ",
					"2223": "PELAYOS",
					"2224": "PEÑA (LA)",
					"2225": "PEÑACABALLERA",
					"2226": "PEÑAPARDA",
					"2227": "PEÑARANDA DE BRACAMONTE",
					"2228": "PEÑARANDILLA",
					"2229": "PERALEJOS DE ABAJO",
					"2230": "PERALEJOS DE ARRIBA",
					"2231": "PEREÑA DE LA RIBERA",
					"2232": "PEROMINGO",
					"2233": "PINEDAS",
					"2234": "PINO DE TORMES (EL)",
					"2235": "PITIEGUA",
					"2236": "PIZARRAL",
					"2237": "POVEDA DE LAS CINTAS",
					"2238": "POZOS DE HINOJO",
					"2239": "PUEBLA DE AZABA",
					"2240": "PUEBLA DE SAN MEDEL",
					"2241": "PUENTE DEL CONGOSTO",
					"2242": "PUERTO DE BEJAR",
					"2243": "PUERTO SEGURO",
					"2244": "RAGAMA",
					"2245": "REDONDA (LA)",
					"2246": "RETORTILLO",
					"2247": "RINCONADA DE LA SIERRA (LA)",
					"2248": "ROBLEDA",
					"2249": "ROBLIZA DE COJOS",
					"2250": "ROLLAN",
					"2251": "SAELICES EL CHICO",
					"2252": "SAGRADA (LA)",
					"2253": "SALAMANCA",
					"2254": "SALDEANA",
					"2255": "SALMORAL",
					"2256": "SALVATIERRA DE TORMES",
					"2257": "SAN CRISTOBAL DE LA CUESTA",
					"2258": "SANCTI-SPIRITUS",
					"2259": "SANCHON DE LA RIBERA",
					"2260": "SANCHON DE LA SAGRADA",
					"2261": "SANCHOTELLO",
					"2262": "SANDO",
					"2263": "SAN ESTEBAN DE LA SIERRA",
					"2264": "SAN FELICES DE LOS GALLEGOS",
					"2265": "SAN MIGUEL DE VALERO",
					"2266": "SAN MORALES",
					"2267": "SAN MUÑOZ",
					"2268": "SAN PEDRO DEL VALLE",
					"2269": "SAN PELAYO DE GUAREÑA",
					"2270": "SANTA MARIA DE SANDO",
					"2271": "SANTA MARTA DE TORMES",
					"2272": "SANTIAGO DE LA PUEBLA",
					"2273": "SANTIBAÑEZ DE LA SIERRA",
					"2274": "SANTIZ",
					"2275": "SANTOS (LOS)",
					"2276": "SARDON DE LOS FRAILES",
					"2277": "SAHUGO (EL)",
					"2278": "SEPULCRO-HILARIO",
					"2279": "SERRADILLA DEL ARROYO",
					"2280": "SIERPE (LA)",
					"2281": "SIETEIGLESIAS DE TORMES",
					"2282": "SOBRADILLO",
					"2283": "SORIHUELA",
					"2284": "TABERA DE ABAJO",
					"2285": "TALA (LA)",
					"2286": "TAMAMES",
					"2287": "TARDAGUILA",
					"2288": "TEJADO (EL)",
					"2289": "TEJEDA Y SEGOYUELA",
					"2290": "TERRADILLOS",
					"2291": "TOPAS",
					"2292": "TORNADIZO (EL)",
					"2293": "TORRESMENUDAS",
					"2294": "TREMEDAL DE TORMES",
					"2295": "VALDECARROS",
					"2296": "VALDEHIJADEROS",
					"2297": "VALDELACASA",
					"2298": "VALDELAGEVE",
					"2299": "VALDELOSA",
					"2300": "VALDERRODRIGO",
					"2301": "VALDUNCIEL",
					"2302": "VALERO",
					"2303": "VALVERDE DE VALDELACASA",
					"2304": "VALVERDON",
					"2305": "VECINOS",
					"2306": "VEGA DE TIRADOS",
					"2307": "VEGUILLAS (LAS)",
					"2308": "VELLES (LA)",
					"2309": "VIDOLA (LA)",
					"2310": "VILVESTRE",
					"2311": "VILLAFLORES",
					"2312": "VILLAGONZALO DE TORMES",
					"2313": "VILLAMAYOR",
					"2314": "VILLANUEVA DEL CONDE",
					"2315": "VILLAR DE ARGAÑAN",
					"2316": "VILLAR DE CIERVO",
					"2317": "VILLAR DE LA YEGUA",
					"2318": "VILLAR DE PERALONSO",
					"2319": "VILLAR DE SAMANIEGO",
					"2320": "VILLARES DE LA REINA",
					"2321": "VILLARINO DE LOS AIRES",
					"2322": "VILLARMAYOR",
					"2323": "VILLARMUERTO",
					"2324": "VILLASBUENAS",
					"2325": "VILLASECO DE LOS GAMITOS",
					"2326": "VILLASECO DE LOS REYES",
					"2327": "VILLAVERDE DE GUAREÑA",
					"2328": "VILLAVIEJA DE YELTES",
					"2329": "CASILLAS DE FLORES",
					"7242": "YECLA DE YELTES",
					"7243": "ZARZA DE PUMAREDA (LA)",
					"7282": "CASTELLANOS DE MORISCOS",
					"7283": "CEREZAL DE PEÑAHORCADA",
					"7284": "CIPEREZ",
					"7285": "COLMENAR DE MONTEMAYOR",
					"7286": "DIOS LE GUARDE",
					"7287": "ENCINA (LA)",
					"7288": "ENCINAS DE ARRIBA",
					"7289": "ESPADAÑA",
					"7290": "FLORIDA DE LIEBANA",
					"7291": "FRESNO ALHANDIGA",
					"7292": "FUENTERROBLE DE SALVATIERRA",
					"7293": "GALISANCHO",
					"7294": "SAN MARTIN DEL CASTAÑAR",
					"7295": "SAN PEDRO DE ROZADOS",
					"7296": "SANTIBAÑEZ DE BEJAR",
					"7297": "SAUCELLE",
					"7298": "SEQUEROS",
					"7299": "SERRADILLA DEL LLANO",
					"7300": "SOTOSERRANO",
					"7301": "TARAZONA DE GUAREÑA",
					"7302": "TENEBRON",
					"7303": "TORDILLOS",
					"7304": "TRABANCA",
					"7305": "VALDEFUENTES DE SANGUSIN",
					"7306": "VALDEMIERQUE",
					"7307": "VALSALABROSO",
					"7308": "VALLEJERA DE RIOFRIO",
					"7309": "VENTOSA DEL RIO ALMAR",
					"7310": "VILLALBA DE LOS LLANOS",
					"7311": "VILLAR DE GALLIMAZO",
					"7312": "VILLARES DE YELTES",
					"7313": "VILLASDARDO",
					"7314": "VILLASRUBIAS",
					"7315": "VILLORIA",
					"7335": "ABUSEJO",
					"7336": "AHIGAL DE VILLARINO",
					"7337": "ALBA DE TORMES",
					"7338": "ALCONADA",
					"7339": "ALDEA DEL OBISPO",
					"7340": "ALDEARRODRIGO",
					"7341": "ALDEATEJADA",
					"7342": "ALDEHUELA DE YELTES",
					"7343": "ARABAYONA DE MOGICA",
					"7344": "ARMENTEROS",
					"7345": "BAÑOBAREZ",
					"7346": "BARCEO",
					"7347": "BASTIDA (LA)",
					"7348": "BERROCAL DE HUEBRA",
					"7349": "BOGAJO",
					"7350": "BRINCONES",
					"7351": "CABACO (EL)",
					"7352": "CABEZA DEL CABALLO",
					"7353": "CALVARRASA DE ARRIBA",
					"7354": "CAMPO DE PEÑARANDA (EL)",
					"7355": "CANTARACILLO",
					"7356": "CARRASCAL DE BARREGAS"
				}
			},
			"38": {
				"nameProvincia": "S.C.Tenerife",
				"idProvincia": "38",
				"localidades": {
					"1389": "ADEJE",
					"1390": "AGULO",
					"1391": "ALAJERO",
					"1392": "ARICO",
					"1393": "BARLOVENTO",
					"1394": "BREÑA ALTA",
					"1395": "BUENAVISTA DEL NORTE",
					"1396": "CANDELARIA",
					"1397": "FRONTERA",
					"1398": "GARACHICO",
					"1399": "GARAFIA",
					"1400": "GRANADILLA DE ABONA",
					"1401": "GUANCHA (LA)",
					"1402": "GUIA DE ISORA",
					"1403": "HERMIGUA",
					"1404": "SAN CRISTOBAL DE LA LAGUNA",
					"1405": "LLANOS DE ARIDANE (LOS)",
					"1406": "MATANZA DE ACENTEJO (LA)",
					"1407": "OROTAVA (LA)",
					"1408": "PUERTO DE LA CRUZ",
					"1409": "PUNTAGORDA",
					"1410": "REALEJOS (LOS)",
					"1411": "ROSARIO (EL)",
					"1412": "SAN JUAN DE LA RAMBLA",
					"1413": "SAN MIGUEL DE ABONA",
					"1414": "SAN SEBASTIAN DE LA GOMERA",
					"1415": "SANTA CRUZ DE TENERIFE",
					"1416": "SANTA URSULA",
					"1417": "SANTIAGO DEL TEIDE",
					"1418": "SAUZAL (EL)",
					"1419": "SILOS (LOS)",
					"1420": "TANQUE (EL)",
					"1421": "TAZACORTE",
					"1422": "TIJARAFE",
					"1423": "VALLE GRAN REY",
					"1424": "VALLEHERMOSO",
					"1425": "VILAFLOR",
					"1426": "VILLA DE MAZO",
					"7244": "ARAFO",
					"7245": "ARONA",
					"7246": "BREÑA BAJA",
					"7247": "FASNIA",
					"7248": "FUENCALIENTE DE LA PALMA",
					"7249": "GÜIMAR",
					"7250": "ICOD DE LOS VINOS",
					"7251": "PASO (EL)",
					"7252": "PUNTALLANA",
					"7253": "SAN ANDRES Y SAUCES",
					"7254": "SANTA CRUZ DE LA PALMA",
					"7255": "TACORONTE",
					"7256": "TEGUESTE",
					"7257": "VALVERDE",
					"7258": "VICTORIA DE ACENTEJO (LA)"
				}
			},
			"39": {
				"nameProvincia": "Cantabria",
				"idProvincia": "39",
				"localidades": {
					"1427": "ALFOZ DE LLOREDO",
					"1428": "AMPUERO",
					"1429": "ANIEVAS",
					"1430": "ARGOÑOS",
					"1431": "ARNUERO",
					"1432": "ARREDONDO",
					"1433": "BARCENA DE CICERO",
					"1434": "BARCENA DE PIE DE CONCHA",
					"1435": "BAREYO",
					"1436": "CABEZON DE LIEBANA",
					"1437": "CABUERNIGA",
					"1438": "CAMALEÑO",
					"1439": "CAMARGO",
					"1440": "CAMPOO DE YUSO",
					"1441": "CARTES",
					"1442": "CASTAÑEDA",
					"1443": "CASTRO-URDIALES",
					"1444": "CIEZA",
					"1445": "CILLORIGO DE LIEBANA",
					"1446": "COLINDRES",
					"1447": "COMILLAS",
					"1448": "CORRALES DE BUELNA (LOS)",
					"1449": "CORVERA DE TORANZO",
					"1450": "CAMPOO DE ENMEDIO",
					"1451": "ENTRAMBASAGUAS",
					"1452": "ESCALANTE",
					"1453": "GURIEZO",
					"1454": "HAZAS DE CESTO",
					"1455": "HERMANDAD DE CAMPOO DE SUSO",
					"1456": "HERRERIAS",
					"1457": "LAMASON",
					"1458": "LAREDO",
					"1459": "LIENDO",
					"1460": "LIERGANES",
					"1461": "LIMPIAS",
					"1462": "LUENA",
					"1463": "MARINA DE CUDEYO",
					"1464": "MAZCUERRAS",
					"1465": "MEDIO CUDEYO",
					"1466": "MERUELO",
					"1467": "MIENGO",
					"1468": "MIERA",
					"1469": "MOLLEDO",
					"1470": "NOJA",
					"1471": "PENAGOS",
					"1472": "PEÑARRUBIA",
					"1473": "PESAGUERO",
					"1474": "PESQUERA",
					"1475": "PIELAGOS",
					"1476": "POLACIONES",
					"1477": "POLANCO",
					"1478": "POTES",
					"1479": "PUENTE VIESGO",
					"1480": "RAMALES DE LA VICTORIA",
					"1481": "RASINES",
					"1482": "REINOSA",
					"1483": "REOCIN",
					"1484": "RIBAMONTAN AL MAR",
					"1485": "RIBAMONTAN AL MONTE",
					"1486": "RIONANSA",
					"1487": "RIOTUERTO",
					"1488": "ROZAS DE VALDEARROYO (LAS)",
					"1489": "RUENTE",
					"1490": "RUESGA",
					"1491": "RUILOBA",
					"1492": "SAN FELICES DE BUELNA",
					"1493": "SAN MIGUEL DE AGUAYO",
					"1494": "SAN PEDRO DEL ROMERAL",
					"1495": "SAN ROQUE DE RIOMIERA",
					"1496": "SANTA CRUZ DE BEZANA",
					"1497": "SANTA MARIA DE CAYON",
					"1498": "SANTANDER",
					"1499": "SANTILLANA DEL MAR",
					"1500": "SANTIURDE DE REINOSA",
					"1501": "SANTIURDE DE TORANZO",
					"1502": "SANTOÑA",
					"1503": "SAN VICENTE DE LA BARQUERA",
					"1504": "SARO",
					"1505": "SELAYA",
					"1506": "SOBA",
					"1507": "SOLORZANO",
					"1508": "SUANCES",
					"1509": "TOJOS (LOS)",
					"1510": "TORRELAVEGA",
					"1511": "TRESVISO",
					"1512": "TUDANCA",
					"1513": "UDIAS",
					"1514": "VALDALIGA",
					"1515": "VALDEOLEA",
					"1516": "VALDEPRADO DEL RIO",
					"1517": "VALDERREDIBLE",
					"1518": "VAL DE SAN VICENTE",
					"1519": "VEGA DE LIEBANA",
					"1520": "VEGA DE PAS",
					"1521": "VILLACARRIEDO",
					"1522": "VILLAESCUSA",
					"1523": "VILLAFUFRE",
					"1524": "VILLAVERDE DE TRUCIOS",
					"1525": "VOTO",
					"7259": "ARENAS DE IGUÑA",
					"7260": "ASTILLERO (EL)",
					"7261": "CABEZON DE LA SAL"
				}
			},
			"40": {
				"nameProvincia": "Segovia",
				"idProvincia": "40",
				"localidades": {
					"1137": "OREJANA",
					"1138": "ORTIGOSA DE PESTAÑO",
					"1139": "PAJAREJOS",
					"1140": "PALAZUELOS DE ERESMA",
					"1141": "PEDRAZA",
					"1142": "PELAYOS DEL ARROYO",
					"1143": "PINAREJOS",
					"1144": "PINARNEGRILLO",
					"1145": "PRADENA",
					"1146": "RAPARIEGOS",
					"1147": "REBOLLO",
					"1148": "REMONDO",
					"1149": "RIAGUAS DE SAN BARTOLOME",
					"1150": "RIBOTA",
					"1151": "RODA DE ERESMA",
					"1152": "SACRAMENIA",
					"1153": "SAMBOAL",
					"1154": "SAN CRISTOBAL DE LA VEGA",
					"1155": "SANCHONUÑO",
					"1156": "SANGARCIA",
					"1157": "SAN ILDEFONSO",
					"1158": "SAN MARTIN Y MUDRIAN",
					"1159": "SAN PEDRO DE GAILLOS",
					"1160": "SANTA MARIA LA REAL DE NIEVA",
					"1161": "SANTA MARTA DEL CERRO",
					"1162": "SANTIUSTE DE PEDRAZA",
					"1163": "SANTO DOMINGO DE PIRON",
					"1164": "SANTO TOME DEL PUERTO",
					"1165": "SAUQUILLO DE CABEZAS",
					"1166": "SEBULCOR",
					"1167": "SEGOVIA",
					"1168": "SEQUERA DE FRESNO",
					"1169": "SOTILLO",
					"1170": "TABANERA LA LUENGA",
					"1171": "TOLOCIRIO",
					"1172": "TORRECABALLEROS",
					"1173": "TORRECILLA DEL PINAR",
					"1174": "TORREIGLESIAS",
					"1175": "TRESCASAS",
					"1176": "TUREGANO",
					"1177": "URUEÑAS",
					"1178": "VALDEPRADOS",
					"1179": "VALDEVACAS Y GUIJAR",
					"1180": "VALSECA",
					"1181": "VALTIENDAS",
					"1182": "VALVERDE DEL MAJANO",
					"1183": "VALLELADO",
					"1184": "VALLERUELA DE PEDRAZA",
					"1185": "VALLERUELA DE SEPULVEDA",
					"1186": "VEGAS DE MATUTE",
					"1187": "VENTOSILLA Y TEJADILLA",
					"1188": "VILLACASTIN",
					"1189": "VILLAVERDE DE MONTEJO",
					"1190": "VILLEGUILLO",
					"1191": "YANGUAS DE ERESMA",
					"1192": "ZARZUELA DEL PINAR",
					"1193": "ORTIGOSA DEL MONTE",
					"1194": "COZUELOS DE FUENTIDUEÑA",
					"1195": "MARAZOLEJA",
					"1196": "CUEVAS DE PROVANCO",
					"1197": "SAN CRISTOBAL DE SEGOVIA",
					"1383": "NIEVA",
					"1526": "ABADES",
					"1527": "ADRADA DE PIRON",
					"1528": "ADRADOS",
					"1529": "AGUILAFUENTE",
					"1530": "ALCONADA DE MADERUELO",
					"1531": "ALDEALCORVO",
					"1532": "ALDEALENGUA DE PEDRAZA",
					"1533": "ALDEALENGUA DE SANTA MARIA",
					"1534": "ALDEANUEVA DE LA SERREZUELA",
					"1535": "ALDEANUEVA DEL CODONAL",
					"1536": "ALDEA REAL",
					"1537": "ALDEASOÑA",
					"1538": "ALDEHORNO",
					"1539": "ALDEHUELA DEL CODONAL",
					"1540": "ALDEONTE",
					"1541": "ANAYA",
					"1542": "AÑE",
					"1543": "ARAHUETES",
					"1544": "ARCONES",
					"1545": "AREVALILLO DE CEGA",
					"1546": "ARMUÑA",
					"1547": "AYLLON",
					"1548": "BARBOLLA",
					"1549": "BASARDILLA",
					"1550": "BERCIAL",
					"1551": "BERCIMUEL",
					"1552": "BERNARDOS",
					"1553": "BERNUY DE PORREROS",
					"1554": "BOCEGUILLAS",
					"1555": "BRIEVA",
					"1556": "CABALLAR",
					"1557": "CABAÑAS DE POLENDOS",
					"1558": "CABEZUELA",
					"1559": "CALABAZAS DE FUENTIDUEÑA",
					"1560": "CAMPO DE SAN PEDRO",
					"1561": "CANTALEJO",
					"1562": "CANTIMPALOS",
					"1563": "CARBONERO EL MAYOR",
					"1564": "CARRASCAL DEL RIO",
					"1565": "CASLA",
					"1566": "CASTILLEJO DE MESLEON",
					"1567": "CASTRO DE FUENTIDUEÑA",
					"1568": "CASTROJIMENO",
					"1797": "CASTROSERNA DE ABAJO",
					"2030": "CASTROSERRACIN",
					"2031": "CEDILLO DE LA TORRE",
					"2032": "CEREZO DE ABAJO",
					"2033": "CEREZO DE ARRIBA",
					"2034": "CILLERUELO DE SAN MAMES",
					"2035": "COBOS DE FUENTIDUEÑA",
					"2036": "CODORNIZ",
					"2037": "CONDADO DE CASTILNOVO",
					"2038": "CORRAL DE AYLLON",
					"2039": "CUBILLO",
					"2040": "CHAÑE",
					"2041": "DOMINGO GARCIA",
					"2042": "DURUELO",
					"2043": "ENCINAS",
					"2044": "ESCALONA DEL PRADO",
					"2045": "ESCARABAJOSA DE CABEZAS",
					"2046": "ESPINAR (EL)",
					"2047": "ESPIRDO",
					"2048": "FRESNEDA DE CUELLAR",
					"2049": "FRESNO DE CANTESPINO",
					"2050": "FRUMALES",
					"2051": "FUENTE DE SANTA CRUZ",
					"2052": "FUENTE EL OLMO DE FUENTIDUEÑA",
					"2053": "FUENTEPELAYO",
					"2054": "FUENTEPIÑEL",
					"2055": "FUENTERREBOLLO",
					"2056": "FUENTESAUCO DE FUENTIDUEÑA",
					"2057": "FUENTESOTO",
					"2058": "GALLEGOS",
					"2059": "GARCILLAN",
					"2060": "GRAJERA",
					"2061": "HONRUBIA DE LA CUESTA",
					"2062": "HONTALBILLA",
					"2063": "HUERTOS (LOS)",
					"2064": "ITUERO Y LAMA",
					"2065": "JUARROS DE RIOMOROS",
					"2066": "JUARROS DE VOLTOYA",
					"2067": "LAGUNA DE CONTRERAS",
					"2068": "LASTRAS DE CUELLAR",
					"2069": "LASTRAS DEL POZO",
					"2070": "LOSA (LA)",
					"2071": "MADERUELO",
					"2072": "MARAZUELA",
					"2073": "MARTIN MUÑOZ DE LA DEHESA",
					"2074": "MARTIN MUÑOZ DE LAS POSADAS",
					"2075": "MARUGAN",
					"2076": "MATA DE CUELLAR",
					"2077": "MATILLA (LA)",
					"2078": "MEMBIBRE DE LA HOZ",
					"2079": "MIGUELAÑEZ",
					"2080": "MONTEJO DE AREVALO",
					"2081": "MONTERRUBIO",
					"2082": "MORAL DE HORNUEZ",
					"2083": "MOZONCILLO",
					"2084": "MUÑOPEDRO",
					"2085": "MUÑOVEROS",
					"2086": "NAVAFRIA",
					"2087": "NAVALILLA",
					"2088": "NAVALMANZANO",
					"2089": "NAVARES DE AYUSO",
					"2090": "NAVARES DE LAS CUEVAS",
					"2091": "NAVAS DE ORO",
					"2092": "NAVAS DE SAN ANTONIO",
					"7204": "OLOMBRADA",
					"7205": "OTERO DE HERREROS",
					"7206": "PEROSILLO",
					"7207": "PRADALES",
					"7208": "PUEBLA DE PEDRAZA",
					"7209": "RIAZA",
					"7210": "RIOFRIO DE RIAZA",
					"7211": "SAN CRISTOBAL DE CUELLAR",
					"7212": "SAN MIGUEL DE BERNUY",
					"7213": "SANTIUSTE DE SAN JUAN BAUTISTA",
					"7214": "SEPULVEDA",
					"7215": "SOTOSALBOS",
					"7216": "TORREADRADA",
					"7217": "TORRE VAL DE SAN PEDRO",
					"7218": "VALDEVACAS DE MONTEJO",
					"7219": "VALLE DE TABLADILLO",
					"7220": "VEGANZONES",
					"7221": "VILLAVERDE DE ISCAR",
					"7222": "ZARZUELA DEL MONTE",
					"7223": "NAVAS DE RIOFRIO",
					"7262": "COCA",
					"7263": "COLLADO HERMOSO",
					"7264": "CUELLAR",
					"7265": "DONHIERRO",
					"7266": "ENCINILLAS",
					"7267": "ESCOBAR DE POLENDOS",
					"7268": "FRESNO DE LA FUENTE",
					"7269": "FUENTE EL OLMO DE ISCAR",
					"7270": "FUENTIDUEÑA",
					"7271": "GOMEZSERRACIN",
					"7272": "HONTANARES DE ERESMA",
					"7273": "LABAJOS",
					"7274": "LANGUILLA",
					"7275": "LASTRILLA (LA)",
					"7276": "MARTIN MIGUEL",
					"7277": "MATABUENA",
					"7278": "MELQUE DE CERCOS",
					"7279": "MONTEJO DE LA VEGA DE LA SERRE",
					"7280": "NAVA DE LA ASUNCION",
					"7281": "NAVARES DE ENMEDIO"
				}
			},
			"41": {
				"nameProvincia": "Sevilla",
				"idProvincia": "41",
				"localidades": {
					"1198": "AGUADULCE",
					"1199": "ALBAIDA DEL ALJARAFE",
					"1200": "ALCALA DEL RIO",
					"1201": "ALCOLEA DEL RIO",
					"1202": "ALGABA (LA)",
					"1203": "ALGAMITAS",
					"1204": "ALMADEN DE LA PLATA",
					"1205": "ALMENSILLA",
					"1206": "ARAHAL",
					"1207": "AZNALCAZAR",
					"1208": "AZNALCOLLAR",
					"1209": "BADOLATOSA",
					"1210": "BENACAZON",
					"1211": "BOLLULLOS DE LA MITACION",
					"1212": "BORMUJOS",
					"1213": "BRENES",
					"1214": "BURGUILLOS",
					"1215": "CABEZAS DE SAN JUAN (LAS)",
					"1216": "CAMAS",
					"1217": "CAMPANA (LA)",
					"1218": "CANTILLANA",
					"1219": "CARMONA",
					"1220": "CARRION DE LOS CESPEDES",
					"1221": "CASARICHE",
					"1222": "CASTILBLANCO DE LOS ARROYOS",
					"1223": "CASTILLEJA DE GUZMAN",
					"1224": "CASTILLEJA DE LA CUESTA",
					"1225": "CASTILLEJA DEL CAMPO",
					"1226": "CASTILLO DE LAS GUARDAS (EL)",
					"1227": "CAZALLA DE LA SIERRA",
					"1228": "CONSTANTINA",
					"1229": "CORIA DEL RIO",
					"1230": "CORIPE",
					"1231": "CORONIL (EL)",
					"1232": "CORRALES (LOS)",
					"1233": "DOS HERMANAS",
					"1234": "ECIJA",
					"1235": "ESPARTINAS",
					"1236": "ESTEPA",
					"1237": "FUENTES DE ANDALUCIA",
					"1238": "GARROBO (EL)",
					"1239": "GELVES",
					"1240": "GERENA",
					"1241": "GILENA",
					"1242": "GINES",
					"1243": "GUADALCANAL",
					"1244": "GUILLENA",
					"1245": "HERRERA",
					"1246": "HUEVAR DEL ALJARAFE",
					"1247": "LANTEJUELA (LA)",
					"1248": "LEBRIJA",
					"1249": "LORA DE ESTEPA",
					"1250": "LORA DEL RIO",
					"1251": "LUISIANA (LA)",
					"1252": "MADROÑO (EL)",
					"1253": "MAIRENA DEL ALCOR",
					"1254": "MAIRENA DEL ALJARAFE",
					"1255": "MARCHENA",
					"1256": "MARINALEDA",
					"1257": "MARTIN DE LA JARA",
					"1258": "MOLARES (LOS)",
					"1259": "MONTELLANO",
					"1260": "MORON DE LA FRONTERA",
					"1261": "NAVAS DE LA CONCEPCION (LAS)",
					"1262": "OLIVARES",
					"1263": "OSUNA",
					"1264": "PALACIOS Y VILLAFRANCA (LOS)",
					"1265": "PALOMARES DEL RIO",
					"1266": "PARADAS",
					"1267": "PEDRERA",
					"1268": "PEDROSO (EL)",
					"1269": "PEÑAFLOR",
					"1270": "PILAS",
					"1271": "PRUNA",
					"1272": "PUEBLA DE CAZALLA (LA)",
					"1273": "PUEBLA DE LOS INFANTES (LA)",
					"1274": "PUEBLA DEL RIO (LA)",
					"1275": "REAL DE LA JARA (EL)",
					"1276": "RINCONADA (LA)",
					"1277": "RODA DE ANDALUCIA (LA)",
					"1278": "RONQUILLO (EL)",
					"1279": "RUBIO (EL)",
					"1280": "SALTERAS",
					"1281": "SAN JUAN DE AZNALFARACHE",
					"1282": "SANLUCAR LA MAYOR",
					"1283": "SAN NICOLAS DEL PUERTO",
					"1284": "SANTIPONCE",
					"1285": "SAUCEJO (EL)",
					"1286": "SEVILLA",
					"1287": "TOCINA",
					"1288": "TOMARES",
					"1289": "UMBRETE",
					"1290": "UTRERA",
					"1291": "VALENCINA DE LA CONCEPCION",
					"1292": "VILLAMANRIQUE DE LA CONDESA",
					"1293": "VILLANUEVA DEL ARISCAL",
					"1294": "VILLANUEVA DEL RIO Y MINAS",
					"1295": "VILLANUEVA DE SAN JUAN",
					"1296": "VILLAVERDE DEL RIO",
					"1297": "VISO DEL ALCOR (EL)",
					"1298": "CAÑADA ROSAL",
					"1299": "ISLA MAYOR",
					"1300": "CUERVO DE SEVILLA (EL)",
					"7224": "ALANIS",
					"7225": "ALCALA DE GUADAIRA"
				}
			},
			"42": {
				"nameProvincia": "Soria",
				"idProvincia": "42",
				"localidades": {
					"1136": "MIÑO DE SAN ESTEBAN",
					"1301": "ABEJAR",
					"1302": "ADRADAS",
					"1303": "AGREDA",
					"1304": "ALCONABA",
					"1305": "ALCUBILLA DE AVELLANEDA",
					"1306": "ALCUBILLA DE LAS PEÑAS",
					"1307": "ALDEALAFUENTE",
					"1308": "ALDEALICES",
					"1309": "ALDEALPOZO",
					"1310": "ALDEALSEÑOR",
					"1311": "ALDEHUELA DE PERIAÑEZ",
					"1312": "ALDEHUELAS (LAS)",
					"1313": "ALENTISQUE",
					"1314": "ALIUD",
					"1315": "ALMAJANO",
					"1316": "ALMALUEZ",
					"1317": "ALMARZA",
					"1318": "ALMAZAN",
					"1319": "ALMAZUL",
					"1320": "ALMENAR DE SORIA",
					"1321": "ALPANSEQUE",
					"1322": "ARANCON",
					"1323": "ARCOS DE JALON",
					"1324": "ARENILLAS",
					"1325": "AREVALO DE LA SIERRA",
					"1326": "AUSEJO DE LA SIERRA",
					"1327": "BARAONA",
					"1328": "BARCA",
					"1329": "BARCONES",
					"1330": "BAYUBAS DE ABAJO",
					"1331": "BAYUBAS DE ARRIBA",
					"1332": "BERATON",
					"1333": "BERLANGA DE DUERO",
					"1334": "BLACOS",
					"1335": "BLIECOS",
					"1336": "BORJABAD",
					"1337": "BOROBIA",
					"1338": "BUBEROS",
					"1339": "BUITRAGO",
					"1340": "BURGO DE OSMA-CIUDAD DE OSMA",
					"1341": "CABREJAS DEL PINAR",
					"1342": "CALATAÑAZOR",
					"1343": "CALTOJAR",
					"1344": "CANDILICHERA",
					"1345": "CARABANTES",
					"1346": "CARACENA",
					"1347": "CARRASCOSA DE LA SIERRA",
					"1348": "CASAREJOS",
					"1349": "CASTILFRIO DE LA SIERRA",
					"1350": "CASTILLEJO DE ROBLEDO",
					"1351": "CENTENERA DE ANDALUZ",
					"1352": "CERBON",
					"1353": "CIGUDOSA",
					"1354": "CIRIA",
					"1355": "CIRUJALES DEL RIO",
					"1356": "COVALEDA",
					"1357": "CUBILLA",
					"1358": "CUEVA DE AGREDA",
					"1359": "DEVANOS",
					"1360": "DEZA",
					"1361": "ESCOBOSA DE ALMAZAN",
					"1362": "ESPEJA DE SAN MARCELINO",
					"1363": "ESPEJON",
					"1364": "ESTEPA DE SAN JUAN",
					"1365": "FRESNO DE CARACENA",
					"1366": "FUENTEARMEGIL",
					"1367": "FUENTECAMBRON",
					"1368": "FUENTECANTOS",
					"1369": "FUENTELSAZ DE SORIA",
					"1370": "FUENTEPINILLA",
					"1371": "FUENTESTRUN",
					"1372": "GARRAY",
					"1373": "GOLMAYO",
					"1374": "GOMARA",
					"1375": "HERRERA DE SORIA",
					"1376": "LANGA DE DUERO",
					"1377": "LICERAS",
					"1378": "LOSILLA (LA)",
					"1379": "MAGAÑA",
					"1380": "MATALEBRERAS",
					"1381": "MEDINACELI",
					"1382": "MIÑO DE MEDINACELI",
					"1569": "RELLO",
					"1570": "RETORTILLO DE SORIA",
					"1571": "REZNOS",
					"1572": "RIOSECO DE SORIA",
					"1573": "ROLLAMIENTA",
					"1574": "ROYO (EL)",
					"1575": "SALDUERO",
					"1576": "SAN FELICES",
					"1577": "SAN LEONARDO DE YAGÜE",
					"1578": "SAN PEDRO MANRIQUE",
					"1579": "SANTA CRUZ DE YANGUAS",
					"1580": "SANTA MARIA DE LAS HOYAS",
					"1581": "SERON DE NAGIMA",
					"1582": "SOLIEDRA",
					"1583": "SORIA",
					"1584": "SUELLACABRAS",
					"1585": "TAJAHUERCE",
					"1586": "TAJUECO",
					"1587": "TALVEILA",
					"1588": "TARODA",
					"1589": "TEJADO",
					"1590": "TORREBLACOS",
					"1591": "TORRUBIA DE SORIA",
					"1592": "UCERO",
					"1593": "VADILLO",
					"1594": "VALDEGEÑA",
					"1595": "VALDELAGUA DEL CERRO",
					"1596": "VALDEMALUQUE",
					"1597": "VALDENEBRO",
					"1598": "VALDERRODILLA",
					"1599": "VALTAJEROS",
					"1600": "VELILLA DE LA SIERRA",
					"1601": "VELILLA DE LOS AJOS",
					"1602": "VILLACIERVOS",
					"1603": "VILLANUEVA DE GORMAZ",
					"1604": "VILLAR DEL ALA",
					"1605": "VILLAR DEL RIO",
					"1606": "VILLARES DE SORIA (LOS)",
					"1607": "VILLASAYAS",
					"1608": "VINUESA",
					"1609": "VIZMANOS",
					"1610": "VOZMEDIANO",
					"1611": "YANGUAS",
					"2888": "MOLINOS DE DUERO",
					"2889": "MOMBLONA",
					"2890": "MONTEAGUDO DE LAS VICARIAS",
					"2891": "MONTEJO DE TIERMES",
					"2892": "MONTENEGRO DE CAMEROS",
					"2893": "MURIEL DE LA FUENTE",
					"2894": "MURIEL VIEJO",
					"2895": "NAFRIA DE UCERO",
					"2896": "NAVALENO",
					"2897": "NOLAY",
					"2898": "NOVIERCAS",
					"2899": "ONCALA",
					"2900": "PORTILLO DE SORIA",
					"2901": "POVEDA DE SORIA (LA)",
					"2902": "POZALMURO",
					"2903": "QUINTANAS DE GORMAZ",
					"2904": "QUIÑONERIA",
					"2905": "RABANOS (LOS)",
					"2906": "REBOLLAR",
					"6477": "MORON DE ALMAZAN",
					"6478": "NARROS",
					"6479": "NEPAS",
					"6480": "OLVEGA",
					"6481": "PINILLA DEL CAMPO",
					"6482": "QUINTANA REDONDA",
					"6483": "RECUERDA",
					"6484": "RENIEBLAS",
					"6485": "RIBA DE ESCALOTE (LA)",
					"6486": "SAN ESTEBAN DE GORMAZ",
					"6487": "SANTA MARIA DE HUERTA",
					"6488": "SOTILLO DEL RINCON",
					"6489": "TARDELCUENDE",
					"6490": "TORLENGUA",
					"6491": "TREVAGO",
					"6492": "VALDEAVELLANO DE TERA",
					"6493": "VALDEPRADO",
					"6494": "VELAMAZAN",
					"6495": "VIANA DE DUERO",
					"6496": "VILLAR DEL CAMPO",
					"6497": "VILLASECA DE ARCIEL",
					"6498": "YELO",
					"7226": "CABREJAS DEL CAMPO",
					"7227": "CAÑAMAQUE",
					"7228": "CARRASCOSA DE ABAJO",
					"7229": "CASTILRUIZ",
					"7230": "CIDONES",
					"7231": "CIHUELA",
					"7232": "COSCURITA",
					"7233": "CUBO DE LA SOLANA",
					"7234": "DURUELO DE LA SIERRA",
					"7235": "FRECHILLA DE ALMAZAN",
					"7236": "FUENTELMONGE",
					"7237": "FUENTES DE MAGAÑA",
					"7238": "GORMAZ",
					"7239": "HINOJOSA DEL CAMPO",
					"7240": "MAJAN",
					"7241": "MATAMALA DE ALMAZAN"
				}
			},
			"43": {
				"nameProvincia": "Tarragona",
				"idProvincia": "43",
				"localidades": {
					"1612": "AIGUAMURCIA",
					"1613": "ALBIOL (L')",
					"1614": "ALCANAR",
					"1615": "ALDOVER",
					"1616": "ALEIXAR (L')",
					"1617": "ALFORJA",
					"1618": "ALIO",
					"1619": "ALMOSTER",
					"1620": "AMETLLA DE MAR (L')",
					"1621": "AMPOSTA",
					"1622": "ARBOÇ (L')",
					"1623": "ARNES",
					"1624": "ASCO",
					"1625": "BANYERES DEL PENEDES",
					"1626": "BATEA",
					"1627": "BELLMUNT DEL PRIORAT",
					"1628": "BELLVEI",
					"1629": "BENIFALLET",
					"1630": "BISBAL DE FALSET (LA)",
					"1631": "BISBAL DEL PENEDES (LA)",
					"1632": "BONASTRE",
					"1633": "BORGES DEL CAMP (LES)",
					"1634": "BOTARELL",
					"1635": "CABACES",
					"1636": "CABRA DEL CAMP",
					"1637": "CAMBRILS",
					"1638": "CAPAFONTS",
					"1639": "CAPÇANES",
					"1640": "CASERES",
					"1641": "CASTELLVELL DEL CAMP",
					"1642": "CATLLAR (EL)",
					"1643": "SENIA (LA)",
					"1644": "COLLDEJOU",
					"1645": "CONESA",
					"1646": "CONSTANTI",
					"1647": "CORBERA D'EBRE",
					"1648": "CORNUDELLA DE MONTSANT",
					"1649": "CREIXELL",
					"1650": "CUNIT",
					"1651": "XERTA",
					"1652": "DUESAIGÜES",
					"1653": "ESPLUGA DE FRANCOLI (L')",
					"1654": "FALSET",
					"1655": "FATARELLA (LA)",
					"1656": "FEBRO (LA)",
					"1657": "FIGUERA (LA)",
					"1658": "FIGUEROLA DEL CAMP",
					"1659": "FLIX",
					"1660": "FORES",
					"1661": "FREGINALS",
					"1662": "GALERA (LA)",
					"1663": "GANDESA",
					"1664": "GARCIA",
					"1665": "GARIDELLS (ELS)",
					"1666": "GINESTAR",
					"1667": "GODALL",
					"1668": "GRATALLOPS",
					"1669": "GUIAMETS (ELS)",
					"1670": "HORTA DE SANT JOAN",
					"1671": "LLOAR (EL)",
					"1672": "LLORAC",
					"1673": "LLORENÇ DEL PENEDES",
					"1674": "MARGALEF",
					"1675": "MARÇA",
					"1676": "MAS DE BARBERANS",
					"1677": "MASDENVERGE",
					"1678": "MASLLORENÇ",
					"1679": "MASO (LA)",
					"1680": "MASPUJOLS",
					"1681": "MASROIG (EL)",
					"1682": "MILA (EL)",
					"1683": "MIRAVET",
					"1684": "MOLAR (EL)",
					"1685": "MONTBLANC",
					"1686": "MONTBRIO DEL CAMP",
					"1687": "MONTFERRI",
					"1688": "MONTMELL (EL)",
					"1689": "MONT-RAL",
					"1690": "MONT-ROIG DEL CAMP",
					"1691": "MORA D'EBRE",
					"1692": "MORA LA NOVA",
					"1693": "MORELL (EL)",
					"1694": "MORERA DE MONTSANT (LA)",
					"1695": "NOU DE GAIA (LA)",
					"1696": "NULLES",
					"1697": "PALMA D'EBRE (LA)",
					"1698": "PALLARESOS (ELS)",
					"1699": "PASSANANT",
					"1700": "PAÜLS",
					"1701": "PERAFORT",
					"1702": "PERELLO (EL)",
					"1703": "PILES (LES)",
					"1704": "PINELL DE BRAI (EL)",
					"1705": "PIRA",
					"1706": "PLA DE SANTA MARIA (EL)",
					"1707": "POBLA DE MAFUMET (LA)",
					"1708": "POBLA DE MASSALUCA (LA)",
					"1709": "POBLA DE MONTORNES (LA)",
					"1710": "POBOLEDA",
					"1711": "PONT D'ARMENTERA (EL)",
					"1712": "PORRERA",
					"1713": "PRADELL DE LA TEIXETA",
					"1714": "PRADES",
					"1715": "PRAT DE COMTE",
					"1716": "PRATDIP",
					"1717": "PUIGPELAT",
					"1718": "QUEROL",
					"1719": "RASQUERA",
					"1720": "RENAU",
					"1721": "REUS",
					"1722": "RIBA (LA)",
					"1723": "RIBA-ROJA D'EBRE",
					"1724": "RIERA DE GAIA (LA)",
					"1725": "RIUDECANYES",
					"1726": "RIUDECOLS",
					"1727": "RIUDOMS",
					"1728": "ROCAFORT DE QUERALT",
					"1729": "RODA DE BARA",
					"1730": "RODONYA",
					"1731": "ROQUETES",
					"1732": "ROURELL (EL)",
					"1733": "SALOMO",
					"1734": "SANT CARLES DE LA RAPITA",
					"1735": "SANT JAUME DELS DOMENYS",
					"1736": "SANTA BARBARA",
					"1737": "SANTA COLOMA DE QUERALT",
					"1738": "SANTA OLIVA",
					"1739": "PONTILS",
					"1740": "SARRAL",
					"1741": "SAVALLA DEL COMTAT",
					"1742": "SECUITA (LA)",
					"1743": "SELVA DEL CAMP (LA)",
					"1744": "SENAN",
					"1745": "SOLIVELLA",
					"1746": "TARRAGONA",
					"1747": "TIVENYS",
					"1748": "TIVISSA",
					"1749": "TORRE DE FONTAUBELLA (LA)",
					"1750": "TORRE DE L'ESPANYOL (LA)",
					"1751": "TORREDEMBARRA",
					"1752": "TORROJA DEL PRIORAT",
					"1753": "TORTOSA",
					"1754": "ULLDECONA",
					"1755": "ULLDEMOLINS",
					"1756": "VALLCLARA",
					"1757": "VALLFOGONA DE RIUCORB",
					"1758": "VALLMOLL",
					"1759": "VALLS",
					"1760": "VANDELLOS I L'HOSPITALET DE L.",
					"1761": "VENDRELL (EL)",
					"1762": "VESPELLA DE GAIA",
					"1763": "VILABELLA",
					"1764": "VILALLONGA DEL CAMP",
					"1765": "VILANOVA D'ESCORNALBOU",
					"1766": "VILANOVA DE PRADES",
					"1767": "VILAPLANA",
					"1768": "VILA-RODONA",
					"1769": "VILA-SECA",
					"1770": "VILAVERD",
					"1771": "VILELLA ALTA (LA)",
					"1772": "VILELLA BAIXA (LA)",
					"1773": "VIMBODI",
					"1774": "VINEBRE",
					"1775": "VINYOLS I ELS ARCS",
					"1776": "SANT JAUME D'ENVEJA",
					"1777": "CAMARLES",
					"1778": "SALOU",
					"1779": "AMPOLLA (L')",
					"6499": "ALBINYANA",
					"6500": "ALCOVER",
					"6501": "ALFARA DE CARLES",
					"7179": "ARGENTERA (L')",
					"7180": "BARBERA DE LA CONCA",
					"7181": "BENISSANET",
					"7182": "BLANCAFORT",
					"7183": "BOT",
					"7184": "BRAFIM",
					"7185": "CALAFELL",
					"7186": "VILALBA DELS ARCS",
					"7187": "DELTEBRE",
					"7188": "ALDEA (L')",
					"7868": "ALTAFULLA",
					"7869": "ARBOLI"
				}
			},
			"44": {
				"nameProvincia": "Teruel",
				"idProvincia": "44",
				"localidades": {
					"397": "BRONCHALES",
					"398": "BUEÑA",
					"399": "CABRA DE MORA",
					"400": "CALACEITE",
					"401": "CALANDA",
					"402": "CALOMARDE",
					"403": "CAMARENA DE LA SIERRA",
					"404": "CAMARILLAS",
					"405": "CANTAVIEJA",
					"406": "CAÑADA DE BENATANDUZ",
					"407": "CAÑADA VELLIDA",
					"408": "CAÑIZAR DEL OLIVAR",
					"409": "CASCANTE DEL RIO",
					"410": "CASTEJON DE TORNOS",
					"411": "CASTELNOU",
					"412": "CASTELSERAS",
					"413": "CASTELLAR (EL)",
					"414": "CEDRILLAS",
					"415": "CELADAS",
					"416": "CEROLLERA (LA)",
					"417": "CORBALAN",
					"418": "CORTES DE ARAGON",
					"419": "COSA",
					"420": "CRIVILLEN",
					"421": "CUBLA",
					"422": "CUCALON",
					"423": "CUEVAS DE ALMUDEN",
					"424": "CUEVAS LABRADAS",
					"425": "EJULVE",
					"426": "ESCUCHA",
					"427": "ESTERCUEL",
					"428": "FONFRIA",
					"429": "FORMICHE ALTO",
					"430": "FORNOLES",
					"431": "FORTANETE",
					"432": "FRESNEDA (LA)",
					"433": "FRIAS DE ALBARRACIN",
					"434": "FUENTES CALIENTES",
					"435": "FUENTES CLARAS",
					"436": "FUENTES DE RUBIELOS",
					"437": "GALVE",
					"438": "GARGALLO",
					"439": "GINEBROSA (LA)",
					"440": "GRIEGOS",
					"441": "GUADALAVIAR",
					"442": "HIJAR",
					"443": "HINOJOSA DE JARQUE",
					"444": "HUESA DEL COMUN",
					"1126": "ARENS DE LLEDO",
					"1127": "ARIÑO",
					"1128": "BADENAS",
					"1129": "BAGUENA",
					"1130": "BARRACHINA",
					"1131": "BECEITE",
					"1132": "BELLO",
					"1133": "BERGE",
					"1134": "BEZAS",
					"1135": "BLANCAS",
					"1780": "ABEJUELA",
					"1781": "AGUAVIVA",
					"1782": "AGUILAR DEL ALFAMBRA",
					"1783": "ALBA",
					"1784": "ALBALATE DEL ARZOBISPO",
					"1785": "ALBENTOSA",
					"1786": "ALCAINE",
					"1787": "ALCAÑIZ",
					"1788": "ALCORISA",
					"1789": "ALFAMBRA",
					"1790": "ALMOHAJA",
					"1791": "ALOBRAS",
					"1792": "ALLEPUZ",
					"1793": "ALLUEVA",
					"1794": "ANADON",
					"1796": "ARCOS DE LAS SALINAS",
					"2682": "IGLESUELA DEL CID (LA)",
					"2683": "JABALOYAS",
					"2684": "JARQUE DE LA VAL",
					"2685": "JORCAS",
					"2686": "LAGUERUELA",
					"2687": "LIBROS",
					"2688": "LIDON",
					"2689": "LOSCOS",
					"2690": "LLEDO",
					"2691": "MAICAS",
					"2692": "MARTIN DEL RIO",
					"2693": "MAS DE LAS MATAS",
					"2694": "MAZALEON",
					"2695": "MEZQUITA DE JARQUE",
					"2696": "MIRAMBEL",
					"2697": "MIRAVETE DE LA SIERRA",
					"2698": "MONFORTE DE MOYUELA",
					"2699": "MONREAL DEL CAMPO",
					"2700": "MONTALBAN",
					"2701": "MONTEAGUDO DEL CASTILLO",
					"2702": "MORA DE RUBIELOS",
					"2703": "MOSCARDON",
					"2704": "MOSQUERUELA",
					"2705": "MUNIESA",
					"2706": "NOGUERAS",
					"2707": "NOGUERUELAS",
					"2708": "OBON",
					"2709": "ODON",
					"2710": "OLBA",
					"2711": "OLIETE",
					"2712": "ORIHUELA DEL TREMEDAL",
					"2713": "ORRIOS",
					"2714": "PANCRUDO",
					"2715": "PARRAS DE CASTELLOTE (LAS)",
					"2716": "PEÑARROYA DE TASTAVINS",
					"2717": "PERACENSE",
					"2718": "PERALES DEL ALFAMBRA",
					"2719": "PITARQUE",
					"2720": "POBO (EL)",
					"2721": "POZONDON",
					"2722": "POZUEL DEL CAMPO",
					"2723": "PUEBLA DE HIJAR (LA)",
					"2724": "PUERTOMINGALVO",
					"2725": "RAFALES",
					"2726": "RILLO",
					"2727": "RIODEVA",
					"2728": "ROYUELA",
					"2729": "RUBIALES",
					"2730": "RUBIELOS DE MORA",
					"2731": "SALCEDILLO",
					"2732": "SALDON",
					"2733": "SAMPER DE CALANDA",
					"2734": "SAN MARTIN DEL RIO",
					"2735": "SANTA CRUZ DE NOGUERAS",
					"2736": "SARRION",
					"2737": "SEGURA DE LOS BAÑOS",
					"2738": "SENO",
					"2739": "TERRIENTE",
					"2740": "TERUEL",
					"2741": "TORIL Y MASEGOSO",
					"2742": "TORMON",
					"2743": "TORNOS",
					"2744": "TORRALBA DE LOS SISONES",
					"2745": "TORRECILLA DE ALCAÑIZ",
					"2746": "TORRECILLA DEL REBOLLAR",
					"2747": "TORRE DE ARCAS",
					"2748": "TORRE DE LAS ARCAS",
					"2749": "TORRE DEL COMPTE",
					"2750": "TORRELACARCEL",
					"2751": "TORRE LOS NEGROS",
					"2752": "TORREMOCHA DE JILOCA",
					"2753": "TORRES DE ALBARRACIN",
					"2754": "TORREVELILLA",
					"2755": "TORRIJAS",
					"2756": "TORRIJO DEL CAMPO",
					"2757": "TRAMACASTIEL",
					"2758": "TRAMACASTILLA",
					"2759": "TRONCHON",
					"2760": "URREA DE GAEN",
					"2761": "UTRILLAS",
					"2762": "VALACLOCHE",
					"2763": "VALBONA",
					"2764": "VALDEALGORFA",
					"2765": "VALDECUENCA",
					"2766": "VALDELINARES",
					"2767": "VALDELTORMO",
					"2768": "VALDERROBRES",
					"2769": "VALJUNQUERA",
					"2770": "VALLECILLO (EL)",
					"2771": "VEGUILLAS DE LA SIERRA",
					"2772": "VILLAFRANCA DEL CAMPO",
					"2773": "VILLAHERMOSA DEL CAMPO",
					"2774": "VILLANUEVA DEL REBOLLAR DE LA",
					"2775": "VILLAR DEL COBO",
					"2776": "VILLAR DEL SALZ",
					"2777": "VILLARLUENGO",
					"2778": "VILLARQUEMADO",
					"2779": "VILLARROYA DE LOS PINARES",
					"2780": "VILLASTAR",
					"2781": "VILLEL",
					"2782": "VINACEITE",
					"2783": "VISIEDO",
					"2784": "VIVEL DEL RIO MARTIN",
					"2785": "ZOMA (LA)",
					"2881": "BORDON",
					"6429": "BURBAGUENA",
					"6430": "CALAMOCHA",
					"6431": "CAMAÑAS",
					"6432": "CAMINREAL",
					"6433": "CAÑADA DE VERICH (LA)",
					"6434": "CASTEL DE CABRA",
					"6435": "CASTELLOTE",
					"6436": "CELLA",
					"6437": "CODOÑERA (LA)",
					"6438": "CRETAS",
					"6439": "CUBA (LA)",
					"6440": "CUERVO (EL)",
					"6441": "ESCORIHUELA",
					"6442": "FERRERUELA DE HUERVA",
					"6443": "FOZ-CALANDA",
					"6444": "FUENFERRADA",
					"6445": "FUENTESPALDA",
					"6446": "GEA DE ALBARRACIN",
					"6447": "GUDAR",
					"6448": "HOZ DE LA VIEJA (LA)",
					"6449": "JATIEL",
					"6450": "JOSA",
					"6451": "LANZUELA",
					"6452": "LINARES DE MORA",
					"6453": "MANZANERA",
					"6454": "MATA DE LOS OLMOS (LA)",
					"6455": "MOLINOS",
					"6456": "MONROYO",
					"6457": "MONTERDE DE ALBARRACIN",
					"6458": "NOGUERA DE ALBARRACIN",
					"6459": "OJOS NEGROS",
					"6460": "OLMOS (LOS)",
					"6461": "PALOMAR DE ARROYOS",
					"6462": "PERALEJOS",
					"6463": "PLOU",
					"6464": "PORTELLADA (LA)",
					"6465": "PUEBLA DE VALVERDE (LA)",
					"6466": "RODENAS",
					"6467": "RUBIELOS DE LA CERIDA",
					"6468": "SAN AGUSTIN",
					"6469": "SANTA EULALIA",
					"6470": "SINGRA",
					"7189": "ABABUJ",
					"7190": "AGUATON",
					"7191": "ALACON",
					"7192": "ALBARRACIN",
					"7193": "ALCALA DE LA SELVA",
					"7194": "ALIAGA",
					"7195": "ALPEÑES",
					"7196": "ALLOZA",
					"7197": "ANDORRA",
					"7198": "ARGENTE",
					"7199": "AZAILA",
					"7200": "BAÑON",
					"7201": "BEA",
					"7202": "BELMONTE DE SAN JOSE",
					"7203": "BLESA"
				}
			},
			"45": {
				"nameProvincia": "Toledo",
				"idProvincia": "45",
				"localidades": {
					"123": "NAVALCAN",
					"124": "NAVALMORALEJO",
					"125": "NAVALMORALES (LOS)",
					"126": "NAVALUCILLOS (LOS)",
					"127": "NAVAMORCUENDE",
					"128": "NOBLEJAS",
					"129": "NOEZ",
					"130": "NOMBELA",
					"131": "NOVES",
					"132": "NUMANCIA DE LA SAGRA",
					"133": "NUÑO GOMEZ",
					"134": "OCAÑA",
					"135": "OLIAS DEL REY",
					"136": "ONTIGOLA",
					"137": "ORGAZ",
					"138": "OROPESA",
					"139": "OTERO",
					"140": "PALOMEQUE",
					"141": "PANTOJA",
					"142": "PAREDES DE ESCALONA",
					"143": "PARRILLAS",
					"144": "PELAHUSTAN",
					"145": "PEPINO",
					"146": "POLAN",
					"147": "PORTILLO DE TOLEDO",
					"148": "PUEBLA DE ALMORADIEL (LA)",
					"149": "PUEBLA DE MONTALBAN (LA)",
					"150": "PUEBLANUEVA (LA)",
					"151": "PUENTE DEL ARZOBISPO (EL)",
					"152": "PUERTO DE SAN VICENTE",
					"153": "PULGAR",
					"154": "QUERO",
					"155": "QUINTANAR DE LA ORDEN",
					"156": "QUISMONDO",
					"157": "REAL DE SAN VICENTE (EL)",
					"158": "RECAS",
					"159": "RETAMOSO",
					"160": "RIELVES",
					"161": "ROBLEDO DEL MAZO",
					"162": "ROMERAL (EL)",
					"163": "SAN BARTOLOME DE LAS ABIERTAS",
					"164": "SAN MARTIN DE MONTALBAN",
					"165": "SAN MARTIN DE PUSA",
					"166": "SAN PABLO DE LOS MONTES",
					"167": "SAN ROMAN DE LOS MONTES",
					"168": "SANTA CRUZ DE LA ZARZA",
					"169": "SANTA CRUZ DEL RETAMAR",
					"170": "SANTA OLALLA",
					"171": "SEGURILLA",
					"172": "SESEÑA",
					"173": "SONSECA",
					"174": "SOTILLO DE LAS PALOMAS",
					"175": "TALAVERA DE LA REINA",
					"176": "TEMBLEQUE",
					"177": "TOLEDO",
					"178": "TORRALBA DE OROPESA",
					"179": "TORRECILLA DE LA JARA",
					"180": "TORRICO",
					"181": "TORRIJOS",
					"182": "TOTANES",
					"183": "TURLEQUE",
					"184": "UGENA",
					"185": "VALDEVERDEJA",
					"186": "VELADA",
					"187": "VENTAS CON PEÑA AGUILERA (LAS)",
					"188": "VENTAS DE SAN JULIAN (LAS)",
					"189": "VILLACAÑAS",
					"190": "VILLA DE DON FADRIQUE (LA)",
					"191": "VILLAFRANCA DE LOS CABALLEROS",
					"192": "VILLALUENGA DE LA SAGRA",
					"193": "VILLAMINAYA",
					"194": "VILLAMUELAS",
					"195": "VILLANUEVA DE ALCARDETE",
					"196": "VILLAREJO DE MONTALBAN",
					"197": "VILLARRUBIA DE SANTIAGO",
					"198": "VILLASECA DE LA SAGRA",
					"199": "VILLASEQUILLA",
					"200": "VISO DE SAN JUAN (EL)",
					"201": "YEBENES (LOS)",
					"202": "YEPES",
					"203": "YUNCLILLOS",
					"204": "YUNCOS",
					"374": "NAVAHERMOSA",
					"2786": "AJOFRIN",
					"2787": "ALAMEDA DE LA SAGRA",
					"2788": "ALBARREAL DE TAJO",
					"2789": "ALCABON",
					"2790": "ALCAÑIZO",
					"2791": "ALCAUDETE DE LA JARA",
					"2792": "ALCOLEA DE TAJO",
					"2793": "ALDEA EN CABO",
					"2794": "ALDEANUEVA DE BARBARROYA",
					"2795": "ALDEANUEVA DE SAN BARTOLOME",
					"2796": "ALMENDRAL DE LA CAÑADA",
					"2797": "ALMONACID DE TOLEDO",
					"2798": "ALMOROX",
					"2799": "AÑOVER DE TAJO",
					"2800": "ARCICOLLAR",
					"2801": "ARGES",
					"2802": "AZUTAN",
					"2803": "BARCIENCE",
					"2804": "BARGAS",
					"2805": "BELVIS DE LA JARA",
					"2806": "BOROX",
					"2807": "BUENAVENTURA",
					"2808": "BURGUILLOS DE TOLEDO",
					"2809": "BURUJON",
					"2810": "CABAÑAS DE LA SAGRA",
					"2811": "CABAÑAS DE YEPES",
					"2812": "CABEZAMESADA",
					"2813": "CALERA Y CHOZAS",
					"2814": "CALERUELA",
					"2815": "CALZADA DE OROPESA",
					"2816": "CAMARENA",
					"2817": "CAMARENILLA",
					"2818": "CAMPILLO DE LA JARA (EL)",
					"2819": "CAMUÑAS",
					"2820": "CARDIEL DE LOS MONTES",
					"2821": "CARMENA",
					"2822": "CARPIO DE TAJO (EL)",
					"2823": "CARRANQUE",
					"2824": "CARRICHES",
					"2825": "CASAR DE ESCALONA (EL)",
					"2826": "CASARRUBIOS DEL MONTE",
					"2827": "CASASBUENAS",
					"2828": "CASTILLO DE BAYUELA",
					"2829": "CAZALEGAS",
					"2830": "CEBOLLA",
					"2831": "CEDILLO DEL CONDADO",
					"2832": "CERRALBOS (LOS)",
					"2833": "CERVERA DE LOS MONTES",
					"2834": "CIRUELOS",
					"2835": "COBEJA",
					"2836": "COBISA",
					"2837": "CONSUEGRA",
					"2838": "CORRAL DE ALMAGUER",
					"2839": "CUERVA",
					"2840": "CHOZAS DE CANALES",
					"2841": "CHUECA",
					"2842": "DOMINGO PEREZ",
					"2843": "DOSBARRIOS",
					"2844": "ERUSTES",
					"2845": "ESCALONA",
					"2846": "ESCALONILLA",
					"2847": "ESPINOSO DEL REY",
					"2848": "ESQUIVIAS",
					"2849": "ESTRELLA (LA)",
					"2850": "FUENSALIDA",
					"2851": "GALVEZ",
					"2852": "GARCIOTUM",
					"2853": "GERINDOTE",
					"2854": "GUADAMUR",
					"2855": "GUARDIA (LA)",
					"2856": "HERENCIAS (LAS)",
					"2857": "HERRERUELA DE OROPESA",
					"2858": "HINOJOSA DE SAN VICENTE",
					"2859": "HONTANAR",
					"2860": "HORMIGOS",
					"2861": "HUECAS",
					"2862": "HUERTA DE VALDECARABANOS",
					"2863": "IGLESUELA (LA)",
					"2864": "ILLAN DE VACAS",
					"2865": "ILLESCAS",
					"2866": "LAGARTERA",
					"2867": "LAYOS",
					"2868": "LILLO",
					"2869": "LOMINCHAR",
					"2870": "LUCILLOS",
					"2871": "MADRIDEJOS",
					"2872": "MAGAN",
					"2873": "MALPICA DE TAJO",
					"2874": "MANZANEQUE",
					"2875": "MAQUEDA",
					"2876": "MARJALIZA",
					"2877": "MARRUPE",
					"2878": "MATA (LA)",
					"2879": "MAZARAMBROZ",
					"2880": "MENASALBAS",
					"2882": "MESEGAR DE TAJO",
					"2883": "MIGUEL ESTEBAN",
					"2884": "MOHEDAS DE LA JARA",
					"2885": "MONTEARAGON",
					"2886": "MORA",
					"2887": "NAMBROCA",
					"6392": "SANTA ANA DE PUSA",
					"6393": "SARTAJADA",
					"6394": "SEVILLEJA DE LA JARA",
					"6395": "TOBOSO (EL)",
					"6396": "TORRE DE ESTEBAN HAMBRAN (LA)",
					"6397": "URDA",
					"6398": "VALMOJADO",
					"6399": "VENTAS DE RETAMOSA (LAS)",
					"6400": "VILLAMIEL DE TOLEDO",
					"6401": "VILLANUEVA DE BOGAS",
					"6402": "VILLATOBAS",
					"6403": "YELES",
					"6404": "YUNCLER",
					"6405": "SANTO DOMINGO-CAUDILLA",
					"6471": "MASCARAQUE",
					"6472": "MEJORADA",
					"6473": "MENTRIDA",
					"6474": "MOCEJON",
					"6475": "MONTESCLAROS",
					"6476": "NAVA DE RICOMALILLO (LA)"
				}
			},
			"46": {
				"nameProvincia": "Valencia / València",
				"idProvincia": "46",
				"localidades": {
					"115": "RIBA-ROJA DE TURIA",
					"205": "ADEMUZ",
					"206": "ADOR",
					"208": "ATZENETA D'ALBAIDA",
					"209": "AGULLENT",
					"210": "ALBAIDA",
					"211": "ALBAL",
					"212": "ALBALAT DELS SORELLS",
					"213": "ALBALAT DELS TARONGERS",
					"214": "ALBERIC",
					"215": "ALBORACHE",
					"216": "ALBUIXECH",
					"217": "ALCASSER",
					"218": "ALZIRA",
					"219": "ALCUBLAS",
					"220": "ALCUDIA (L')",
					"221": "ALDAIA",
					"222": "ALFAFAR",
					"223": "ALFAUIR",
					"224": "ALFARA DE ALGIMIA",
					"225": "ALFARA DEL PATRIARCA",
					"226": "ALFARRASI",
					"227": "ALGEMESI",
					"228": "ALGIMIA DE ALFARA",
					"229": "ALGINET",
					"230": "ALMASSERA",
					"231": "ALMOINES",
					"232": "ALPUENTE",
					"233": "ALQUERIA DE LA CONDESA/ALQUERI",
					"234": "ANDILLA",
					"235": "ANTELLA",
					"236": "AIELO DE MALFERIT",
					"237": "AIELO DE RUGAT",
					"238": "AYORA",
					"239": "BARX",
					"240": "BELGIDA",
					"241": "BELLUS",
					"242": "BENAGEBER",
					"243": "BENAVITES",
					"244": "BENEIXIDA",
					"245": "BENIARJO",
					"246": "BENIATJAR",
					"247": "BENIFAIRO DE LES VALLS",
					"248": "BENIFAIRO DE LA VALLDIGNA",
					"249": "BENIFLA",
					"250": "BENIGANIM",
					"251": "BENIMUSLEM",
					"252": "BENIPARRELL",
					"253": "BENISANO",
					"254": "BENISSODA",
					"255": "BETERA",
					"256": "BICORP",
					"257": "BOLBAITE",
					"258": "BONREPOS I MIRAMBELL",
					"259": "BUFALI",
					"260": "BUGARRA",
					"261": "BUÑOL",
					"262": "BURJASSOT",
					"263": "CALLES",
					"264": "CAMPORROBLES",
					"265": "CANALS",
					"266": "CANET D'EN BERENGUER",
					"267": "CARCAIXENT",
					"268": "CARCER",
					"269": "CARLET",
					"270": "CARRICOLA",
					"271": "CASAS ALTAS",
					"272": "CASAS BAJAS",
					"273": "CASINOS",
					"274": "CASTELLO DE RUGAT",
					"275": "CASTELLONET DE LA CONQUESTA",
					"276": "CASTIELFABIB",
					"277": "CATADAU",
					"278": "CATARROJA",
					"279": "CAUDETE DE LAS FUENTES",
					"280": "CERDA",
					"281": "COFRENTES",
					"282": "CORBERA",
					"283": "CORTES DE PALLAS",
					"284": "COTES",
					"285": "QUART DE LES VALLS",
					"286": "QUART DE POBLET",
					"287": "QUARTELL",
					"288": "QUATRETONDA",
					"289": "CULLERA",
					"290": "CHELVA",
					"291": "CHELLA",
					"292": "CHERA",
					"293": "CHESTE",
					"294": "XIRIVELLA",
					"295": "CHIVA",
					"296": "CHULILLA",
					"297": "DAIMUS",
					"298": "DOMEÑO",
					"299": "DOS AGUAS",
					"300": "ELIANA (L')",
					"301": "EMPERADOR",
					"302": "ENGUERA",
					"303": "ÈNOVA (L')",
					"304": "ESTIVELLA",
					"305": "ESTUBENY",
					"306": "FAURA",
					"307": "FAVARA",
					"308": "FONTANARS DELS ALFORINS",
					"309": "FORTALENY",
					"310": "FOIOS",
					"311": "FONT D'EN CARROS (LA)",
					"312": "FONT DE LA FIGUERA (LA)",
					"313": "FUENTERROBLES",
					"314": "GAVARDA",
					"315": "GANDIA",
					"316": "GENOVES",
					"317": "GESTALGAR",
					"318": "GILET",
					"319": "GODELLA",
					"320": "GODELLETA",
					"321": "GRANJA DE LA COSTERA (LA)",
					"322": "GUADASEQUIES",
					"323": "GUADASSUAR",
					"324": "GUARDAMAR DE LA SAFOR",
					"325": "HIGUERUELAS",
					"326": "JALANCE",
					"327": "XERACO",
					"328": "JARAFUEL",
					"329": "XATIVA",
					"330": "XERESA",
					"331": "LLIRIA",
					"332": "LORIGUILLA",
					"333": "LOSA DEL OBISPO",
					"334": "LLUTXENT",
					"335": "LLOCNOU D'EN FENOLLET",
					"336": "LUGAR NUEVO DE LA CORONA",
					"337": "LLOCNOU DE SANT JERONI",
					"338": "LLANERA DE RANES",
					"339": "LLAURI",
					"340": "LLOMBAI",
					"341": "LLOSA DE RANES (LA)",
					"342": "MACASTRE",
					"343": "MANISES",
					"344": "MANUEL",
					"345": "MARINES",
					"346": "MASALAVES",
					"347": "MASSALFASSAR",
					"348": "MASSAMAGRELL",
					"349": "MASSANASSA",
					"350": "MELIANA",
					"351": "MILLARES",
					"352": "MIRAMAR",
					"353": "MISLATA",
					"354": "MOGENTE/MOIXENT",
					"355": "MONCADA",
					"356": "MONSERRAT",
					"357": "MONTAVERNER",
					"358": "MONTESA",
					"359": "MONTICHELVO",
					"360": "MONTROY",
					"361": "MUSEROS",
					"362": "NAQUERA",
					"363": "NAVARRES",
					"364": "NOVELE/NOVETLE",
					"365": "OLIVA",
					"366": "OLOCAU",
					"367": "OLLERIA (L')",
					"368": "ONTINYENT",
					"369": "OTOS",
					"370": "PAIPORTA",
					"371": "PALMA DE GANDIA",
					"372": "PALMERA",
					"373": "PALOMAR (EL)",
					"375": "PATERNA",
					"376": "PEDRALBA",
					"377": "PETRES",
					"378": "PICANYA",
					"379": "PICASSENT",
					"380": "PILES",
					"381": "PINET",
					"382": "POLINYA DE XUQUER",
					"383": "POTRIES",
					"384": "POBLA DE FARNALS (LA)",
					"385": "POBLA DEL DUC (LA)",
					"386": "PUEBLA DE SAN MIGUEL",
					"387": "POBLA DE VALLBONA (LA)",
					"388": "POBLA LLARGA (LA)",
					"389": "PUIG",
					"390": "PUÇOL",
					"391": "QUESA",
					"392": "RAFELCOFER",
					"393": "RAFELGUARAF",
					"394": "RAFOL DE SALEM",
					"395": "REAL DE GANDIA",
					"396": "REQUENA",
					"767": "RIOLA",
					"768": "ROCAFORT",
					"769": "ROTGLA I CORBERA",
					"770": "ROTOVA",
					"771": "RUGAT",
					"772": "SAGUNTO/SAGUNT",
					"773": "SALEM",
					"774": "SAN JUAN DE ENOVA",
					"775": "SEDAVI",
					"776": "SEGART",
					"777": "SELLENT",
					"778": "SEMPERE",
					"779": "SENYERA",
					"780": "SERRA",
					"781": "SIETE AGUAS",
					"782": "SILLA",
					"783": "SIMAT DE LA VALLDIGNA",
					"784": "SINARCAS",
					"785": "SOLLANA",
					"786": "SOT DE CHERA",
					"787": "SUECA",
					"788": "SUMACARCER",
					"789": "TAVERNES BLANQUES",
					"790": "TAVERNES DE LA VALLDIGNA",
					"791": "TERESA DE COFRENTES",
					"792": "TERRATEIG",
					"793": "TITAGUAS",
					"794": "TORREBAJA",
					"795": "TORRELLA",
					"796": "TORRENT",
					"797": "TORRES TORRES",
					"798": "TOUS",
					"799": "TUEJAR",
					"800": "TURIS",
					"801": "UTIEL",
					"802": "VALENCIA",
					"803": "VALLADA",
					"804": "VALLANCA",
					"805": "VALLES",
					"806": "VENTA DEL MORO",
					"807": "VILLALONGA",
					"808": "VILAMARXANT",
					"809": "VILLANUEVA DE CASTELLON",
					"810": "VILLAR DEL ARZOBISPO",
					"811": "VILLARGORDO DEL CABRIEL",
					"812": "VINALESA",
					"813": "YATOVA",
					"814": "YESA (LA)",
					"815": "ZARRA",
					"816": "GATOVA",
					"817": "SAN ANTONIO DE BENAGEBER",
					"6406": "ALAQUAS",
					"6407": "ALBALAT DE LA RIBERA",
					"6408": "ALBORAYA",
					"6409": "ALCANTERA DE XUQUER",
					"6410": "ALCUDIA DE CRESPINS (L')",
					"6411": "ALFARP",
					"6412": "ALGAR DE PALANCIA",
					"6413": "ALMISERA",
					"6414": "ALMUSSAFES",
					"6415": "ANNA",
					"6416": "ARAS DE LOS OLMOS",
					"6417": "BARXETA",
					"6418": "BELLREGUARD",
					"6419": "BENAGUASIL",
					"6420": "BENETUSSER",
					"6421": "BENICOLET",
					"6422": "BENIFAIO",
					"6423": "BENIMODO",
					"6424": "BENIRREDRA",
					"6425": "BENISUERA",
					"6426": "BOCAIRENT",
					"6427": "RAFELBUÑOL/RAFELBUNYOL",
					"6428": "REAL DE MONTROI"
				}
			},
			"47": {
				"nameProvincia": "Valladolid",
				"idProvincia": "47",
				"localidades": {
					"2": "MUCIENTES",
					"3": "MUDARRA (LA)",
					"4": "MURIEL",
					"5": "NUEVA VILLA DE LAS TORRES",
					"6": "OLIVARES DE DUERO",
					"7": "OLMEDO",
					"8": "OLMOS DE PEÑAFIEL",
					"9": "PALAZUELO DE VEDIJA",
					"10": "PARRILLA (LA)",
					"11": "PEDRAJAS DE SAN ESTEBAN",
					"12": "PEDROSA DEL REY",
					"13": "PEÑAFIEL",
					"14": "PEÑAFLOR DE HORNIJA",
					"15": "PIÑA DE ESGUEVA",
					"16": "PIÑEL DE ABAJO",
					"17": "PIÑEL DE ARRIBA",
					"18": "POLLOS",
					"19": "POZAL DE GALLINAS",
					"20": "POZUELO DE LA ORDEN",
					"21": "PURAS",
					"22": "QUINTANILLA DEL MOLAR",
					"23": "QUINTANILLA DE ONESIMO",
					"24": "QUINTANILLA DE TRIGUEROS",
					"25": "RABANO",
					"26": "RENEDO DE ESGUEVA",
					"27": "ROALES DE CAMPOS",
					"28": "ROTURAS",
					"29": "RUBI DE BRACAMONTE",
					"30": "SAELICES DE MAYORGA",
					"31": "SALVADOR DE ZAPARDIEL",
					"32": "SAN CEBRIAN DE MAZOTE",
					"33": "SAN LLORENTE",
					"34": "SAN MARTIN DE VALVENI",
					"35": "SAN MIGUEL DEL ARROYO",
					"36": "SAN MIGUEL DEL PINO",
					"37": "SAN PABLO DE LA MORALEJA",
					"38": "SAN PEDRO DE LATARCE",
					"39": "SAN PELAYO",
					"40": "SAN ROMAN DE HORNIJA",
					"41": "SAN SALVADOR",
					"42": "SANTA EUFEMIA DEL ARROYO",
					"43": "SANTERVAS DE CAMPOS",
					"44": "SANTIBAÑEZ DE VALCORBA",
					"45": "SANTOVENIA DE PISUERGA",
					"46": "SAN VICENTE DEL PALACIO",
					"47": "SARDON DE DUERO",
					"48": "SECA (LA)",
					"49": "SERRADA",
					"50": "SIETE IGLESIAS DE TRABANCOS",
					"51": "SIMANCAS",
					"52": "TAMARIZ DE CAMPOS",
					"53": "TIEDRA",
					"54": "TORDEHUMOS",
					"55": "TORDESILLAS",
					"56": "TORRECILLA DE LA ABADESA",
					"57": "TORRECILLA DE LA ORDEN",
					"58": "TORRECILLA DE LA TORRE",
					"59": "TORRE DE ESGUEVA",
					"60": "TORRE DE PEÑAFIEL",
					"61": "TORRELOBATON",
					"62": "TORRESCARCELA",
					"63": "TRASPINEDO",
					"64": "TRIGUEROS DEL VALLE",
					"65": "TUDELA DE DUERO",
					"66": "UNION DE CAMPOS (LA)",
					"67": "URONES DE CASTROPONCE",
					"68": "URUEÑA",
					"69": "VALBUENA DE DUERO",
					"70": "VALDEARCOS DE LA VEGA",
					"71": "VALDENEBRO DE LOS VALLES",
					"72": "VALDESTILLAS",
					"73": "VALDUNQUILLO",
					"74": "VALORIA LA BUENA",
					"75": "VALVERDE DE CAMPOS",
					"76": "VALLADOLID",
					"77": "VEGA DE RUIPONCE",
					"78": "VEGA DE VALDETRONCO",
					"79": "VELASCALVARO",
					"80": "VELILLA",
					"81": "VELLIZA",
					"82": "VENTOSA DE LA CUESTA",
					"83": "VIANA DE CEGA",
					"84": "VILORIA",
					"85": "VILLABAÑEZ",
					"86": "VILLABARUZ DE CAMPOS",
					"87": "VILLABRAGIMA",
					"88": "VILLACARRALON",
					"89": "VILLACID DE CAMPOS",
					"90": "VILLACO",
					"91": "VILLAFRADES DE CAMPOS",
					"92": "VILLAFRANCA DE DUERO",
					"93": "VILLAFRECHOS",
					"94": "VILLAFUERTE",
					"95": "VILLAGARCIA DE CAMPOS",
					"96": "VILLAGOMEZ LA NUEVA",
					"97": "VILLALAN DE CAMPOS",
					"98": "VILLALAR DE LOS COMUNEROS",
					"99": "VILLALBA DE LA LOMA",
					"100": "VILLALBA DE LOS ALCORES",
					"101": "VILLALBARBA",
					"102": "VILLALON DE CAMPOS",
					"103": "VILLAMURIEL DE CAMPOS",
					"104": "VILLAN DE TORDESILLAS",
					"105": "VILLANUBLA",
					"106": "VILLANUEVA DE DUERO",
					"107": "VILLANUEVA DE LA CONDESA",
					"108": "VILLANUEVA DE LOS CABALLEROS",
					"109": "VILLANUEVA DE LOS INFANTES",
					"110": "VILLANUEVA DE SAN MANCIO",
					"111": "VILLARDEFRADES",
					"112": "VILLARMENTERO DE ESGUEVA",
					"113": "VILLASEXMIR",
					"114": "VILLAVAQUERIN",
					"116": "VILLAVELLID",
					"117": "VILLAVERDE DE MEDINA",
					"118": "VILLAVICENCIO DE LOS CABALLERO",
					"119": "WAMBA",
					"120": "ZARATAN",
					"121": "ZARZA (LA)",
					"818": "ADALIA",
					"819": "AGUASAL",
					"820": "AGUILAR DE CAMPOS",
					"821": "ALAEJOS",
					"822": "ALCAZAREN",
					"823": "ALDEA DE SAN MIGUEL",
					"824": "ALDEAMAYOR DE SAN MARTIN",
					"825": "ALMENARA DE ADAJA",
					"826": "AMUSQUILLO",
					"827": "ARROYO DE LA ENCOMIENDA",
					"828": "ATAQUINES",
					"829": "BAHABON",
					"830": "BARCIAL DE LA LOMA",
					"831": "BARRUELO DEL VALLE",
					"832": "BECILLA DE VALDERADUEY",
					"833": "BENAFARCES",
					"834": "BERCERUELO",
					"835": "BERRUECES",
					"836": "BOCIGAS",
					"837": "BOCOS DE DUERO",
					"838": "BOECILLO",
					"839": "BRAHOJOS DE MEDINA",
					"840": "BUSTILLO DE CHAVES",
					"841": "CABEZON DE PISUERGA",
					"842": "CABEZON DE VALDERADUEY",
					"843": "CAMPASPERO",
					"844": "CAMPILLO (EL)",
					"845": "CAMPORREDONDO",
					"846": "CANILLAS DE ESGUEVA",
					"847": "CARPIO",
					"848": "CASASOLA DE ARION",
					"849": "CASTREJON DE TRABANCOS",
					"850": "CASTRILLO-TEJERIEGO",
					"851": "CASTROBOL",
					"852": "CASTRODEZA",
					"853": "CASTROMEMBIBRE",
					"854": "CASTRONUEVO DE ESGUEVA",
					"855": "CASTRONUÑO",
					"856": "CASTROVERDE DE CERRATO",
					"857": "CEINOS DE CAMPOS",
					"858": "CIGALES",
					"859": "CIGUÑUELA",
					"860": "CISTERNIGA",
					"861": "COGECES DE ISCAR",
					"862": "CORCOS",
					"863": "CORRALES DE DUERO",
					"864": "CUBILLAS DE SANTA MARTA",
					"865": "CUENCA DE CAMPOS",
					"866": "ENCINAS DE ESGUEVA",
					"867": "ESGUEVILLAS DE ESGUEVA",
					"868": "FOMBELLIDA",
					"869": "FONTIHOYUELO",
					"870": "FRESNO EL VIEJO",
					"871": "FUENTE EL SOL",
					"872": "FUENTE-OLMEDO",
					"873": "GATON DE CAMPOS",
					"874": "GERIA",
					"875": "HERRIN DE CAMPOS",
					"876": "HORNILLOS DE ERESMA",
					"877": "LAGUNA DE DUERO",
					"878": "LOMOVIEJO",
					"879": "LLANO DE OLMEDO",
					"880": "MARZALES",
					"881": "MATAPOZUELOS",
					"882": "MAYORGA",
					"883": "MEDINA DEL CAMPO",
					"884": "MEDINA DE RIOSECO",
					"885": "MEGECES",
					"886": "MELGAR DE ARRIBA",
					"887": "MOJADOS",
					"888": "MONASTERIO DE VEGA",
					"889": "MONTEMAYOR DE PILILLA",
					"890": "MORAL DE LA REINA",
					"891": "MORALEJA DE LAS PANADERAS",
					"1125": "MORALES DE CAMPOS",
					"6361": "BERCERO",
					"6362": "BOBADILLA DEL CAMPO",
					"6363": "BOLAÑOS DE CAMPOS",
					"6364": "CABREROS DEL MONTE",
					"6365": "CANALEJAS DE PEÑAFIEL",
					"6366": "CASTRILLO DE DUERO",
					"6367": "CASTROMONTE",
					"6368": "CASTROPONCE",
					"6369": "CERVILLEGO DE LA CRUZ",
					"6370": "COGECES DEL MONTE",
					"6371": "CURIEL DE DUERO",
					"6372": "FOMPEDRAZA",
					"6373": "FUENSALDAÑA",
					"6374": "GALLEGOS DE HORNIJA",
					"6375": "ISCAR",
					"6376": "LANGAYO",
					"6377": "MANZANILLO",
					"6378": "MATILLA DE LOS CAÑOS",
					"6379": "MELGAR DE ABAJO",
					"6380": "MONTEALEGRE DE CAMPOS",
					"6381": "MOTA DEL MARQUES",
					"6382": "NAVA DEL REY",
					"6383": "OLMOS DE ESGUEVA",
					"6384": "PEDRAJA DE PORTILLO (LA)",
					"6385": "PESQUERA DE DUERO",
					"6386": "PORTILLO",
					"6387": "POZALDEZ",
					"6388": "QUINTANILLA DE ARRIBA",
					"6389": "RAMIRO",
					"6390": "ROBLADILLO",
					"6391": "RUEDA"
				}
			},
			"48": {
				"nameProvincia": "Vizcaya / Bizkaia",
				"idProvincia": "48",
				"localidades": {
					"122": "ABADIÑO",
					"514": "AMOREBIETA-ETXANO",
					"515": "AMOROTO",
					"516": "ARAKALDO",
					"517": "ARANTZAZU",
					"518": "MUNITIBAR-ARBATZEGI GERRIKAITZ",
					"519": "ARTZENTALES",
					"520": "ARRANKUDIAGA",
					"521": "ARRIETA",
					"522": "ARRIGORRIAGA",
					"523": "BAKIO",
					"524": "BARAKALDO",
					"525": "BARRIKA",
					"526": "BASAURI",
					"527": "BERANGO",
					"528": "BERMEO",
					"529": "BERRIATUA",
					"530": "BERRIZ",
					"531": "BILBAO",
					"532": "BUSTURIA",
					"533": "KARRANTZA HARANA/VALLE DE CARR",
					"534": "ARTEA",
					"535": "ZEANURI",
					"536": "ZEBERIO",
					"537": "DIMA",
					"538": "DURANGO",
					"539": "EA",
					"540": "ETXEBARRI",
					"541": "ETXEBARRIA",
					"542": "ELANTXOBE",
					"543": "ELORRIO",
					"544": "EREÑO",
					"545": "ERMUA",
					"546": "FRUIZ",
					"547": "GALDAKAO",
					"548": "GALDAMES",
					"549": "GAMIZ-FIKA",
					"550": "GARAY",
					"551": "GATIKA",
					"552": "GAUTEGIZ ARTEAGA",
					"553": "GORDEXOLA",
					"554": "GORLIZ",
					"555": "GETXO",
					"556": "GÜEÑES",
					"557": "GERNIKA-LUMO",
					"558": "GIZABURUAGA",
					"559": "IBARRANGELU",
					"560": "ISPASTER",
					"561": "IZURTZA",
					"562": "LANESTOSA",
					"563": "LARRABETZU",
					"564": "LAUKIZ",
					"565": "LEIOA",
					"566": "LEMOA",
					"567": "LEMOIZ",
					"568": "LEKEITIO",
					"569": "MALLABIA",
					"570": "MAÑARIA",
					"571": "MARKINA-XEMEIN",
					"572": "MARURI-JATABE",
					"573": "MENDATA",
					"574": "MENDEXA",
					"575": "MEÑAKA",
					"576": "UGAO-MIRABALLES",
					"577": "MORGA",
					"578": "MUXIKA",
					"579": "MUNDAKA",
					"580": "MUNGIA",
					"581": "AULESTI",
					"582": "MUSKIZ",
					"583": "OTXANDIO",
					"584": "ONDARROA",
					"585": "URDUÑA-ORDUÑA",
					"586": "OROZKO",
					"587": "SUKARRIETA",
					"588": "PLENTZIA",
					"589": "PORTUGALETE",
					"590": "ERRIGOITI",
					"591": "VALLE DE TRAPAGA-TRAPAGARAN",
					"592": "SANTURTZI",
					"593": "ORTUELLA",
					"594": "SOPELANA",
					"595": "TRUCIOS-TURTZIOZ",
					"596": "UBIDE",
					"597": "BALMASEDA",
					"598": "ATXONDO",
					"599": "AREATZA",
					"600": "ZALDIBAR",
					"601": "ZARATAMO",
					"602": "DERIO",
					"603": "LOIU",
					"604": "ZAMUDIO",
					"605": "FORUA",
					"606": "MURUETA",
					"607": "NABARNIZ",
					"608": "AJANGIZ",
					"609": "ALONSOTEGI",
					"610": "ARRATZU",
					"745": "ABANTO Y CIERVANA-ABANTO ZIERB",
					"6316": "LEZAMA",
					"6317": "SESTAO",
					"6318": "SOPUERTA",
					"6319": "URDULIZ",
					"6320": "BEDIA",
					"6321": "IGORRE",
					"6322": "ZALLA",
					"6323": "ERANDIO",
					"6324": "SONDIKA",
					"6325": "KORTEZUBI",
					"6326": "IURRETA",
					"6327": "ZIERBENA"
				}
			},
			"49": {
				"nameProvincia": "Zamora",
				"idProvincia": "49",
				"localidades": {
					"487": "SANTIBAÑEZ DE VIDRIALES",
					"611": "ABEZAMES",
					"612": "ALCUBILLA DE NOGALES",
					"613": "ALFARAZ DE SAYAGO",
					"614": "ALMARAZ DE DUERO",
					"615": "ANDAVIAS",
					"616": "ARCENILLAS",
					"617": "ARCOS DE LA POLVOROSA",
					"618": "ARGAÑIN",
					"619": "ARQUILLINOS",
					"620": "ARRABALDE",
					"621": "ASTURIANOS",
					"622": "AYOO DE VIDRIALES",
					"623": "BELVER DE LOS MONTES",
					"624": "BENAVENTE",
					"625": "BENEGILES",
					"626": "BOVEDA DE TORO (LA)",
					"627": "BRETO",
					"628": "BRETOCINO",
					"629": "BRIME DE SOG",
					"630": "BURGANES DE VALVERDE",
					"631": "BUSTILLO DEL ORO",
					"632": "CALZADILLA DE TERA",
					"633": "CAMARZANA DE TERA",
					"634": "CAÑIZAL",
					"635": "CARBAJALES DE ALBA",
					"636": "CARBELLINO",
					"637": "CASASECA DE LAS CHANAS",
					"638": "CASTRILLO DE LA GUAREÑA",
					"639": "CASTROGONZALO",
					"640": "CASTRONUEVO",
					"641": "CAZURRA",
					"642": "CERECINOS DE CAMPOS",
					"643": "CERECINOS DEL CARRIZAL",
					"644": "CERNADILLA",
					"645": "COOMONTE",
					"646": "CORRALES",
					"647": "COTANES DEL MONTE",
					"648": "CUBO DE BENAVENTE",
					"649": "CUBO DE TIERRA DEL VINO (EL)",
					"650": "ENTRALA",
					"651": "ESPADAÑEDO",
					"652": "FARIZA",
					"653": "FERMOSELLE",
					"654": "FERRERAS DE ABAJO",
					"655": "FERRERAS DE ARRIBA",
					"656": "FIGUERUELA DE ARRIBA",
					"657": "FONFRIA",
					"658": "FRESNO DE LA POLVOROSA",
					"659": "FRESNO DE SAYAGO",
					"660": "FRIERA DE VALVERDE",
					"661": "FUENTE ENCALADA",
					"662": "FUENTESAUCO",
					"663": "FUENTES DE ROPEL",
					"664": "FUENTESECAS",
					"665": "GALENDE",
					"666": "GALLEGOS DEL PAN",
					"667": "GALLEGOS DEL RIO",
					"668": "GEMA",
					"669": "GRANUCILLO",
					"670": "GUARRATE",
					"671": "HERMISENDE",
					"672": "HINIESTA (LA)",
					"673": "JUSTEL",
					"674": "LOSACINO",
					"675": "LUBIAN",
					"676": "MADERAL (EL)",
					"677": "MADRIDANOS",
					"678": "MAIRE DE CASTROPONCE",
					"679": "MANGANESES DE LA LAMPREANA",
					"681": "MANGANESES DE LA POLVOROSA",
					"682": "MANZANAL DEL BARCO",
					"683": "MANZANAL DE LOS INFANTES",
					"684": "MATILLA DE ARZON",
					"685": "MAYALDE",
					"686": "MELGAR DE TERA",
					"687": "MICERECES DE TERA",
					"688": "MOLACILLOS",
					"689": "MOLEZUELAS DE LA CARBALLEDA",
					"690": "MOMBUEY",
					"691": "MONFARRACINOS",
					"692": "MORAL DE SAYAGO",
					"693": "MORALEJA DEL VINO",
					"694": "MORALEJA DE SAYAGO",
					"695": "MORALES DE REY",
					"696": "MORALES DE TORO",
					"697": "MORALES DE VALVERDE",
					"698": "MORALINA",
					"699": "MORERUELA DE LOS INFANZONES",
					"700": "MORERUELA DE TABARA",
					"701": "MUELAS DE LOS CABALLEROS",
					"702": "MUELAS DEL PAN",
					"703": "MUGA DE SAYAGO",
					"704": "NAVIANOS DE VALVERDE",
					"705": "OLMILLOS DE CASTRO",
					"706": "OTERO DE BODAS",
					"707": "PAJARES DE LA LAMPREANA",
					"708": "PALACIOS DEL PAN",
					"709": "PALACIOS DE SANABRIA",
					"710": "PEDRALBA DE LA PRADERIA",
					"711": "PEGO (EL)",
					"712": "PELEAGONZALO",
					"713": "PELEAS DE ABAJO",
					"714": "PEÑAUSENDE",
					"715": "PEQUE",
					"716": "PERDIGON (EL)",
					"717": "PERERUELA",
					"718": "PERILLA DE CASTRO",
					"719": "PIAS",
					"720": "PIEDRAHITA DE CASTRO",
					"721": "PINILLA DE TORO",
					"722": "PINO",
					"723": "PIÑERO (EL)",
					"724": "POBLADURA DEL VALLE",
					"725": "POBLADURA DE VALDERADUEY",
					"726": "PORTO",
					"727": "POZOANTIGUO",
					"728": "POZUELO DE TABARA",
					"729": "PRADO",
					"730": "PUEBLA DE SANABRIA",
					"731": "PUEBLICA DE VALVERDE",
					"732": "QUINTANILLA DEL MONTE",
					"733": "QUINTANILLA DEL OLMO",
					"734": "QUINTANILLA DE URZ",
					"735": "QUIRUELAS DE VIDRIALES",
					"736": "RABANALES",
					"737": "RABANO DE ALISTE",
					"738": "REQUEJO",
					"739": "REVELLINOS",
					"740": "RIOFRIO DE ALISTE",
					"741": "RIONEGRO DEL PUENTE",
					"742": "ROALES",
					"743": "ROBLEDA-CERVANTES",
					"744": "ROELOS DE SAYAGO",
					"746": "ROSINOS DE LA REQUEJADA",
					"747": "SALCE",
					"748": "SAMIR DE LOS CAÑOS",
					"749": "SAN AGUSTIN DEL POZO",
					"750": "SAN CEBRIAN DE CASTRO",
					"751": "SAN CRISTOBAL DE ENTREVIÑAS",
					"752": "SAN ESTEBAN DEL MOLAR",
					"753": "SAN JUSTO",
					"754": "SAN MARTIN DE VALDERADUEY",
					"755": "SAN MIGUEL DE LA RIBERA",
					"756": "SAN MIGUEL DEL VALLE",
					"757": "SAN PEDRO DE CEQUE",
					"758": "SAN PEDRO DE LA NAVE-ALMENDRA",
					"759": "SANTA CLARA DE AVEDILLO",
					"760": "SANTA COLOMBA DE LAS MONJAS",
					"761": "SANTA CRISTINA DE LA POLVOROSA",
					"762": "SANTA CROYA DE TERA",
					"763": "SANTA EUFEMIA DEL BARCO",
					"764": "SANTA MARIA DE LA VEGA",
					"765": "SANTA MARIA DE VALVERDE",
					"766": "SANTIBAÑEZ DE TERA",
					"925": "SANTOVENIA",
					"926": "SAN VICENTE DE LA CABEZA",
					"927": "SAN VITERO",
					"928": "SANZOLES",
					"929": "TABARA",
					"930": "TAPIOLES",
					"931": "TORO",
					"932": "TORRE DEL VALLE (LA)",
					"933": "TORREGAMONES",
					"934": "TORRES DEL CARRIZAL",
					"935": "TRABAZOS",
					"936": "TREFACIO",
					"937": "UÑA DE QUINTANA",
					"938": "VADILLO DE LA GUAREÑA",
					"939": "VALCABADO",
					"940": "VALDEFINJAS",
					"941": "VALDESCORRIEL",
					"942": "VALLESA DE LA GUAREÑA",
					"943": "VEGA DE TERA",
					"944": "VEGA DE VILLALOBOS",
					"945": "VEGALATRAVE",
					"946": "VENIALBO",
					"947": "VEZDEMARBAN",
					"948": "VIDAYANES",
					"949": "VIDEMALA",
					"950": "VILLABRAZARO",
					"951": "VILLABUENA DEL PUENTE",
					"952": "VILLADEPERA",
					"953": "VILLAESCUSA",
					"954": "VILLAFAFILA",
					"955": "VILLAFERRUEÑA",
					"956": "VILLAGERIZ",
					"957": "VILLALAZAN",
					"958": "VILLALBA DE LA LAMPREANA",
					"959": "VILLALCAMPO",
					"960": "VILLALOBOS",
					"961": "VILLALONSO",
					"962": "VILLALPANDO",
					"963": "VILLALUBE",
					"964": "VILLAMAYOR DE CAMPOS",
					"965": "VILLAMOR DE LOS ESCUDEROS",
					"966": "VILLANAZAR",
					"967": "VILLANUEVA DE AZOAGUE",
					"968": "VILLANUEVA DE CAMPEAN",
					"969": "VILLANUEVA DE LAS PERAS",
					"970": "VILLANUEVA DEL CAMPO",
					"971": "VILLARALBO",
					"972": "VILLARDECIERVOS",
					"973": "VILLAR DE FALLAVES",
					"974": "VILLAR DEL BUEY",
					"975": "VILLARDIEGUA DE LA RIBERA",
					"976": "VILLARDIGA",
					"977": "VILLARDONDIEGO",
					"978": "VILLARRIN DE CAMPOS",
					"979": "VILLASECO DEL PAN",
					"980": "VILLAVENDIMIO",
					"981": "VILLAVEZA DEL AGUA",
					"982": "VILLAVEZA DE VALVERDE",
					"983": "VIÑAS",
					"984": "ZAMORA",
					"6328": "ALCAÑICES",
					"6329": "ALGODRE",
					"6330": "ALMEIDA DE SAYAGO",
					"6331": "ARGUJILLO",
					"6332": "ASPARIEGOS",
					"6333": "BARCIAL DEL BARCO",
					"6334": "BERMILLO DE SAYAGO",
					"6335": "BRIME DE URZ",
					"6336": "CABAÑAS DE SAYAGO",
					"6337": "CAÑIZO",
					"6338": "CASASECA DE CAMPEAN",
					"6339": "CASTROVERDE DE CAMPOS",
					"6340": "COBREROS",
					"6341": "CORESES",
					"6342": "CUBILLOS",
					"6343": "CUELGAMURES",
					"6344": "FARAMONTANOS DE TABARA",
					"6345": "FERRERUELA",
					"6346": "FRESNO DE LA RIBERA",
					"6347": "FUENTELAPEÑA",
					"6348": "FUENTESPREADAS",
					"6349": "GAMONES",
					"6350": "GRANJA DE MORERUELA",
					"6351": "JAMBRINA",
					"6352": "LOSACIO",
					"6353": "LUELMO",
					"6354": "MAHIDE",
					"6355": "MALVA",
					"6356": "MANZANAL DE ARRIBA",
					"6357": "MATILLA LA SECA",
					"6358": "MILLES DE LA POLVOROSA",
					"6359": "MONTAMARTA",
					"6360": "MORALES DEL VINO"
				}
			},
			"50": {
				"nameProvincia": "Zaragoza",
				"idProvincia": "50",
				"localidades": {
					"1": "USED",
					"445": "ORES",
					"446": "OSEJA",
					"447": "PANIZA",
					"448": "PARACUELLOS DE JILOCA",
					"449": "PASTRIZ",
					"450": "PEDROLA",
					"451": "PEDROSAS (LAS)",
					"452": "PERDIGUERA",
					"453": "PIEDRATAJADA",
					"454": "PINA DE EBRO",
					"455": "PINSEQUE",
					"456": "PINTANOS (LOS)",
					"457": "PLASENCIA DE JALON",
					"458": "PLEITAS",
					"459": "PLENAS",
					"460": "POMER",
					"461": "POZUEL DE ARIZA",
					"462": "POZUELO DE ARAGON",
					"463": "PRADILLA DE EBRO",
					"464": "PUEBLA DE ALBORTON",
					"465": "PUEBLA DE ALFINDEN (LA)",
					"466": "PUENDELUNA",
					"467": "PURUJOSA",
					"468": "QUINTO",
					"469": "REMOLINOS",
					"470": "RETASCON",
					"471": "RICLA",
					"472": "ROMANOS",
					"473": "RUEDA DE JALON",
					"474": "RUESCA",
					"475": "SADABA",
					"476": "SALILLAS DE JALON",
					"477": "SALVATIERRA DE ESCA",
					"478": "SAMPER DEL SALZ",
					"479": "SAN MARTIN DE LA VIRGEN DE MON",
					"480": "SAN MATEO DE GALLEGO",
					"481": "SANTA CRUZ DE GRIO",
					"482": "SANTA CRUZ DE MONCAYO",
					"483": "SANTA EULALIA DE GALLEGO",
					"484": "SANTED",
					"485": "SASTAGO",
					"486": "SABIÑAN",
					"488": "SEDILES",
					"489": "SESTRICA",
					"490": "SIERRA DE LUNA",
					"491": "SIGÜES",
					"492": "SISAMON",
					"493": "SOBRADIEL",
					"494": "SOS DEL REY CATOLICO",
					"495": "TABUENCA",
					"496": "TALAMANTES",
					"497": "TARAZONA",
					"498": "TAUSTE",
					"499": "TERRER",
					"500": "TIERGA",
					"501": "TOBED",
					"502": "TORRALBA DE LOS FRAILES",
					"503": "TORRALBA DE RIBOTA",
					"504": "TORRALBILLA",
					"505": "TORREHERMOSA",
					"506": "TORRELAPAJA",
					"507": "TORRELLAS",
					"508": "TORRES DE BERRELLEN",
					"509": "TORRIJO DE LA CAÑADA",
					"510": "TOSOS",
					"511": "TRASMOZ",
					"512": "TRASOBARES",
					"513": "UNCASTILLO",
					"680": "URRIES",
					"892": "URREA DE JALON",
					"893": "UTEBO",
					"894": "VALDEHORNA",
					"895": "VAL DE SAN MARTIN",
					"896": "VALMADRID",
					"897": "VALPALMAS",
					"898": "VALTORRES",
					"899": "VELILLA DE EBRO",
					"900": "VELILLA DE JILOCA",
					"901": "VERA DE MONCAYO",
					"902": "VIERLAS",
					"903": "VILUEÑA (LA)",
					"904": "VILLADOZ",
					"905": "VILLAFELICHE",
					"906": "VILLAFRANCA DE EBRO",
					"907": "VILLALBA DE PEREJIL",
					"908": "VILLALENGUA",
					"909": "VILLANUEVA DE GALLEGO",
					"910": "VILLANUEVA DE JILOCA",
					"911": "VILLANUEVA DE HUERVA",
					"912": "VILLAR DE LOS NAVARROS",
					"913": "VILLARREAL DE HUERVA",
					"914": "VILLARROYA DE LA SIERRA",
					"915": "VILLARROYA DEL CAMPO",
					"916": "VISTABELLA",
					"917": "ZAIDA (LA)",
					"918": "ZARAGOZA",
					"919": "ZUERA",
					"920": "BIEL",
					"921": "MARRACOS",
					"924": "UNDUES DE LERDA",
					"985": "ABANTO",
					"986": "ACERED",
					"987": "AGON",
					"988": "AGUARON",
					"989": "AGUILON",
					"990": "AINZON",
					"991": "ALADREN",
					"992": "ALAGON",
					"993": "ALARBA",
					"994": "ALBERITE DE SAN JUAN",
					"995": "ALBETA",
					"996": "ALBORGE",
					"997": "ALCALA DE EBRO",
					"998": "ALCALA DE MONCAYO",
					"999": "ALCONCHEL DE ARIZA",
					"1000": "ALDEHUELA DE LIESTOS",
					"1001": "ALFAJARIN",
					"1002": "ALFAMEN",
					"1003": "ALFORQUE",
					"1004": "ALHAMA DE ARAGON",
					"1005": "ALMOCHUEL",
					"1006": "ALMOLDA (LA)",
					"1007": "ALMONACID DE LA CUBA",
					"1008": "ALMONACID DE LA SIERRA",
					"1009": "ALMUNIA DE DOÑA GODINA (LA)",
					"1010": "ALPARTIR",
					"1011": "AMBEL",
					"1012": "ANENTO",
					"1013": "ANIÑON",
					"1014": "AÑON DE MONCAYO",
					"1015": "ARANDA DE MONCAYO",
					"1016": "ARANDIGA",
					"1017": "ARDISA",
					"1018": "ARIZA",
					"1019": "ARTIEDA",
					"1020": "ASIN",
					"1021": "ATEA",
					"1022": "ATECA",
					"1023": "AZUARA",
					"1024": "BADULES",
					"1025": "BALCONCHAN",
					"1026": "BARBOLES",
					"1027": "BELCHITE",
					"1028": "BELMONTE DE GRACIAN",
					"1029": "BERRUECO",
					"1030": "BIJUESCA",
					"1031": "BISIMBRE",
					"1032": "BORDALBA",
					"1033": "BORJA",
					"1034": "BREA DE ARAGON",
					"1035": "BUBIERCA",
					"1036": "BULBUENTE",
					"1037": "BURETA",
					"1038": "BUSTE (EL)",
					"1039": "CABAÑAS DE EBRO",
					"1040": "CABOLAFUENTE",
					"1041": "CALATAYUD",
					"1042": "CALATORAO",
					"1043": "CALMARZA",
					"1044": "CAMPILLO DE ARAGON",
					"1045": "CARIÑENA",
					"1046": "CASTEJON DE ALARBA",
					"1047": "CASTEJON DE LAS ARMAS",
					"1048": "CASTILISCAR",
					"1049": "CERVERA DE LA CAÑADA",
					"1050": "CERVERUELA",
					"1051": "CETINA",
					"1052": "CINCO OLIVAS",
					"1053": "CLARES DE RIBOTA",
					"1054": "CODOS",
					"1055": "COSUENDA",
					"1056": "CUARTE DE HUERVA",
					"1057": "CUERLAS (LAS)",
					"1058": "CHODES",
					"1059": "DAROCA",
					"1060": "EMBID DE ARIZA",
					"1061": "ENCINACORBA",
					"1062": "EPILA",
					"1063": "ERLA",
					"1064": "FABARA",
					"1065": "FARLETE",
					"1066": "FAYOS (LOS)",
					"1067": "FOMBUENA",
					"1068": "FRAGO (EL)",
					"1069": "FRASNO (EL)",
					"1070": "FUENDEJALON",
					"1071": "FUENTES DE EBRO",
					"1072": "FUENTES DE JILOCA",
					"1073": "GALLOCANTA",
					"1074": "GELSA",
					"1075": "GOTOR",
					"1076": "GRISEL",
					"1077": "HERRERA DE LOS NAVARROS",
					"1078": "ILLUECA",
					"1079": "ISUERRE",
					"1080": "JARQUE",
					"1081": "JOYOSA (LA)",
					"1082": "LAGATA",
					"1083": "LAYANA",
					"1084": "LECERA",
					"1085": "LECIÑENA",
					"1086": "LETUX",
					"1087": "LITAGO",
					"1088": "LOBERA DE ONSELLA",
					"1089": "LONGARES",
					"1090": "LUCENA DE JALON",
					"1091": "LUESIA",
					"1092": "LUESMA",
					"1093": "LUNA",
					"1094": "MAELLA",
					"1095": "MAINAR",
					"1096": "MALANQUILLA",
					"1097": "MALON",
					"1098": "MALLEN",
					"1099": "MANCHONES",
					"1100": "MARIA DE HUERVA",
					"1101": "MEQUINENZA",
					"1102": "MESONES DE ISUELA",
					"1103": "MEZALOCHA",
					"1104": "MIANOS",
					"1105": "MONEGRILLO",
					"1106": "MONEVA",
					"1107": "MONREAL DE ARIZA",
					"1108": "MONTON",
					"1109": "MORATA DE JALON",
					"1110": "MORES",
					"1111": "MOROS",
					"1112": "MOYUELA",
					"1113": "MUEL",
					"1114": "MUNEBREGA",
					"1115": "MURERO",
					"1116": "NAVARDUN",
					"1117": "NIGÜELLA",
					"1118": "NOMBREVILLA",
					"1119": "NONASPE",
					"1120": "NOVILLAS",
					"1121": "NUEVALOS",
					"1122": "OLVES",
					"1123": "ORCAJO",
					"6278": "CODO",
					"6279": "CONTAMINA",
					"6280": "CUBEL",
					"6281": "CHIPRANA",
					"6282": "EJEA DE LOS CABALLEROS",
					"6283": "ESCATRON",
					"6284": "FAYON",
					"6285": "FIGUERUELAS",
					"6286": "FRESCANO",
					"6287": "FUENDETODOS",
					"6288": "GALLUR",
					"6289": "GODOJOS",
					"6290": "GRISEN",
					"6291": "IBDES",
					"6292": "JARABA",
					"6293": "JAULIN",
					"6294": "LANGA DEL CASTILLO",
					"6295": "LECHON",
					"6296": "LITUENIGO",
					"6297": "LONGAS",
					"6298": "LUCENI",
					"6299": "LUMPIAQUE",
					"6300": "MAGALLON",
					"6301": "MALEJAN",
					"6302": "MALUENDA",
					"6303": "MARA",
					"6304": "MEDIANA DE ARAGON",
					"6305": "MIEDES DE ARAGON",
					"6306": "MONTERDE",
					"6307": "MORATA DE JILOCA",
					"6308": "MOZOTA",
					"6309": "MUELA (LA)",
					"6310": "MURILLO DE GALLEGO",
					"6311": "NOVALLAS",
					"6312": "NUEZ DE EBRO",
					"6313": "ORERA",
					"6314": "OSERA DE EBRO",
					"6315": "PARACUELLOS DE LA RIBERA",
					"6738": "CASTEJON DE VALDEJASA",
					"7166": "BAGÜES",
					"7167": "BARDALLUR",
					"7168": "BERDEJO",
					"7169": "BIOTA",
					"7170": "BOQUIÑENI",
					"7171": "BOTORRITA",
					"7172": "BUJARALOZ",
					"7173": "BURGO DE EBRO (EL)",
					"7174": "CADRETE",
					"7175": "CALCENA",
					"7176": "CARENAS",
					"7177": "CASPE",
					"7870": "CIMBALLA"
				}
			},
			"51": {
				"nameProvincia": "Ceuta",
				"idProvincia": "51",
				"localidades": {
					"922": "CEUTA"
				}
			},
			"52": {
				"nameProvincia": "Melilla",
				"idProvincia": "52",
				"localidades": {
					"923": "MELILLA"
				}
			},
			"53": {
				"nameProvincia": "Desconocido",
				"idProvincia": "53",
				"localidades": {

				}
			}
		}
	},
	getters: {
		getDominio: state => {
			return (value) => {
				return state.dominios[value];
			}
		},
		getProvinciasComplet: state => {
			if (!!state.provinciasComplet) {
				return state.provinciasComplet;
			}
		},
		getDominios: state => state.dominios,
		getInteresesCV: state => state.interesesCV,
		getProgramas: state => state.programas,
		getPaises: state => {
			if (!!state.dominios.paises) {
				let paises = Object.entries(state.dominios.paises);
				return paises.sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});
			}
		},
		getDominiosOrder: state => {
			let dominios = new Object();

			if (!!state.dominios) {
				Object.entries(state.dominios).forEach(d => {
					if (!!d[1]) {
						dominios[d[0]] = Object.entries(d[1]).sort(function (p1, p2) {
							return (p1[1] < p2[1]) ? -1 : 1;
						});
					}
				});
			}

			return dominios;

		},
		getProvincias: state => {
			if (!!state.dominios.provincias) {
				let provincias = Object.entries(state.dominios.provincias);
				return provincias.sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});
			}
		},
		getAreasFuncionales: state => {
			if (!!state.dominios.areasFuncionales) {

				let areasFuncionales = Object.entries(state.dominios.areasFuncionales);

				let otrosString = ['otras', 'otros'];

				//COPIA DE OTROS
				let otros = areasFuncionales.filter(e => { return (otrosString.some(s => s.toLowerCase() == e[1].toLowerCase())) })[0];

				//SACO EL CAMPO "OTROS";
				areasFuncionales = areasFuncionales.filter(e => { return !(otrosString.some(s => s.toLowerCase() == e[1].toLowerCase())) });


				areasFuncionales = areasFuncionales.sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});

				if (!!otros) {
					areasFuncionales.push(otros);
				}

				return areasFuncionales;

			}
		},
		getSectoresActividad: state => {
			if (!!state.dominios.sectoresActividad) {
				let sectoresActividad = Object.entries(state.dominios.sectoresActividad);
				return sectoresActividad.sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});
			}
		},
		getConvocatoriasEmpleo: state => {
			if (!!state.dominios.convocatoriasEmpleo) {
				let convocatoriasEmpleo = Object.entries(state.dominios.convocatoriasEmpleo);
				return convocatoriasEmpleo.sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});
			}
		},
		getTiposContrato: state => {
			if (!!state.dominios.tiposContrato) {
				let tiposContrato = Object.entries(state.dominios.tiposContrato);
				return tiposContrato.sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});
			}
		},
		getTiposContratoOfertasPracticas: state => state.dominios.tiposContratoOfertaPracticas,

		getTiposDocumentoAlumnoPracticas: state => {
			if (!!state.dominios.tiposDocumentoAlumnoPracticas) {
				let tiposDocumentoAlumnoPracticas = Object.entries(state.dominios.tiposDocumentoAlumnoPracticas);
				return tiposDocumentoAlumnoPracticas.sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});
			}
		},
		getEstadosCandidaturaAlumno: state => {
			if (!!state.dominios.estadosCandidaturasAlumno) {
				let tiposestadosCandidaturasAlumno = Object.entries(state.dominios.estadosCandidaturasAlumno);
				return tiposestadosCandidaturasAlumno.sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});
			}
		},
		getTitulacionesEmpresa: state => {
			if (!!state.titulacionesEmpresa) {
				return state.titulacionesEmpresa;
			}
		},
		getmotivosRechazo: state => {
			if (!!state.motivosRechazo) {
				return state.motivosRechazo;
			}
		},
		getLocalidades: state => {

			return (idProvincia) => {

				let localidades;

				if (!!state.dominios.localidades) {
					localidades = state.dominios.localidades.filter(l => l.idProvincia == idProvincia);
					localidades = localidades.sort(function (p1, p2) {
						return (p1.descripcion < p2.descripcion) ? -1 : 1;
					});
				}



				return localidades

			}
		},
		getAmbitos: state => {

			let ambitos;

			if (!!state.dominios.ambitos) {
				ambitos = Object.values(state.dominios.ambitos).sort(function (p1, p2) {
					return (p1.ambitoEstudo < p2.ambitoEstudo) ? -1 : 1;
				});
			}
			return ambitos

		},
		getEspecialidades: state => {

			let especialidades = new Array();

			if (!!state.dominios && !!state.dominios.ambitos) {
				Object.values(state.dominios.ambitos).forEach(e => {
					Object.entries(e.especialidadesAmbitoEstudio).forEach(especialidad => {
						especialidades.push(especialidad);
					});
				})
			}

			especialidades.sort(function (p1, p2) {
				return (p1[1].normalize("NFD").replace(/[\u0300-\u036f]/g, "") < p2[1].normalize("NFD").replace(/[\u0300-\u036f]/g, "")) ? -1 : 1;
			});

			return especialidades;
		},
		getAniosForo: state => state.aniosForo,
		getTipoContactoEmpresa: state => {

			let tipos;


			if (!!state.dominios.tiposContacoEmpresa) {
				tipos = Object.entries(state.dominios.tiposContacoEmpresa).sort(function (p1, p2) {
					return (p1[1] < p2[1]) ? -1 : 1;
				});
			}

			return tipos;

		},
		getIsla(state) {
			return (id) => {
				let isla;
				if (state.dominios && state.dominios.islas.length != 0) {
					isla = state.dominios.islas.filter(isla => isla.idIsla == id)[0];
				}
				return isla;
			};
		},

	},
	actions: {
		requestDominios: ({ commit, getters, dispatch }) => {

			axios.get(`/api/Dominios/dominios/${getters.getLanguage}`).then(response => {
				(response.data.status == 0) ? commit('setDominios', response.data.datos) : '';
				dispatch('requestDominiosList');
			})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
		},
		requestDominiosList: ({ commit, getters, dispatch }) => {

			let list = [
				'localidades',
				'tiposVia',
				'titulaciones',
				'ProgramasInformaticos',
				'competenciasfesionales',
				'tipoEstanciasExtranjero',
				'nivelesProgramasInformaticos',
				'tiposContacoEmpresa',
				'tipoMotivoCambioEstadoCandidatura',
				'tiposFormacionAcademica',
				'tiposDocumentoIdentidad',
				'tiposContratoExperiencias',
				'tiposNivelesTitulacion',
				'subtiposContratoExperiencias',
				'actividadesrofesionales',
				'ambitosEstudio',
				'ragosFacturacion',
				'numeroDeEmpleados',
				'tipoOpcionPublicacionOferta',
				'TagsInteresAlumno',
				'rangosDeCreditos',
				'tiposNivelFormativoSNE',

			];


			if (getters.getBrand.dominios) {
				list = getters.getBrand.dominios;
			}

			axios.get(`/api/Dominios/dominiosList/${getters.getLanguage}`).then(response => {

				if (response.data.datos.length != 0) {
					if (response.data.status == 0) {
						list.forEach(el => {
							let data = [el, response.data.datos[el]];
							(response.data.status == 0) ? commit('setDominiosList', data) : '';
						});
					} else {
						'';
					}
				}
			}).catch(function (error) { });

		},
		requestIntereses: function ({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get(`api/Dominios/TagsInteresAlumno`).then(response => {
					(response.data.status == 0) ? commit('setInteresesCV', response.data.datos) : '';
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});

		},
		requestProgramas: function ({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get(`api/Dominios/ProgramasInformaticos`).then(response => {
					(response.data.status == 0) ? commit('setProgramas', response.data.datos) : '';
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestTitulacionesEmpresa: function ({ getters, commit, dispatch }) {


			return new Promise((resolve, reject) => {
				axios.get(`api/Dominios/titulaciones/${getters.getLanguage}`).then(response => {
					if (response.data.status == 0) {
						commit('setTitulaciones', response.data.datos);
						resolve(true);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestMotivosRechazo: function ({ getters, commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get(`api/Dominios/tipoMotivoCambioEstadoCandidatura/${getters.getLanguage}`).then(response => {
					if (response.data.status == 0) {
						commit('setMotivoRechazoPracticas', response.data.datos);
						resolve(true);
					}
				})
					.catch(function (error) { });
			});
		},
		createAniosForo({ commit }) {
			let init = 2010;
			let years = [];
			let finish = new Date().getFullYear();

			while (init <= finish) {
				years.push(init);
				init++;
			}

			commit('setAniosForo', years);

		},
		requestEmpresasPorProvincia: ({ commit, getters, dispatch }, idProvincia) => {
			return new Promise((resolve, reject) => {
				axios.get(`/api/Dominios/centrosEducativosDeProvincia/${idProvincia}`).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos)
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
	},
	mutations: {
		setDominio: function (state, data) {
			state.dominios[data[0]] = data[1];
		},
		setDominiosList: function (state, data) {
			if (Object.values(data[1]).length != 0) {
				state.dominios[data[0]] = data[1];
			}
		},
		setDominios: function (state, data) {
			state.dominios = data;
		},
		setInteresesCV: function (state, data) {
			state.interesesCV = data;
		},
		setProgramas: function (state, data) {
			state.programas = Object.values(data);
		},
		setTitulaciones: function (state, data) {
			state.titulacionesEmpresa = Object.values(data);
		},
		setMotivoRechazoPracticas: function (state, data) {
			state.motivosRechazo = data.sort((a, b) => a.descripcion > b.descripcion ? 1 : -1);
		},
		setAmbitosEstudio: function (state, data) {
			state.ambitos.ambitosEstudio = data;
		},
		setEspecialidadesAmbitoEstudio: function (state, data) {
			state.ambitos.especialidadesAmbitoEstudio[data[0]] = data[1];
		},
		setAniosForo(state, years) {
			state.aniosForo = years;
		}
	}
}

export default dominios;



// WEBPACK FOOTER //
// ./src/store/dominios.js